import * as styles from '../ui/slots-lobby/global-poker/GlobalPokerSlotsLobby.css'

export type TableGameIds = 'blackjackClassic' | 'blackjackPremium' | 'casinoHoldem' | 'caribbeanPoker' | 'blackjack-classic' | 'blackjack-premium' | 'caribbean-stud';

export type CasinoGameInfo = SlotGameInfo | FullWidthInHouseSlotGameInfo | TableGameInfo | GapGameInfo;

export interface BaseCasinoGameInfo {
	gameId: string,
	displayName: string;
	tagLine?: string;
	standardImageUrl: string;
	featureImageUrl: string;
	infoModal: string[];
	hasJackpot?: boolean;
	useGapJackpot?: boolean;
	jackpotName?: string;
	jackpotToDisplay?: string;
	filteredGameType?: string;
	providerGameId?: string;
	replacesGameId?: string;
}

export type SlotGameInfo = BaseCasinoGameInfo & {
	hasJackpot?: boolean;
	gameId: string;
	gameType: 'slot';
	slotUrlDirectory: string;
};

export type FullWidthInHouseSlotGameInfo = SlotGameInfo & {
	useFullWidth: true;
};

export type TableGameInfo = BaseCasinoGameInfo & {
	variant?: string;
	gameId: TableGameIds,
	url: string,
	gameType: 'tablegame';
};

export type GapGameInfo = BaseCasinoGameInfo & {
	gameId: string;
	gameType: 'gap';
	gameProviderId: string;
	overlayClockDesktop: boolean,
	overlayClockMobile: boolean,
	hasInsufficientCoinDialogAvailableInGame: boolean
	onlyUpdateBalanceOnGameRoundCompleted: boolean
	moveCloseButtonLeftOnDesktop: boolean
	moveCloseButtonLeftOnMobile: boolean
	overlayClockPositionOnDesktop?: 'bottom-left' | 'bottom-right' | 'top-left'
	overlayClockPositionOnMobile?: 'bottom-left' | 'bottom-right' | 'top-left'
	showMuteButtonOverlay?: boolean
	moveMuteButtonLeftOnDesktop?: boolean
	moveMuteButtonLeftOnMobile?: boolean
	stackButtonsOnMobile?: boolean
};

const SUPER_DAZZLING_7S: SlotGameInfo = {
	displayName: `Super Dazzling 7's`,
	gameId: 'superDazzling7s',
	gameType: 'slot',
	standardImageUrl: styles.superDazzlingSevensStandard,
	featureImageUrl: styles.superDazzlingSevensFeature,
	tagLine: '3 REEL 5 LINE',
	slotUrlDirectory: 'super-dazzling-7s',
	infoModal: [
		'3 Reels',
		'All the classic features of a 3-reel slots game. 5 paylines, Wild substitutes for all symbols except Scatters',
		'Free Spins Feature - 3 Scatter symbols anywhere on the reels retriggers 10 additional free spins!',
		'Wild Reel 2 Feature - triggered when a Wild appears on reel 2. The whole reel 2 becomes Wild and both the other reels respin 3 times!',
	],
}

const HYPERNOVA: SlotGameInfo = {
	displayName: `Hypernova`,
	gameId: 'hypernova',
	gameType: 'slot',
	standardImageUrl: styles.hypernovaStandard,
	featureImageUrl: styles.hypernovaFeature,
	tagLine: '10,000 WAYS',
	slotUrlDirectory: 'hypernova_v2',
	infoModal: [
		'6 Reels plus additional top reel',
		'10,000 ways to win',
		'Jackpot Respins',
		'Land 6 or more scatters to hit the Jackpot respin feature',
		'Land a jackpot symbol to multiply total coins played by 10, 50, 250 or 2000x',
	],
}

const WESTERN_GOLD: SlotGameInfo = {
	displayName: 'Western Gold',
	gameId: 'westernGold',
	gameType: 'slot',
	standardImageUrl: styles.westernGoldStandard,
	featureImageUrl: styles.westernGoldFeature,
	tagLine: 'PROGRESSIVE JACKPOT',
	slotUrlDirectory: 'western-gold',
	infoModal: [
		'5 Reels',
		'Progressive Jackpot',
		'Journey to the time of the Gold Rush',
		'Fortune Reel above the reels - rotates prizes every spin - win the reel prize when you land a full stack of sheriff badges',
		'Free spins Feature',
		'The chance to win many features on a single spin!',
	],
	hasJackpot: true,
	jackpotName: 'westernGold',
	jackpotToDisplay: 'grand',
}

const LUCKY_SHOW: SlotGameInfo = {
	displayName: 'Lucky Show',
	gameId: 'luckyShow',
	gameType: 'slot',
	standardImageUrl: styles.luckyShowStandard,
	featureImageUrl: styles.luckyShowFeature,
	tagLine: '3 REEL 9 LINE',
	slotUrlDirectory: 'lucky-show',
	infoModal: [
		'3 Reels',
		'Spinning Wheel Feature',
		'Big Jackpots',
		'Virtual game show like no other!',
		'Multiple Wilds that multiply anywhere between 2x and 8x your win amount',
		'Land 3 Scatters (wheels) and enter into the Wheel Bonus!',
	],
}

const CRUSADERS_GOLD: SlotGameInfo = {
	displayName: 'Crusader\'s Gold',
	gameId: 'crusadersGold',
	gameType: 'slot',
	standardImageUrl: styles.crusadersGoldStandard,
	featureImageUrl: styles.crusadersGoldFeature,
	tagLine: '4096 WAYS',
	slotUrlDirectory: 'crusaders-gold',
	infoModal: [
		'6 Reels',
		'Fun, classic theme of knights and dragons',
		'3 Scatters awards 12 free spins',
		'Collect dragons, fill the meter and change other symbols to dragon symbols',
		'Feature can be retriggered',
	],
}

const TRIPLE_DOUBLE_GOLDEN_STARS: SlotGameInfo = {
	displayName: 'Triple Double Golden Stars',
	gameId: 'tripleDoubleGoldenStars',
	gameType: 'slot',
	standardImageUrl: styles.tripleDoubleGoldenStarsStandard,
	featureImageUrl: styles.tripleDoubleGoldenStarsFeature,
	tagLine: '3 REEL 5 LINE',
	slotUrlDirectory: 'triple-double-golden-stars',
	infoModal: [
		'3 Reels',
		'2x and 3x wilds that maximize line wins',
		'Old-school thrill of the Free Spins Feature, with its greater frequency of multiplied wilds!',
		'Land 3 of a kind Triple Gold Star Wilds for the maximum prize!',
	],
}

const BIG_GOREELA: SlotGameInfo = {
	displayName: 'Big Goreela',
	gameId: 'bigGoreela',
	gameType: 'slot',
	standardImageUrl: styles.bigGoreelaStandard,
	featureImageUrl: styles.bigGoreelaFeature,
	tagLine: 'PROGRESSIVE JACKPOT',
	hasJackpot: true,
	jackpotName: 'bigGoreela',
	jackpotToDisplay: 'grand',
	slotUrlDirectory: 'the-big-goreela',
	infoModal: [
		'5 reels',
		'Progressive Jackpot',
		'The Grand Jackpot seeds start at GC300,000,000 and SC30,000 and can be won at any play level while in the feature game',
		'Hitting the scatter jewels on reels 1 and 5 only awards you free games in the feature!',
		'Center 3 reels turn into MEGA symbols during free games',
		'576 ways to win',
		'Free Spins Feature',
	],
}

const SANTAS_RICHES: SlotGameInfo = {
	displayName: 'Santa\'s Riches',
	gameId: 'santasRiches',
	gameType: 'slot',
	standardImageUrl: styles.santasRichesStandard,
	featureImageUrl: styles.santasRichesFeature,
	tagLine: '3X5 REEL 25 LINE',
	slotUrlDirectory: 'santas-riches',
	infoModal: [
		'5 Reels',
		'Loveable festive Christmas theme',
		'3 Santa symbols on reels 2, 3 and 4 triggers 7 feature free spins',
		'During the Free Spins Feature, when Jolly Old Saint Nicholas appears on the reel, that entire reel becomes wild!',
		'More santas appear during the free spins, and the free spins feature can be triggered again during the free spins!',
	],
}

const LIGHTNING_NUDGE: SlotGameInfo = {
	displayName: 'Lightning Nudge',
	gameId: 'lightningNudge',
	gameType: 'slot',
	standardImageUrl: styles.lightningNudgeStandard,
	featureImageUrl: styles.lightningNudgeFeature,
	tagLine: '3 REEL 5 LINE',
	slotUrlDirectory: 'lightning-nudge',
	infoModal: [
		'3 Reels',
		'Free Spins & Win Multipliers',
		'BIG Prize - 5x Multiplier',
		'Wild has the power to substitute for all missing basic symbols to help you complete a winning combo',
	],
}

const BLACKJACK_PREMIUM: TableGameInfo = {
	displayName: 'Blackjack Premium',
	gameId: 'blackjackPremium',
	url: 'blackjack',
	variant: 'premium',
	gameType: 'tablegame',
	standardImageUrl: styles.bjPremiumStandard,
	featureImageUrl: styles.bjPremiumFeature,
	tagLine: 'TABLE GAME',
	infoModal: [
		'slots.dialogs.table-games.blackjack-premium.description-1',
		'slots.dialogs.table-games.blackjack-premium.description-2',
	],
	filteredGameType: 'table'
}

const BLACKJACK_PREMIUM_GAP: GapGameInfo = {
	displayName: 'Blackjack Premium',
	gameType: 'gap',
	standardImageUrl: styles.bjPremiumStandard,
	featureImageUrl: styles.bjPremiumFeature,
	gameProviderId: 'gas',
	gameId: 'blackjack-premium',
	tagLine: 'TABLE GAME',
	filteredGameType: 'table',
	infoModal: [
		'Premium blackjack is a relatively new blackjack variant adapted from a European version of the game.',
		'Blackjack is already considered to be one of the best games to play at the casino; the premium version takes Blackjack one step further and increases the odds for players to come away with a win.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	overlayClockPositionOnDesktop: 'bottom-right',
	overlayClockPositionOnMobile: 'bottom-right'
}

const BLACKJACK_CLASSIC: TableGameInfo = {
	displayName: 'Blackjack Classic',
	gameId: 'blackjackClassic',
	url: 'blackjack',
	variant: 'classic',
	gameType: 'tablegame',
	standardImageUrl: styles.placeholderTile,
	featureImageUrl: styles.placeholderTile,
	tagLine: 'TABLE GAME',
	infoModal: [
		'slots.dialogs.table-games.blackjack-classic.description-1',
		'slots.dialogs.table-games.blackjack-classic.description-2',
		'slots.dialogs.table-games.blackjack-classic.description-3',
	],
	filteredGameType: 'table'
}

const BLACKJACK_CLASSIC_GAP: GapGameInfo = {
	displayName: 'Blackjack Classic',
	gameType: 'gap',
	standardImageUrl: styles.bjClassicStandard,
	featureImageUrl: styles.bjClassicFeature,
	gameProviderId: 'gas',
	gameId: 'blackjack-classic',
	tagLine: 'TABLE GAME',
	filteredGameType: 'table',
	infoModal: [
		'Classic Blackjack is fast and easy to learn but also rewards a well thought out strategy.',
		'With Global Poker, players can whip through a few hands whenever they want, wherever they want.',
		'There are always tables available at Global Poker and because of the speed of the game, you won\'t be stuck playing for hours, unless you want to!',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	overlayClockPositionOnDesktop: 'bottom-right',
	overlayClockPositionOnMobile: 'bottom-right'
}

const DUSKMOON_FAIRE_JACKPOT_EDITION: SlotGameInfo = {
	displayName: 'Duskmoon Faire Jackpot',
	gameId: 'duskmoonFaireJackpot',
	gameType: 'slot',
	standardImageUrl: styles.duskmoonFaireJackpotEditionStandard,
	featureImageUrl: styles.duskmoonFaireJackpotEditionFeature,
	tagLine: 'PROGRESSIVE JACKPOT',
	slotUrlDirectory: 'duskmoon-faire-jackpot-edition',
	hasJackpot: true,
	jackpotName: 'duskmoonFaireJackpot',
	jackpotToDisplay: 'grand',
	infoModal: [
		'5 Reels',
		'Progressive Jackpot',
		'5 different levels of jackpots with the Grand Jackpot growing with every spin!',
		'Trigger the Free Spins Feature when you land 3, 4 or 5 scatter symbols - the colorful big top - and win 10, 15 or 20 free spins respectively',
		'During the Free Spins Feature, all rockets, cannon and ticket symbols become the Fortune Teller for that spin',
		'Trigger the jackpot with a full screen of the Fortune Teller Symbols and watch as your fortunes improve',
	],
}

const HALLOWS_WILDS: SlotGameInfo = {
	displayName: 'Hallows Wilds',
	gameId: 'hallowsWilds',
	gameType: 'slot',
	standardImageUrl: styles.hallowsWildsStandard,
	featureImageUrl: styles.hallowsWildsFeature,
	tagLine: '4X5 REEL 50 LINE',
	slotUrlDirectory: 'hallows-wilds',
	infoModal: [
		'5 Reels',
		'3 or more Scatters triggers 15 Free Spins',
		'Chase stacks of Wilds in the Free Spins',
		'During the Free Spins, symbols may become Wild, meaning you could be in for large wins',
	],
}

const SUPER_HOT_SEVENS: SlotGameInfo = {
	displayName: 'Super Hot 7\'s',
	gameId: 'superHot7s',
	gameType: 'slot',
	standardImageUrl: styles.superHotSevensStandard,
	featureImageUrl: styles.superHotSevensFeature,
	tagLine: '3 REEL 5 LINE',
	slotUrlDirectory: 'super-hot-7s',
	infoModal: [
		'3 Reels',
		'5 lines, fixed in place',
		'Super Hot 7\'s takes you back to the golden age of 8-bit video games from the 1980s',
		'Simplistic fruit symbol selection of Cherries, Oranges, Grapes, Lemons, Plums and Melons with the addition of the Super 7 and a scatter in the shape of a star',
		'Offers big wins potential with fantastic bonus rounds',
	],
}

const TRIPLE_DOUBLE_GOLDEN_EAGLES: SlotGameInfo = {
	displayName: 'Triple Double Golden Eagles',
	gameId: 'tripleDoubleGoldenEagles',
	gameType: 'slot',
	standardImageUrl: styles.tripleDoubleGoldenEagleStandard,
	featureImageUrl: styles.tripleDoubleGoldenEagleFeature,
	tagLine: '3 REEL 5 LINE',
	slotUrlDirectory: 'triple-double-golden-eagles',
	infoModal: [
		'3 Reels',
		'Eagles multipliers. 2x eagles and 3x eagles symbols act as multipliers',
		'3 Scatters in any position trigger/retrigger 10 free games',
	],
}

const DRAGONS_RIVER: SlotGameInfo = {
	displayName: 'Dragon\'s River',
	gameId: 'dragonsRiver',
	gameType: 'slot',
	standardImageUrl: styles.dragonsRiverStandard,
	featureImageUrl: styles.dragonsRiverFeature,
	tagLine: '720 WAYS',
	slotUrlDirectory: 'dragons-river',
	infoModal: [
		'5 Reels',
		'720 ways game',
		'Chinese Mythology Theme',
		'Wins go left to right and right to left, except for the Scatter',
		'The Dragon is Wild and appears on reels 2, 3 and 4',
		'Free Spins Feature',
	],
}

const CARIBBEAN_POKER: TableGameInfo = {
	displayName: 'Caribbean Poker',
	gameId: 'caribbeanPoker',
	url: 'caribbean-poker',
	gameType: 'tablegame',
	standardImageUrl: styles.caribbeanPokerStandard,
	featureImageUrl: styles.caribbeanPokerFeature,
	tagLine: 'TABLE GAME',
	infoModal: [
		'slots.dialogs.table-games.caribbean-poker.description-1',
		'slots.dialogs.table-games.caribbean-poker.description-2',
		'slots.dialogs.table-games.caribbean-poker.description-3',
		'slots.dialogs.table-games.caribbean-poker.description-4',
	],
	filteredGameType: 'table'
}

const DIAMOND_PANTHER: SlotGameInfo = {
	displayName: 'Diamond Panther',
	gameId: 'diamondPanther',
	gameType: 'slot',
	standardImageUrl: styles.diamondPantherStandard,
	featureImageUrl: styles.diamondPantherFeature,
	tagLine: '4X5 REEL 40 LINE',
	slotUrlDirectory: 'diamond-panther',
	infoModal: [
		'5 Reels',
		'Jungle Theme',
		'Striking Visuals & Animation',
		'Shifting Vines Feature - Cloning Reels',
		'Free Spins & Win Multipliers',
		'Wild can replace any standard symbol if it helps players complete winning lines',
	],
}

const CASINO_HOLDEM: TableGameInfo = {
	displayName: 'Casino Hold\'Em',
	gameId: 'casinoHoldem',
	url: 'casino-holdem',
	gameType: 'tablegame',
	standardImageUrl: styles.casinoHoldemStandard,
	featureImageUrl: styles.casinoHoldemFeature,
	tagLine: 'TABLE GAME',
	infoModal: [
		'slots.dialogs.table-games.casino-holdem.description-1',
		'slots.dialogs.table-games.casino-holdem.description-2',
	],
	filteredGameType: 'table'
}

const TRIPLE_DOUBLE_FEVER: SlotGameInfo = {
	displayName: 'Triple Double Fever',
	gameId: 'tripleDoubleFever',
	gameType: 'slot',
	standardImageUrl: styles.tripleDoubleFeverStandard,
	featureImageUrl: styles.tripleDoubleFeverFeature,
	tagLine: 'FIRESHOT JACKPOT',
	slotUrlDirectory: 'triple-double-fever',
	infoModal: [
		'Shared Fireshot Jackpot™ feature with Wild Roads',
		'High wins Triple and Double Wild Symbols',
		'Free Spin feature with bonus reels',
	],
	hasJackpot: true,
	jackpotName: 'tripleDoubleFever',
	jackpotToDisplay: 'grand',
}

const WILD_ROADS: SlotGameInfo = {
	displayName: 'Wild Roads',
	gameId: 'wildRoads',
	gameType: 'slot',
	standardImageUrl: styles.wildRoadsStandard,
	featureImageUrl: styles.wildRoadsFeature,
	tagLine: 'FIRESHOT JACKPOT',
	slotUrlDirectory: 'wild-roads',
	infoModal: [
		'Shared Fireshot Jackpot™ shared with Triple Double Fever',
		'Three different free-spins options',
		'Wild symbols',
		'Road-trip-themed slot machine',
	],
	hasJackpot: true,
	jackpotName: 'wildRoads',
	jackpotToDisplay: 'grand',
}

const LAST_EMPRESS: SlotGameInfo = {
	displayName: 'The Last Empress',
	gameId: 'lastEmpress10k',
	gameType: 'slot',
	standardImageUrl: styles.lastEmpressStandard,
	featureImageUrl: styles.lastEmpressFeature,
	tagLine: 'PROGRESSIVE JACKPOT',
	slotUrlDirectory: 'last-empress-10k',
	hasJackpot: true,
	jackpotName: 'lastEmpress10k',
	jackpotToDisplay: 'grand',
	infoModal: [
		'10,000 ways game',
		'6 x 4 base reel slots',
		'Cascading wins',
		'Multiplying Free Spins feature',
		'Mini, Minor and Progressive Major and Grand Jackpots for huge wins!',
	],
}

const ATLANTIS_10K: SlotGameInfo = {
	displayName: 'Atlantis',
	gameId: 'atlantis10kways',
	gameType: 'slot',
	standardImageUrl: styles.atlantisStandard,
	featureImageUrl: styles.atlantisFeature,
	tagLine: '10,000 WAYS',
	slotUrlDirectory: 'atlantis10kways',
	infoModal: [
		'6 Reels plus additional top reel',
		'10,000 ways to win',
		'Jackpot Respins',
		'Land 6 or more scatters to hit the Jackpot respin feature',
		'Land a jackpot symbol to multiply total coins played by 10, 50, 250 or 2000x',
	],
}

const RING_MASTER: FullWidthInHouseSlotGameInfo = {
	displayName: 'Ring Master',
	gameId: 'ringMaster',
	gameType: 'slot',
	standardImageUrl: styles.ringMasterStandard,
	featureImageUrl: styles.ringMasterFeature,
	tagLine: '5X5 REEL, UP TO 3,500X',
	slotUrlDirectory: 'ring-master',
	infoModal: [
		'Win up to 3,500x your play',
		'Cascading wins and Wild Charger',
		'Bonus Game with selectable features',
		'Prize Wheel with second chances',
	],
	useFullWidth: true,
}

const WOLF_GOLD: GapGameInfo = {
	displayName: 'Wolf Gold',
	gameType: 'gap',
	standardImageUrl: styles.wolfGoldStandard,
	featureImageUrl: styles.wolfGoldFeature,
	gameProviderId: 'pragmatic',
	gameId: 'vs25wolfgold',
	tagLine: '3X5 REEL, HUNT FOR BIG WINS!',
	infoModal: [
		'Giant Symbol Free Spins: Increase your winning chances with giant symbols during free spins',
		'Respin Feature: Triggered by Coin Symbols, win Mega, Major, or Mini Jackpot',
		'Stacked Wilds: Land a full screen of WILD symbols for a chance to win x500 and see stacked wolf pack on all reels'
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const BIG_BASS_BONANZA: GapGameInfo = {
	displayName: 'Big Bass Bonanza',
	gameType: 'gap',
	standardImageUrl: styles.bigBassBonanzaStandard,
	featureImageUrl: styles.bigBassBonanzaFeature,
	gameProviderId: 'pragmatic',
	gameId: 'vs10bbbonanza',
	tagLine: 'MAX WIN OF 2100X',
	infoModal: [
		'Captivating Underwater Theme: Immerse yourself in the vibrant and colorful world of Big Bass Bonanza, with stunning animations and a lively soundtrack',
		'Progressive Multiplier and Free Spins Feature: Experience the thrill of increasing multipliers and free spins as you collect Scatter symbols, with up to 20 free spins available',
		'Dynamite Feature: Unleash the explosive power of the "Dynamite" feature, transforming ordinary symbols into lucrative Fish symbols for bigger wins',
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GRIZZLY_REELS: FullWidthInHouseSlotGameInfo = {
	useFullWidth: true,
	displayName: `Grizzly Reels`,
	gameId: 'grizzlyReels',
	gameType: 'slot',
	standardImageUrl: styles.grizzlyReelsStandard,
	featureImageUrl: styles.grizzlyReelsFeature,
	tagLine: 'UNLEASH WILD ADVENTURES',
	slotUrlDirectory: 'grizzly-reels',
	infoModal: [
		'Free Games: Win 15 spins with scatters, find treasures',
		'Bonus Adventure: Pouch symbol = prizes, multipliers',
		'Collector\'s Dream: Seek Collector symbol in free games',
	]
}

const CHILLI_HEAT: GapGameInfo = {
	displayName: 'Chilli Heat',
	gameType: 'gap',
	standardImageUrl: styles.chilliHeatStandard,
	featureImageUrl: styles.chilliHeatFeature,
	gameProviderId: 'pragmatic',
	gameId: 'vs25chilli',
	tagLine: 'GRANDE JACKPOT OF x1000',
	infoModal: [
		'The Reels Are Hot: Experience the sizzling action in Chilli Heat™, a 3×5, 25 lines slot by Pragmatic with stacked Wild symbols.',
		'Money Bag Hold and Re-Spin with Jackpots: Trigger the re-spin feature by landing 6 or more "Money Bag" symbols, and watch as the money bags become sticky for big wins and jackpots!',
		'Free Spins Feature: Land the "Sun Shine" Scatter on reels 2, 3, and 4 to receive 8 Free Spins where J, Q, K, and A symbols are removed, leaving only higher value symbols for bigger rewards.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const JOHN_HUNTER: GapGameInfo = {
	displayName: 'John Hunter',
	gameType: 'gap',
	standardImageUrl: styles.johnHunterStandard,
	featureImageUrl: styles.johnHunterFeature,
	gameProviderId: 'pragmatic',
	gameId: 'vs25scarabqueen',
	tagLine: 'MAX WIN OF 10,500X',
	infoModal: [
		'Uncover the Riches of Ancient Egypt: Join John Hunter in his quest to find the treasures hidden in Scarab Queen, a thrilling 3×5, 25 lines videoslot with Golden Scarab Coin symbols that lead to big wins and exciting features.',
		'Base Game Features: Encounter a variety of symbols in the Tomb of the Scarab Queen, including general and premium symbols related to treasure hunting and Ace to Jack. The Queen herself acts as the wild symbol, and landing all three Pyramid Scatters triggers 8 Free Spins',
		'Free Spins Feature: Trigger 8 Free Spins by landing 3 Pyramid Scatters. During the Free Spins, all coin symbols and Collect features remain active. The Super Re-Spin Pot collects coin symbol values, and on the final spin, if you land a Collect symbol, the full pot will be awarded, leading to even bigger wins.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GATES_OF_OLYMPUS: GapGameInfo = {
	displayName: 'Gates of Olympus',
	gameType: 'gap',
	standardImageUrl: styles.gatesOfOlympusStandard,
	featureImageUrl: styles.gatesOfOlympusFeature,
	gameProviderId: 'pragmatic',
	gameId: 'vs20olympgate',
	tagLine: 'MAX WIN OF 5,000X',
	infoModal: [
		'Embark on a Mythical Journey: Enter the Gates of Olympus, a captivating 6×5 videoslot with 20 win lines where symbols tumble down, awarding in clusters of at least 8, and discover Zeus\' realm filled with magnificent rewards.',
		'Zeus\' Gift - Multiplier Feature: Experience the power of Zeus as he triggers the Multiplier Feature at random times. Watch as the four multiplier symbols take any value up to 500x and combine to boost your total win from a tumble spin.',
		'Ascend to Mount Olympus in Free Spins: Triggered by landing 4 or more Zeus Scatters, you\'ll receive 15 free games. All multiplier symbols are added up, granting tremendous prizes that accumulate throughout the bonus round.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const SWEET_BONANZA: GapGameInfo = {
	displayName: 'Sweet Bonanza',
	gameType: 'gap',
	standardImageUrl: styles.sweetBonanzaStandard,
	featureImageUrl: styles.sweetBonanzaFeature,
	gameProviderId: 'pragmatic',
	gameId: 'vs20fruitsw',
	tagLine: 'MAX WIN OF 21,175X',
	infoModal: [
		'Indulge in a Sugar Rush: Dive into the delectable world of Sweet Bonanza, a 6x5, pays anywhere, tumbling videoslot where hitting more candies leads to exciting tumbles and bigger rewards.',
		'Sweet Free Spins: Trigger the high-awarding Free Spins feature by landing 4 or more Lollipop Scatters. Hitting 6 Lollipops awards x100 on top of 10 free spins. During Free Spins, a new Candy Bomb multiplier symbol can appear, randomly awarding values from 2x to 100x, which are combined and multiplied by your tumble wins for tremendous wins.',
		'Re-Trigger for More Sweet Wins: Keep the sugar rush going by re-triggering the bonus with 3 new scatters to receive an additional 5 free spins.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const SLINGO_XXXTREME: GapGameInfo = {
	displayName: 'Slingo XXXTreme',
	gameType: 'gap',
	standardImageUrl: styles.slingoXxxtremeStandard,
	featureImageUrl: styles.slingoXxxtremeFeature,
	gameProviderId: 'Gaming Realms',
	gameId: 'slingo-xxxtreme',
	tagLine: 'MAX WIN x1000 & UNLIMITED FREE SPINS',
	infoModal: [
		'Win big with a max win of x1000',
		'Enjoy endless thrills with Unlimited Free Spins',
		'Find Jokers and Super Jokers to mark off numbers strategically and earn instant coin prizes'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const THE_DOG_HOUSE: GapGameInfo = {
	displayName: 'The Dog House',
	gameType: 'gap',
	standardImageUrl: styles.theDogHouseStandard,
	featureImageUrl: styles.theDogHouseFeature,
	gameProviderId: 'pragmatic',
	gameId: 'vs20doghouse',
	tagLine: 'MAX WIN OF 6,750X',
	infoModal: [
		'Join the Pack in The Dog House: Experience the charming cartoon-style graphics of The Dog House, a 5×3, 20 lines slot designed to appeal to dog lovers and alike.',
		'Sticky Multiplier Wilds and Free Spins: Trigger the free spins feature with 3 Jewel paw symbols, receiving at least 9 free spins, with the potential for up to 27 spins. In the free spins round, wilds on reels 2, 3, and 4 have 2x or 3x multipliers and become sticky, multiplying with each other up to a maximum of 9x for massive wins.',
		'High Win Potential: With a maximum win of up to 6,750x, The Dog House keeps the excitement high and rewards on your paws.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const MADAME_DESTINY: GapGameInfo = {
	displayName: 'Madame Destiny',
	gameType: 'gap',
	standardImageUrl: styles.madameDestinyStandard,
	featureImageUrl: styles.madameDestinyFeature,
	gameProviderId: 'pragmatic',
	gameId: 'vs10madame',
	tagLine: 'MAX WIN OF 1500X',
	infoModal: [
		'Peer into the Future: Enter the mystical world of Madame Destiny, a 3×5, 10 lines videoslot where the Wild oracle multiplies all wins by 2x, and the Free Spins feature brings a 3x win multiplier and retriggering opportunities.',
		'Free Spins Feature: Land three or more scatters to receive 5 free spins, where all wins are multiplied by 3x, and winning combinations with at least one WILD are multiplied by x3.',
		'Endless Retriggers: Increase your chances of big wins by retriggering the bonus with another 3 or more Scatters to receive an additional 15 spins—no limits on retriggers!'
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const SUGAR_RUSH: GapGameInfo = {
	displayName: 'Sugar Rush',
	gameType: 'gap',
	standardImageUrl: styles.sugarRushStandard,
	featureImageUrl: styles.sugarRushFeature,
	gameProviderId: 'pragmatic',
	gameId: 'vs20sugarrush',
	tagLine: 'MAX WIN OF 5000X',
	infoModal: [
		'Sweet-filled Reels: Delight in the world of Sugar Rush, a 7×7 grid slot filled with jelly babies and gummy bears, using a cluster wins system. Trigger the tumble feature with wins and explore Multiplier Spots and Free Spins.',
		'Multiplier Spots: Match a winning symbol twice to mark its spot on the grid and add a multiplier, starting from x2 and doubling with each additional symbol explosion, up to a maximum of x128.',
		'Free Spins: Trigger the bonus round with 3 to 7 Sugar Rush Scatter Symbols, receiving 10 to 30 free spins. Unlike the base game, the "Multiplier Spots" in the Free Spins round never reset, making it easier to build huge multipliers.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GREAT_RHINO: GapGameInfo = {
	displayName: 'Great Rhino',
	gameType: 'gap',
	standardImageUrl: styles.greatRhinoStandard,
	featureImageUrl: styles.greatRhinoFeature,
	gameProviderId: 'pragmatic',
	gameId: 'vs20rhino',
	tagLine: 'MAX WIN OF 900X',
	infoModal: [
		'Win Stampede: Join the thrilling 3x5, 20 lines videoslot "Great Rhino" with stacked rhinos on all reels. Trigger the Stampede Re-spin round when two stacks hit for big wins.',
		'Enjoy Free Spins with WILD Rhino Symbols and the Super Re-spin with Major and Grand Jackpots up to x500.',
		'Big Jackpots: Fill 14 positions for the Major Jackpot x375 or all 15 positions for the Grand Jackpot x500.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const CHEEKY_FRUITS_DELUXE: GapGameInfo = {
	displayName: 'Cheeky Fruits Deluxe',
	gameType: 'gap',
	standardImageUrl: styles.cheekyFruitsDeluxeStandard,
	featureImageUrl: styles.cheekyFruitsDeluxeFeature,
	gameProviderId: 'ggames',
	gameId: 'CHEEKY_FRUITS_DELUXE',
	tagLine: 'MAX WIN OF 5000X',
	infoModal: [
		'Jackpot: Symbols with crowns fill the jackpot meter on every spin. Fill it to claim the displayed Jackpot and win big!',
		'Free Spins: Land 3-6 \'BONUS\' scatter symbols to trigger 10-25 free spins. One symbol expands over 3 central reels, enhancing your chances of big wins.',
		'Fixed Win Lines: Play with 5 fixed win lines, left to right, with wins multiplied by your line your play amount.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const BIG_BASS_SPLASH: GapGameInfo = {
	displayName: 'Big Bass Splash',
	gameType: 'gap',
	standardImageUrl: styles.bigBassSplashStandard,
	featureImageUrl: styles.bigBassSplashFeature,
	gameProviderId: 'pragmatic',
	gameId: 'vs10txbigbass',
	tagLine: 'MAX WIN OF 5,000X',
	infoModal: [
		'12 unique symbols, including high-winning, low-winning, Wild, and Scatter symbols.',
		'Trigger Free Spins with 3 or more Scatters, granting 10 to 20 Free Spins',
		'Randomly selected modifiers before Free Spins enhance fish and Wild symbols, promising big wins'
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const MILLION_BOOK: GapGameInfo = {
	displayName: 'Million Book',
	gameType: 'gap',
	standardImageUrl: styles.millionBookStandard,
	featureImageUrl: styles.millionBookFeature,
	gameProviderId: 'ggames',
	gameId: 'MILLION_BOOK',
	tagLine: 'WIN UP TO 1,000,000X',
	infoModal: [
		'Scatter and Wild Book Symbol: The Book symbol is your key to unlocking untold riches, acting as both a wild and scatter symbol.',
		'10 Free Spins with Expanding Symbol: Trigger 10 free spins with 3 or more Book symbols, featuring an expanding symbol for greater rewards.',
		'Jackpot: To win the x1,000,000 jackpot, land 5 Jackpot scatter symbols, one on each reel.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const FIRE_STRIKE_2: GapGameInfo = {
	displayName: 'Fire Strike 2',
	gameType: 'gap',
	standardImageUrl: styles.fireStrike2Standard,
	featureImageUrl: styles.fireStrike2Feature,
	gameProviderId: 'ggames',
	gameId: 'vs10firestrike2',
	tagLine: 'MAX WIN OF 25,000X',
	infoModal: [
		'Blaze your way to victory with Fire Strike and Fire Strike Wild symbols, offering instant rewards up to 5,000x your play amount.',
		'Trigger the Bonus Round with 12 free spins and fewer symbols required to win big.',
		'Ignite your gameplay with sticky Fire Strike symbols and aim for the explosive 25,000x jackpot during the bonus round!'
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const STARBURST: GapGameInfo = {
	displayName: 'Starburst',
	gameType: 'gap',
	standardImageUrl: styles.starburstStandard,
	featureImageUrl: styles.starburstFeature,
	gameProviderId: 'ggames',
	gameId: 'starburst_not_mobile',
	tagLine: 'MAX WIN OF 500X',
	infoModal: [
		'Starburst: Unique Wilds, re-spins',
		'Expanding Wild: Land, re-spins',
		'Galactic Excitement Unleashed'
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const QUEENIE: GapGameInfo = {
	displayName: 'Queenie',
	gameType: 'gap',
	standardImageUrl: styles.queenieStandard,
	featureImageUrl: styles.queenieFeature,
	gameProviderId: 'ggames',
	gameId: 'vs243queenie',
	tagLine: 'MAX WIN OF 4,200X',
	infoModal: [
		'Whimsical Adventure',
		'Wheel Feature: Prizes, Multipliers',
		'Jackpot Bonuses with 4 Fixed Jackpots'
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const FORTUNE_SCRATCH: GapGameInfo = {
	displayName: 'Fortune Scratch',
	gameType: 'gap',
	standardImageUrl: styles.fortuneScratchStandard,
	featureImageUrl: styles.fortuneScratchFeature,
	gameProviderId: 'ggames',
	gameId: 'FORTUNE_SCRATCH',
	tagLine: 'WIN UP TO 50,000X',
	infoModal: [
		'Find the amount to win - simple, speedy, and 9 separate chances to win!',
		'Scratch your card and win the amazing prizes.',
		'Max Win: 4,000,000 SC or 200,000,000,000 GC',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	filteredGameType: 'scratch-cards',
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const THE_LINK_SCRATCH: GapGameInfo = {
	displayName: 'The Link Scratch',
	gameType: 'gap',
	standardImageUrl: styles.theLinkScratchStandard,
	featureImageUrl: styles.theLinkScratchFeature,
	gameProviderId: 'ggames',
	gameId: 'THE_LINK_SCRATCH',
	tagLine: 'MAX WIN OF 4000X',
	infoModal: [
		'Every line of symbols you match multiplies your prize in this 6-game scratch card.',
		'Scratch your card and win the amazing prizes.',
		'Max Win: 2,000,000 SC or 100,000,000,000 GC',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	filteredGameType: 'scratch-cards',
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const PHARAOHS_TREASURE: GapGameInfo = {
	displayName: 'Pharaoh\'s Treasure',
	gameType: 'gap',
	standardImageUrl: styles.pharaohsTreasureStandard,
	featureImageUrl: styles.pharaohsTreasureFeature,
	gameProviderId: 'ggames',
	gameId: 'PHARAOHS_TREASURE',
	tagLine: 'WIN UP TO 100,000X',
	infoModal: [
		'Unleash the secrets of ancient Egypt with "Pharaoh\'s Treasure" scratch card. Unveil hidden symbols, win dazzling prizes. Embark on an unforgettable adventure.',
		'Scratch your card and win the amazing prizes.',
		'Max Win: 4,000,000 SC or 200,000,000,000 GC',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	filteredGameType: 'scratch-cards',
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const DIAMONDS_SCRATCH: GapGameInfo = {
	displayName: 'Diamonds Scratch',
	gameType: 'gap',
	standardImageUrl: styles.diamondsScratchStandard,
	featureImageUrl: styles.diamondsScratchFeature,
	gameProviderId: 'ggames',
	gameId: 'DIAMONDS_SCRATCH',
	tagLine: 'WIN UP TO 50,000X',
	infoModal: [
		'Match the carat of the diamond to win the prize on this glittering scratch card with 7 chances to win!',
		'Scratch your card and win the amazing prizes.',
		'Max Win: 4,000,000 SC or 200,000,000,000 GC',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	filteredGameType: 'scratch-cards',
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const TOUCH_DOWN: GapGameInfo = {
	displayName: 'Touch Down',
	gameType: 'gap',
	standardImageUrl: styles.touchDownStandard,
	featureImageUrl: styles.touchDownFeature,
	gameProviderId: 'ggames',
	gameId: 'TOUCH_DOWN',
	tagLine: 'WIN UP TO 50,000X',
	infoModal: [
		'The beautiful game is back with this fast-play football scratch. Scratch the team football helmets and match three amounts to win. Could it be your and your team’s lucky day?',
		'Scratch your card and win the amazing prizes.',
		'Max Win: 4,000,000 SC or 200,000,000,000 GC',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	filteredGameType: 'scratch-cards',
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const FIVE_LIONS_GOLD: GapGameInfo = {
	displayName: '5 Lions Gold',
	gameType: 'gap',
	standardImageUrl: styles.fiveLionsGoldStandard,
	featureImageUrl: styles.fiveLionsGoldFeature,
	gameProviderId: 'ggames',
	gameId: 'vs243lionsgold',
	tagLine: 'MAX WIN OF 7,342X',
	infoModal: [
		'Jackpot Riches: Up to 2,000x',
		'Cashien\'s Surprises: Random Rewards',
		'Free Spins Bonanza: 7 Unique Options',
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const AMERICASH: GapGameInfo = {
	displayName: 'Americash',
	gameType: 'gap',
	standardImageUrl: styles.americashStandard,
	featureImageUrl: styles.americashFeature,
	gameProviderId: 'reelplay',
	gameId: 'americash10kways',
	tagLine: 'WIN THE AMERICAN DREAM',
	infoModal: [
		'10,000 Ways to Win',
		'A Massive Possible 9,141x Maximum Win Potential',
		'Free Spins Scatter Symbols with a potential award of 1x to 100x your play amount',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const THREE_DANCING_MONKEYS: GapGameInfo = {
	displayName: '3 DANCING MONKEYS',
	gameType: 'gap',
	standardImageUrl: styles.threeDancingMonkeysStandard,
	featureImageUrl: styles.threeDancingMonkeysFeature,
	gameProviderId: 'ggames',
	gameId: 'vswaysmonkey',
	tagLine: 'MAX WIN 12,077X',
	infoModal: [
		'Expanded Reels and Versatile Wins: Discover 243 ways to win. The Red Gem holds the key to expanding the standard 5x3 reel set to an impressive 5x5 during the bonus round.',
		'Diverse Bonus Rounds: Gather red, green, and blue gems to trigger different bonus rounds. Expand the grid, get extra wilds, and multiply wins with each monkey\'s gem power.',
		'Surprise Rewards: Discover mystery symbols in the bonus round for extra spins or big prizes. Win up to 5,000x your play amount or earn more spins.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const CLOVER_GOLD: GapGameInfo = {
	displayName: 'Clover Gold',
	gameType: 'gap',
	standardImageUrl: styles.cloverGoldStandard,
	featureImageUrl: styles.cloverGoldFeature,
	gameProviderId: 'ggames',
	gameId: 'vs20mustanggld2',
	tagLine: 'MAX WIN 5,000X',
	infoModal: [
		'Exhilarating Adventure: Immerse yourself in the golden world of "Clover Gold," where luck meets excitement, offering a chance at remarkable prizes and thrilling experiences.',
		'Coin Collect Feature: The Coin Symbol reveals values up to an astounding 100x your total play amount on reels 1, 2, 3, and 4. Dive into five types of Collect symbols on the end reel for dynamic actions like combining values, adding extra coin values, triggering multipliers, expanding reels, and experiencing thrilling re-spins.',
		'Free Spins Galore: Trigger the Bonus Round with 3 bonus scatters across reels 2, 3, and 4, granting 8 free spins. During this round, all Coin symbols and collect features remain active. Collect sets of 4 Collect Symbols to earn additional +8 free spins and upgrade multipliers to x2, x3, and finally x5 for the third enhancement, promising endless excitement and rewards.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const RED_HOT_SLINGO: GapGameInfo = {
	displayName: 'Red Hot Slingo',
	gameType: 'gap',
	standardImageUrl: styles.redHotSlingoStandard,
	featureImageUrl: styles.redHotSlingoFeature,
	gameProviderId: 'ggames',
	gameId: 'slingo-redhot',
	tagLine: 'WIN UP TO 500X',
	infoModal: [
		'Scatter symbols awards for 3 or more anywhere in view 1x 10x 100x your spin amount',
		'Matching 3 or more of the same symbol on a win line from the left most reel awards a coin prize',
		'Wilds, Super Wilds and Free Spins Symbols are all present in this version of Slingo',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const CASINO_SOLITAIRE: GapGameInfo = {
	displayName: 'Casino Solitaire',
	gameType: 'gap',
	standardImageUrl: styles.casinoSolitaireStandard,
	featureImageUrl: styles.casinoSolitaireFeature,
	gameProviderId: 'ggames',
	gameId: 'CASINO_SOLITAIRE',
	tagLine: 'WIN UP TO 320X',
	infoModal: [
		'Engaging Fusion of Luck and Strategy: Casino Solitaire blends the thrill of luck with strategic gameplay, offering an interactive experience with a good balance of chance and skill.',
		'Dynamic Card Arrangement: Utilize a standard 52-card deck shuffled randomly, dealt into 7 columns with increasing cards from 1 to 7, revealing the final card of each column face up. Begin with empty suit stacks and a \'play\' deck comprising the remaining cards.',
		'Diverse Side Games for Extra Thrills: Take your chances with "No Move" for a 15x win or dive into "Red and Black" for a shot at 200x your play amount.',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	filteredGameType: 'table',
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const FOUR_FANTASTIC_FISH: GapGameInfo = {
	displayName: '4 Fantastic Fish',
	gameType: 'gap',
	standardImageUrl: styles.fourFantasticFishStandard,
	featureImageUrl: styles.fourFantasticFishFeature,
	gameProviderId: 'ggames',
	gameId: 'slots-4fantasticfish',
	tagLine: 'WIN UP TO 15,000X',
	infoModal: [
		'Four exciting jackpots: Big, Super, Mega, and Ultra, offering rewards up to 10,000 times your play amount',
		'Trigger the Re-spins Bonus Round with Marlin scatters',
		'Giant Squid enhances wins by strategically moving Fish Symbols for bigger prizes',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const ELITE_OF_EVIL: GapGameInfo = {
	displayName: 'Elite Of Evil',
	gameType: 'gap',
	standardImageUrl: styles.eliteOfEvilStandard,
	featureImageUrl: styles.eliteOfEvilFeature,
	gameProviderId: 'ggames',
	gameId: 'ELITE_OF_EVIL',
	tagLine: '5 BOSS LEVELS',
	infoModal: [
		'Match 3 Clusters to maximize your wins',
		'Smash runes to power up symbols for epic battles',
		'Defeat all 5 elite bosses for heroic rewards',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	filteredGameType: 'instant-win',
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const SEVEN_UP: GapGameInfo = {
	displayName: '7Up',
	gameType: 'gap',
	standardImageUrl: styles.sevenUpStandard,
	featureImageUrl: styles.sevenUpFeature,
	gameProviderId: 'ggames',
	gameId: '7UP',
	tagLine: 'RETRO ARCADE HIT',
	infoModal: [
		'Nostalgic, multi-line scratch excitement',
		'Multi-line scratch excitement',
		'Quick, effortless, and endlessly entertaining',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	filteredGameType: 'instant-win',
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const FRUIT_PUNCH_UP: GapGameInfo = {
	displayName: 'Fruit Punch Up',
	gameType: 'gap',
	standardImageUrl: styles.fruitPunchUpStandard,
	featureImageUrl: styles.fruitPunchUpFeature,
	gameProviderId: 'ggames',
	gameId: 'FRUIT_PUNCH_UP',
	tagLine: 'KNOCKOUT JACKPOTS',
	infoModal: [
		'Crazy fruits for quick, multi-wins',
		'Hit the bonus wheel for guaranteed prizes',
		'Enjoy free spins with re-trigger possibilities',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	filteredGameType: 'instant-win',
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const DIAMOND_DEAL: GapGameInfo = {
	displayName: 'Diamond Deal',
	gameType: 'gap',
	standardImageUrl: styles.diamondDealStandard,
	featureImageUrl: styles.diamondDealFeature,
	gameProviderId: 'ggames',
	gameId: 'DIAMOND_DEAL',
	tagLine: 'UNCOVER DIAMONDS TO BOOST YOUR PRIZE',
	infoModal: [
		'Navigate wisely with only 4 lives',
		'Redeem prizes strategically before losing all lives',
		'Max Win: 4,000,000.00 SC or 200,000,000,000 GC',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	filteredGameType: 'instant-win',
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const LUCKY_NUMBERS: GapGameInfo = {
	displayName: 'Lucky Numbers',
	gameType: 'gap',
	standardImageUrl: styles.luckyNumbersStandard,
	featureImageUrl: styles.luckyNumbersFeature,
	gameProviderId: 'ggames',
	gameId: '7_11_21',
	tagLine: 'HIT 7, 11 or 21 TO WIN BIG',
	infoModal: [
		'Golden coins pave the way to fortune',
		'Your choices determine the outcome',
		'Experience the excitement of selecting winning numbers',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	filteredGameType: 'instant-win',
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const TWIN_SPIN_MEGAWAYS: GapGameInfo = {
	displayName: 'Twin Spin Megaways',
	gameType: 'gap',
	standardImageUrl: styles.twinSpinMegawaysStandard,
	featureImageUrl: styles.twinSpinMegawaysFeature,
	gameProviderId: 'ggames',
	gameId: 'twinspinmw_not_mobile',
	tagLine: 'WIN UP TO 38,000X',
	infoModal: [
		'Cascade Wins bring the thrill of consecutive victories, where symbols vanish to make room for new ones falling from above or emerging in empty spaces',
		'The Twin Reels feature remains active throughout the game, linking two or more adjacent reels to display matching symbols and spin simultaneously',
		'Free Spin Frenzy is unleashed with 5 Scatters, featuring 7-symbol high Twin Reels and multiplier Wilds up to 81x',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const BLUE_WIZARD: GapGameInfo = {
	displayName: 'Blue Wizard',
	gameType: 'gap',
	standardImageUrl: styles.blueWizardStandard,
	featureImageUrl: styles.blueWizardFeature,
	gameProviderId: 'ggames',
	gameId: 'gpas_bwizard_pop',
	tagLine: 'MAGICAL JACKPOTS',
	infoModal: [
		'Magical theme with enchanting graphics and animations',
		'Wild symbols on reel 3 can randomly receive multipliers up to ×16',
		'Experience the Fire Blaze feature by landing 6 or more Crystal Ball symbols, with the chance to win Major, Minor, or Mini jackpots, including the "GRAND" jackpot for filling the screen with Crystal Balls',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const KHONSU_GOD_OF_MOON: GapGameInfo = {
	displayName: 'Khonsu God of Moon',
	gameType: 'gap',
	standardImageUrl: styles.khonsuGodOfMoonStandard,
	featureImageUrl: styles.khonsuGodOfMoonFeature,
	gameProviderId: 'ggames',
	gameId: 'gpas_kgomoon_pop',
	tagLine: 'ASCEND TO CELESTIAL RICHES',
	infoModal: [
		'Multipliers up to 10x are available for moon symbols landing on the top rows (7, 8, and 9), with the potential to fill the entire grid for massive wins',
		'Trigger the Mega Fire Blaze feature by landing 6 or more moon symbols, unlocking a new 5x9 reel set with locked upper rows',
		'Win the Grand, Major, Minor, or Mini jackpots by landing corresponding jackpot star symbols, with rewards ranging from 20x to 2,000x your play amount',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const TWO_FIFTY_K_DELUXE: GapGameInfo = {
	displayName: '250K Deluxe',
	gameType: 'gap',
	standardImageUrl: styles.twoFiftyKDeluxeStandard,
	featureImageUrl: styles.twoFiftyKDeluxeFeature,
	gameProviderId: 'ggames',
	gameId: 'XK_DELUXE',
	tagLine: 'WIN UP TO 5000X JACKPOT',
	infoModal: [
		'Immerse in the radiant allure of gem-themed slot brilliance',
		'Experience the thrill of Mega Symbols in a 3x3 extravaganza during Free Spins',
		'Keep it simple yet thrilling with 5 fixed win lines',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const BUFFALO_BLITZ: GapGameInfo = {
	displayName: 'Buffalo Blitz',
	gameType: 'gap',
	standardImageUrl: styles.buffaloBlitzStandard,
	featureImageUrl: styles.buffaloBlitzFeature,
	gameProviderId: 'ggames',
	gameId: 'gpas_bblitz_pop',
	tagLine: 'ROAM THE PLAINS FOR WILD REWARDS',
	infoModal: [
		'Trigger up to 100 Free Spins by landing 3 or more Free Games Scatter symbols anywhere on the reels',
		'The Diamond Wild substitutes for all symbols except the Scatter, appearing on reels 2 to 6 and offering random 2x, 3x, or 5x multipliers during the Free Games Bonus',
		'Win additional Free Spins during the Free Games Bonus by landing 2 or more Free Games Scatter symbols',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const QUEST_WEST: GapGameInfo = {
	displayName: 'Quest West',
	gameType: 'gap',
	standardImageUrl: styles.questWestStandard,
	featureImageUrl: styles.questWestFeature,
	gameProviderId: 'ggames',
	gameId: 'gpas_mquest_pop',
	tagLine: 'CLAIM YOUR FORTUNE',
	infoModal: [
		'Trigger the Free Games Feature with 9 SCATTER symbols on reels 2, 3, and 4, initiating 7 Free Games',
		'Pick-and-reveal Bonus Game before Free Games commence, to unveil symbols that will appear more frequently in stacks during Free Games',
		'Extra spins can also be granted during the free spins feature',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const TSAI_SHENS_GIFT: GapGameInfo = {
	displayName: 'Tsai Shens Gift',
	gameType: 'gap',
	standardImageUrl: styles.tsaiShensGiftStandard,
	featureImageUrl: styles.tsaiShensGiftFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_tsgift_pop',
	tagLine: 'WIN UP TO 4106X',
	infoModal: [
		'Land 3 Scatters for 6 free games with a mega 3x3 roaming reel',
		'Fire Blaze Jackpot Re-spins, Triggered by 6+ Pearls, aim to fill the screen for the grand prize',
		'Giant roving symbols, extra free games, and mini giant symbol re-spins in the Free Games round',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const BIG_CIRCUS: GapGameInfo = {
	displayName: 'Big Circus',
	gameType: 'gap',
	standardImageUrl: styles.bigCircusStandard,
	featureImageUrl: styles.bigCircusFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_bcircus_pop',
	tagLine: 'WIN UP TO 2328X',
	infoModal: [
		'5 Free Spins with doubled WILD wins and a Mega Fire Blaze feature during the Free Spins round',
		'Progressive hold and win game with added modifiers and jackpot potential',
		'Aim for the prestigious Grand Jackpot with a staggering x2000 multiplier',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const TUNDRA_WOLF: GapGameInfo = {
	displayName: 'Tundra Wolf',
	gameType: 'gap',
	standardImageUrl: styles.tundraWolfStandard,
	featureImageUrl: styles.tundraWolfFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_twolf_pop',
	tagLine: 'WIN UP TO 2000X',
	infoModal: [
		'Trigger 6 Free Spins with a massive 3x3 Mega Symbol, and the chance to win Mega Moon or Mega Bell symbols',
		'Choose between higher jackpots (Classics) or more frequent wins (Golden) with two distinct game modes',
		'Experience two Fire Blaze features with their respective jackpots, each offering unique gameplay and rewards',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const WILD_LINX: GapGameInfo = {
	displayName: 'Wild LinX',
	gameType: 'gap',
	standardImageUrl: styles.wildLinxStandard,
	featureImageUrl: styles.wildLinxFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_wlinx_pop',
	tagLine: 'WIN UP TO 2539X',
	infoModal: [
		'Triggered by ARROW on one reel and WILD/GOLD WILD on others',
		'Choose between Stacks Free Games or X Free Games with unique reel configurations',
		'Receive 5 Free Games with an increased chance of triggering the Wild LinX Feature; SCATTERs grant extra Free Games',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const DRAGON_TRIO_BONUS: GapGameInfo = {
	displayName: 'Dragon Trio Bonus',
	gameType: 'gap',
	standardImageUrl: styles.dragonTrioBonusStandard,
	featureImageUrl: styles.dragonTrioBonusFeature,
	gameProviderId: 'ggames',
	gameId: 'TBG_DRAGON',
	tagLine: 'UNVEIL ANCIENT RICHES',
	infoModal: [
		'3 Pot Collection Feature',
		'7 Feature Variations',
		'Static Jackpots: Win Big with Fixed Rewards',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const SHARK_FRENZY: GapGameInfo = {
	displayName: 'Shark Frenzy',
	gameType: 'gap',
	standardImageUrl: styles.sharkFrenzyStandard,
	featureImageUrl: styles.sharkFrenzyFeature,
	gameProviderId: 'slotmill',
	gameId: 'shark-frenzy',
	tagLine: 'DIVE INTO THE DEPTHS',
	infoModal: [
		'Random Re-Spins',
		'Win up to a massive 7,777X',
		'Burst Mode Feature',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const THREE_SAMURAI: GapGameInfo = {
	displayName: 'Three Samurai',
	gameType: 'gap',
	standardImageUrl: styles.threeSamuraiStandard,
	featureImageUrl: styles.threeSamuraiFeature,
	gameProviderId: 'slotmill',
	gameId: 'three-samurai',
	tagLine: '5X3 REEL, 10,000X',
	infoModal: [
		`Dragon's Luck Feature: Randomly expands slot to 5x4 with 40 win lines`,
		`Samurai Free Spins: Triggered by 3 bonus symbols, 4 bonus combos with different multipliers and spins`,
		`Stacked Nudge/Wilds: During Free Spins, nudges symbols for more wins, and adds full stack Wilds with gems`,
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	providerGameId: 'threeSamurai',
}

const THUNDER_WHEEL: GapGameInfo = {
	displayName: 'Thunder Wheel',
	gameType: 'gap',
	standardImageUrl: styles.thunderWheelStandard,
	featureImageUrl: styles.thunderWheelFeature,
	gameProviderId: 'slotmill',
	gameId: 'thunder-wheel',
	tagLine: '4X4 REEL, 10,000X',
	infoModal: [
		'Random wilds that can expand to 3x3 symbol size',
		'Burst Mode and Fast Track',
		'Free Spins and Roaming Wilds',
		'Thunder Wheel wins up to 9,999x',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	providerGameId: 'thunderWheel'
}
const FRUIT_SMASH: GapGameInfo = {
	displayName: 'Fruit Smash',
	gameType: 'gap',
	standardImageUrl: styles.fruitSmashStandard,
	featureImageUrl: styles.fruitSmashFeature,
	gameProviderId: 'slotmill',
	gameId: 'fruit-smash',
	tagLine: ' 6X6 REEL, CLUSTER',
	infoModal: [
		'Cluster and Cascade Slot: Match 8+ symbols for a win',
		'Giant Fruit Symbols: Randomly appear with 2x to 100x win multiplier, sticky until a win',
		'Free Spins: Triggered by 3 bonus symbols, 10 free spins, persistent multiplier',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	providerGameId: 'fruitSmash'
}

const SANDS_OF_ETERNITY: GapGameInfo = {
	displayName: 'Sands Of Eternity',
	gameType: 'gap',
	standardImageUrl: styles.sandsOfEternityStandard,
	featureImageUrl: styles.sandsOfEternityFeature,
	gameProviderId: 'slotmill',
	gameId: 'sands-of-eternity',
	tagLine: '6X6 REEL, 46,656 WAYS',
	infoModal: [
		'Explosive Stone Blocks: Trigger unique features with Wilds, symbol removal, and 2x2 Wilds',
		'Random Expansion: On any spin, trigger massive 20,736 ways with all non-winning blocks removed',
		'Multiplier Stones in Free Spins: Explode stones to increase the multiplier for the whole duration of the bonus, and earn additional free spins with Extra Free Spin Symbols'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	providerGameId: 'sandsOfEternity'
}

const STAR_SPELL: GapGameInfo = {
	displayName: 'Star Spell',
	gameType: 'gap',
	standardImageUrl: styles.starSpellStandard,
	featureImageUrl: styles.starSpellFeature,
	gameProviderId: 'slotmill',
	gameId: 'starspell',
	tagLine: '5X3 REEL, WIN BOTH WAYS',
	infoModal: [
		'Win Both Ways: Double your chances of winning',
		'Expanding Sticky Wilds: Sticky Wilds and Multipliers for big wins',
		'Maximum Win of x1,200: Win up to x1,200 and trigger frequent bonuses',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	providerGameId: 'starSpell'
}

const SPACE_MINERS: GapGameInfo = {
	displayName: 'Space Miners',
	gameType: 'gap',
	gameId: 'spaceminers',
	standardImageUrl: styles.spaceMinersStandard,
	featureImageUrl: styles.spaceMinersFeature,
	gameProviderId: 'relax',
	tagLine: 'UP TO 1 MILLION WAYS',
	infoModal: [
		'As the reels grow, so do your chances of winning!',
		'Respin feature and some epic free spins',
		'Collect power-ups that help break through the reels faster',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	providerGameId: 'spaceMiners'
}

const CLUSTER_TUMBLE: GapGameInfo = {
	displayName: 'Cluster Tumble',
	gameType: 'gap',
	gameId: 'clustertumble',
	standardImageUrl: styles.clusterTumbleStandard,
	featureImageUrl: styles.clusterTumbleFeature,
	gameProviderId: 'relax',
	tagLine: '8X8 REEL, UP TO 20,000X',
	infoModal: [
		'Huge clusters on an 8x8 reel',
		'Win up to 20,000x with unlimited multipliers',
		'Lightning Win and Fire Transform features',
		'Unlock more wilds by landing the wild blocker',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	providerGameId: 'clusterTumble'
}

const MONEY_TRAIN: GapGameInfo = {
	displayName: 'Money Train',
	gameType: 'gap',
	standardImageUrl: styles.moneyTrainStandard,
	featureImageUrl: styles.moneyTrainFeature,
	gameProviderId: 'relax',
	gameId: 'moneytrain',
	tagLine: '5X4 REEL, 40 LINES',
	infoModal: [
		'Bonus symbols on reels 1, 3 and 5 triggers Money Cart bonus',
		'5 different bonus game symbols',
		'Win up to 20,000 x play amount',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	providerGameId: 'moneyTrain'
}

const TNT_TUMBLE: GapGameInfo = {
	displayName: 'TNT Tumble',
	gameType: 'gap',
	standardImageUrl: styles.tntTumbleStandard,
	featureImageUrl: styles.tntTumbleFeature,
	gameProviderId: 'relax',
	gameId: 'tnttumble',
	tagLine: '5X7 REEL, 12,278X',
	infoModal: [
		'Free spins if all dark stone blocks destroyed',
		'Persistent Wilds',
		'TNT blocks',
		'Win up to 12,278 x play amount',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	providerGameId: 'tntTumble'
}

const TEMPLAR_TUMBLE: GapGameInfo = {
	displayName: 'Templar Tumble',
	gameType: 'gap',
	standardImageUrl: styles.templarTumbleStandard,
	featureImageUrl: styles.templarTumbleFeature,
	gameProviderId: 'relax',
	gameId: 'templartumble',
	tagLine: '6X7 REEL, 117,649 WAYS',
	infoModal: [
		'6 spins awarded when all crumbling blockers destroyed',
		'Wilds transform normal symbols into Mystery symbols',
		'No blocker symbols present during Free Spins',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	providerGameId: 'templarTumble'
}

const IRON_BANK: GapGameInfo = {
	displayName: 'Iron Bank',
	gameType: 'gap',
	standardImageUrl: styles.ironBankStandard,
	featureImageUrl: styles.ironBankFeature,
	gameProviderId: 'relax',
	gameId: 'ironbank',
	tagLine: '6X4 REEL, 4096 WAYS',
	infoModal: [
		'3 bonus symbols awards Free Spins',
		'4, 5 or 6 bonus symbols award 20x, 200x or 2000x',
		'Choose between Sticky Mystery Symbols, Expanding Re-Spin Wilds, and Progressive Multiplier Wilds',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	providerGameId: 'ironBank'
}

const NINE_FLAGS: GapGameInfo = {
	displayName: '9 Flags',
	gameType: 'gap',
	standardImageUrl: styles.nineFlagsStandard,
	featureImageUrl: styles.nineFlagsFeature,
	gameProviderId: 'gas',
	gameId: 'nine-flags',
	tagLine: 'HOIST YOUR WINS HIGH',
	infoModal: [
		'Win Up to 20,000x Landing 9 Flags',
		'Free Spins and Multiplier Wheel Bonus Feature',
		'Win Up to 30 Free Spins with a 3x Multiplier',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const NINEK_YETI: GapGameInfo = {
	displayName: '9K Yeti',
	gameType: 'gap',
	standardImageUrl: styles.nineKYetiStandard,
	featureImageUrl: styles.nineKYetiFeature,
	gameProviderId: 'Gaming Realms',
	gameId: 'slots-9k-yeti-97',
	tagLine: 'UNCOVER THE LEGEND',
	infoModal: [
		'4,096 Ways to Win',
		'A Massive Possible 9,012x Maximum Win Potential',
		'Select Classic or Big Reel Portrait Mode'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const OINK_OINK_OINK: GapGameInfo = {
	displayName: 'Oink Oink Oink',
	gameType: 'gap',
	standardImageUrl: styles.oinkOinkOinkStandard,
	featureImageUrl: styles.oinkOinkOinkFeature,
	gameProviderId: 'ggames',
	gameId: 'gpas_oink_pop',
	tagLine: 'SQUEEL WITH DELIGHT',
	infoModal: [
		'MINI, MINOR, MAJOR, or GRAND Jackpots',
		'Pick-and-Match Bonus',
		'Free Spins Reaching up to either 1,024 or 3,125 ways to win',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const HERCULES_10K: GapGameInfo = {
	displayName: 'Hercules 10k Ways',
	gameType: 'gap',
	standardImageUrl: styles.herculesStandard,
	featureImageUrl: styles.herculesFeature,
	gameProviderId: 'reelplay',
	gameId: 'hercules10kways',
	tagLine: 'CONQUER THE REELS WITH HERCULES',
	infoModal: [
		'10,000 Ways to Win',
		'A Huge Possible 6,108x Maximum Win Potential',
		'Battle 4 Legendary Monsters',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const SLINGO_LIGHTNING: GapGameInfo = {
	displayName: 'Slingo Lightning',
	gameType: 'gap',
	standardImageUrl: styles.slingoLightningStandard,
	featureImageUrl: styles.slingoLightningFeature,
	gameProviderId: 'Gaming Realms',
	gameId: 'slingo-lightning-100x',
	tagLine: '50 BALL ELECTRIFYING SLINGO',
	infoModal: [
		'50 Ball Instead of the Usual 75 Ball Slingo',
		'Gold Super Wild and Silver Wild Bolts',
		'Infinite Amount of Extra Balls',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const VOLATILE_VIKINGS: GapGameInfo = {
	displayName: 'Volatile Vikings',
	gameType: 'gap',
	standardImageUrl: styles.volatileVikingsStandard,
	featureImageUrl: styles.volatileVikingsFeature,
	gameProviderId: 'relax',
	gameId: 'volatilevikings',
	tagLine: '6X5 REEL, SCATTER',
	infoModal: [
		'Multiplier Reveals Symbols, bearing a counter and multiplier value',
		'Landing 3 bonus symbols in the main game triggers 6 free spins',
		'Win up to 20,000 x play',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	providerGameId: 'volatileVikings'
}

const MONEY_TRAIN_2: GapGameInfo = {
	displayName: 'Money Train 2',
	gameType: 'gap',
	standardImageUrl: styles.moneyTrain2Standard,
	featureImageUrl: styles.moneyTrain2Feature,
	gameProviderId: 'relax',
	gameId: 'moneytrain2',
	tagLine: '5x4 REEL, 40 LINES',
	infoModal: [
		'Win up to 50,000x play amount',
		'Three or more scatters symbol triggers Money Cart bonus',
		'3 different bonus game features (the Collector, the Payer and the Sniper)',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	providerGameId: 'moneyTrain2'
}
const MONEY_TRAIN_3: GapGameInfo = {
	displayName: 'Money Train 3',
	gameType: 'gap',
	standardImageUrl: styles.moneyTrain3Standard,
	featureImageUrl: styles.moneyTrain3Feature,
	gameProviderId: 'relax',
	gameId: 'moneytrain3',
	tagLine: 'MAX WIN OF 100,000X',
	infoModal: [
		'High-Tech Future Theme: Take a futuristic train ride with laser beams and enjoy the third instalment of the popular Money Train series',
		'Base Game Re-Spin Feature: Triggered randomly, this feature allows you to select a symbol type to become sticky while landing multiplier symbols awards additional re-spins with values added to the final win amount',
		'Money Cart Bonus Round: Triggered by 3 or more bonus symbols, sticky bonus symbols and total multiplier. Hit max win of 100,000x with potential additional features',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	providerGameId: 'moneyTrain3'
}

const THE_GREAT_PIGSBY: GapGameInfo = {
	displayName: 'The Great Pigsby',
	gameType: 'gap',
	standardImageUrl: styles.theGreatPigsbyStandard,
	featureImageUrl: styles.theGreatPigsbyFeature,
	gameProviderId: 'relax',
	gameId: 'thegreatpigsby',
	tagLine: '5X3 REEL, 243 WAYS',
	infoModal: [
		'The Great Pigsby: A 5x3 slot game set in the 1930s with medium volatility',
		'Features: Expanding Wilds, Free Spins with Mystery Symbols, Wild Reel Re-Spins',
		'Piggybank Feature: Collect wild reels to trigger other features or affect the state of the piggy bank',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	providerGameId: 'theGreatPigsby'
}

const SNAKE_ARENA: GapGameInfo = {
	displayName: 'Snake Arena',
	gameType: 'gap',
	standardImageUrl: styles.snakeArenaStandard,
	featureImageUrl: styles.snakeArenaFeature,
	gameProviderId: 'relax',
	gameId: 'snakearena',
	tagLine: '5X5 REEL, 30 LINES',
	infoModal: [
		'Land the snakehead and the knight to trigger free spins',
		'1 to 5 reels become wild during the Wild Chase feature',
		'Win up to 2,758 x play',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	providerGameId: 'snakeArena'
}

const BETTER_WILDS: GapGameInfo = {
	displayName: 'Better Wilds',
	gameType: 'gap',
	standardImageUrl: styles.betterWildsStandard,
	featureImageUrl: styles.betterWildsFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_betwilds_pop',
	tagLine: 'WANDERING WILDS',
	infoModal: [
		'Re-spins: Triggered by SPECIAL WILD on reels 3, 4, or 5',
		'SPECIAL WILDS move left and expand during re-spins',
		'Landing extra SPECIAL WILDs retriggers the feature',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const LETS_GET_READY_TO_RUMBLE: GapGameInfo = {
	displayName: 'Lets Get Ready To Rumble',
	gameType: 'gap',
	gameId: 'rumble',
	standardImageUrl: styles.letsGetReadyToRumbleStandard,
	featureImageUrl: styles.letsGetReadyToRumbleFeature,
	gameProviderId: 'relax',
	tagLine: 'WIN UP TO 2,389X',
	infoModal: [
		'Sticky Spin: Lock winning symbols for re-spins.',
		'Wild Stacks: Surprise Wild Stacks fill entire columns.',
		'Special Rumble Spin: Trigger various enhancements in one spin.',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const MOON_OF_THOTH: GapGameInfo = {
	displayName: 'Moon of Thoth',
	gameType: 'gap',
	gameId: 'MOON_OF_THOTH',
	standardImageUrl: styles.moonOfThothStandard,
	featureImageUrl: styles.moonOfThothFeature,
	gameProviderId: 'ggames',
	tagLine: 'UNVEIL LUNAR RICHES',
	infoModal: [
		'Mini jackpots: grand x1000, major x500, minor x200, mini x100',
		'Moon re-spin bonus activated when you land six or more moon symbols',
		'Free Spins with sticky wilds featuring multipliers',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const ZOMBIE_CIRCUS: GapGameInfo = {
	displayName: 'Zombie Circus',
	gameType: 'gap',
	standardImageUrl: styles.zombieCircusStandard,
	featureImageUrl: styles.zombieCircusFeature,
	gameProviderId: 'relax',
	gameId: 'zombiecircus',
	tagLine: 'WIN UP TO X10,587 - CIRCUS CHILLS!',
	infoModal: [
		'Embrace the eerie world of ghouls in an action-packed 5x3 video slot with a heart-pounding 10-winline setup and a thrilling pick-one zombie-slaying bonus round',
		'Trigger the Bonus Game with 3 Bonus symbols on reels 1, 3, and 5. Reel 5 features stacked Bonus Symbols, determining the number of zombie waves: 3 symbols = 2 waves, 4 symbols = 3 waves, and 5 symbols = 4 waves. Pick 5 zombies to reveal free spins and transform a standard symbol into a wild for bigger wins.',
		'Re-trigger Thrills - Watch for bonus symbols on reels 1, 3, and 5 during free spins. Re-ignite Zombie Waves for more spins and another converted symbol, increasing your chances of winning big!',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const BANANA_TOWN: GapGameInfo = {
	displayName: 'Banana Town',
	gameType: 'gap',
	gameId: 'bananatown',
	standardImageUrl: styles.bananaTownStandard,
	featureImageUrl: styles.bananaTownFeature,
	gameProviderId: 'relax',
	tagLine: 'MAX WIN OF 10,000X',
	infoModal: [
		'Where the wins keep multiplying',
		'Free spins and multiplier upgrades galore',
		'Win up to 10,000x your play amount',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const TITAN_STRIKE: GapGameInfo = {
	displayName: 'Titan Strike',
	gameType: 'gap',
	gameId: 'titanstrike',
	standardImageUrl: styles.titanStrikeStandard,
	featureImageUrl: styles.titanStrikeFeature,
	gameProviderId: 'relax',
	tagLine: 'UNLEASH THE POWER OF OLYMPUS!',
	infoModal: [
		'Embark on a mythical quest within "Titan Strike," and prepare to face the mighty Zeus himself in this electrifying slot adventure.',
		'Trigger lightning strikes with Lightning Strike symbols on reels 2, 3, and 4, and win up to 2000 times your play amount.',
		'A unique Collection Feature that offers divine rewards and extra spins',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const SULTAN_SPINS: GapGameInfo = {
	displayName: 'Sultan Spins',
	gameType: 'gap',
	gameId: 'sultanspins',
	standardImageUrl: styles.sultanSpinsStandard,
	featureImageUrl: styles.sultanSpinsFeature,
	gameProviderId: 'relax',
	tagLine: 'DISCOVER RICHES FIT FOR ROYALTY',
	infoModal: [
		'New and Exclusive to Global Poker and Chumba Casino',
		'5 Different Jackpots to Win',
		'Up to a 8x Multiplier during Free Spins',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}


const SANTAS_STACK: GapGameInfo = {
	displayName: 'Santas Stack',
	gameType: 'gap',
	gameId: 'santasstack',
	standardImageUrl: styles.santasStackStandard,
	featureImageUrl: styles.santasStackFeature,
	gameProviderId: 'relax',
	tagLine: 'WIN UP TO A HUGE 20,000X',
	infoModal: [
		'Secret Santa Re-Spin: Wild symbols create mystery symbols, leading to re-spins with held symbols.',
		'Free Spins: Land 3+ Christmas Tree Bonus symbols to trigger 5 Free Spins. Wild symbols at the start boost chances for Secret Santa Re-Spins. Collect up to 8 free spins.',
		'Massive Wins: Achieve 20,000x your play amount during Free Spins for an extraordinary reward.',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const FOUR_FANTASTIC_FISH_GOLD: GapGameInfo = {
	displayName: '4 Fantastic Fish Gold',
	gameType: 'gap',
	gameId: '4fantasticfishgold',
	standardImageUrl: styles.fourFantasticFishGoldStandard,
	featureImageUrl: styles.fourFantasticFishGoldFeature,
	gameProviderId: 'relax',
	tagLine: 'THE BIGGER THE REEL, THE BIGGER THE DEAL!',
	infoModal: [
		'Golden Catch Prizes: Line up Fish symbols for instant coin wins that scale with every reel, climbing all the way to huge fifty times awards on reel six.',
		'Boosting Fortune Chase: Land Tokens to power up the Big, Super, Mega, and Ultra Fortunes, then take a spin on the Fortune Wheel for a shot at instant prize drops.',
		'Deep Sea Re-spins: Lock Fish symbols, reset the counter with every new catch, and let the Shark combine and double full reels as you unlock new reels for even bigger deep sea hauls.',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
}

const TSAI_SHEN_10K: GapGameInfo = {
	displayName: 'Tsai Shen 10k Ways',
	gameType: 'gap',
	standardImageUrl: styles.tsaiShenStandard,
	featureImageUrl: styles.tsaiShenFeature,
	gameProviderId: 'reelplay',
	gameId: 'tsaishen10kways',
	tagLine: '10,000 WAYS TO PROSPERITY',
	infoModal: [
		'10,000 Ways to Win',
		'Bonus Re-Spin Feature',
		'Mini, Minor, Major and Grand Jackpots',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const ADVENTURE_TRAIL: GapGameInfo = {
	displayName: 'Adventure Trail',
	gameType: 'gap',
	standardImageUrl: styles.adventureTrailStandard,
	featureImageUrl: styles.adventureTrailFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_atrail_pop',
	tagLine: 'EXPLORE AND WIN BIG',
	infoModal: [
		'Major, Minor, and Mini Jackpot Prizes',
		'Up to 2,000x your Play Amount',
		'Stacked Wilds and Free Spins',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const LIL_DEMON_GOLD_HIT: GapGameInfo = {
	displayName: 'Lil Demon Gold Hit',
	gameType: 'gap',
	standardImageUrl: styles.lilDemonGoldHitStandard,
	featureImageUrl: styles.lilDemonGoldHitFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_ghitdev_pop',
	tagLine: 'FIREY WINS AWAIT',
	infoModal: [
		'Gold Hit Feature: Lock in Coin symbols for multiplying rewards and special jackpots',
		'Free Games: Trigger with BONUS symbols and fill reels to increase potential winnings',
		'Demon\'s Feature: On any spin the Demon may shower the reels with extra Coin symbols, Bonus symbols, and Collect All coins',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const THREE_WIZARDS: GapGameInfo = {
	displayName: '3 Wizards',
	gameType: 'gap',
	standardImageUrl: styles.threeWizardsStandard,
	featureImageUrl: styles.threeWizardsFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_3wizards_pop',
	tagLine: 'SPELLBINDING RICHES AWAIT',
	infoModal: [
		'Wild Wizards Feature: Red, Green, and Blue Wizards transform entire reels into wilds for massive wins',
		'Tree Features: Activate with Castle Scatters to unlock free spins with extra wilds',
		'Mega Fire Blaze: Land 6+ Orbs for re-spins and jackpot prizes up to 2,000x your play amount'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const GOLD_TRIO: GapGameInfo = {
	displayName: 'Gold Trio: Sinbad’s Riches',
	gameType: 'gap',
	standardImageUrl: styles.goldTrioSinbadRichesStandard,
	featureImageUrl: styles.goldTrioSinbadRichesFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_ctrpl_pop',
	tagLine: 'DISCOVER SINBAD’S RICHES',
	infoModal: [
		'Gold Trio Re-spins: Triggered by Coloured Coins, locking into place for re-spins',
		'Blue Coin: Reveals prizes, transforming into Mini (10x), Minor (20x), or Major (50x) rewards',
		'Red & Green Coins: Red doubles coin values; Green sums all locked coin values'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const CHEERS: GapGameInfo = {
	displayName: 'Cheers',
	gameType: 'gap',
	standardImageUrl: styles.cheersStandard,
	featureImageUrl: styles.cheersFeature,
	gameProviderId: 'gas',
	gameId: 'ad-cheers',
	tagLine: 'SAM-SATIONAL',
	infoModal: [
		'Sticky Wild Re-spin: Wilds nudge to fill reel 2, with re-spins and bonus wheel features',
		'Norm’s Enormous Wins: Match cards to win Mini, Minor, or Mega jackpots',
		'Frasier’s Free Spins: 10 free spins with enhanced Sticky Wild Re-spins and bonus opportunities'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const GODDESS_OF_THE_SEA: GapGameInfo = {
	displayName: 'Goddess of the Sea',
	gameType: 'gap',
	standardImageUrl: styles.goddessOfTheSeaStandard,
	featureImageUrl: styles.goddessOfTheSeaFeature,
	gameProviderId: 'gas',
	gameId: 'queen-of-the-sea',
	tagLine: 'UNCOVER OCEANIC RICHES',
	infoModal: [
		'Underwater Adventure: Explore a sea-themed 5-reel, 3-row, 20-line slot',
		'Free Spins Feature: Trigger 10, 15, or 25 free games with 3, 4, or 5 scatters; reels 4 and 5 turn wild',
		'Progressive Jackpots: Climb the play level ladder to unlock Mini, Minor, Major, and Grand jackpots'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const JP_BACON_AND_CO_GOLD_HIT_AND_LINK: GapGameInfo = {
	displayName: 'JP Bacon and Co Gold Hit and Link',
	gameType: 'gap',
	standardImageUrl: styles.jpBaconAndCoGoldHitAndLinkStandard,
	featureImageUrl: styles.jpBaconAndCoGoldHitAndLinkFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_goldh4_pop',
	tagLine: 'BRING HOME THE BACON',
	infoModal: [
		'Gold Hit Feature: Lock Coin symbols, reset counters, and collect prizes on filled reels',
		'Free Games: Trigger with 3+ BONUS symbols for up to 15 free games with locked Coin symbols and multiplier wheel',
		'Gold Link Feature: Collect Gold Link coins to unlock rows, re-spins, and multipliers up to 10x or major prizes'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const SLINGO_SUPER_SPIN: GapGameInfo = {
	displayName: 'Slingo Super Spin',
	gameType: 'gap',
	standardImageUrl: styles.slingoSuperSpinStandard,
	featureImageUrl: styles.slingoSuperSpinFeature,
	gameProviderId: 'Gaming Realms',
	gameId: 'slingo-superspin',
	tagLine: 'SPIN, DANCE, AND WIN!',
	infoModal: [
		'6th Bonus Reel: Adds an exciting twist to the classic Slingo experience',
		'Mark Numbers: Complete lines on the 5x5 grid to climb the prize ladder',
		'Super Wilds: Use the gold disc Super Wild to mark any position and boost your chances'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const CASINO_WIZARD_CRAPS: GapGameInfo = {
	displayName: 'Casino Wizard Craps',
	gameType: 'gap',
	standardImageUrl: styles.casinoWizardCrapsStandard,
	featureImageUrl: styles.casinoWizardCrapsFeature,
	gameProviderId: 'Gaming Arts',
	gameId: 'cw-craps',
	tagLine: 'STEP RIGHT UP AND ROLL THE DICE',
	infoModal: [
		'Pass Line and Don\'t Pass: Win on a 7 or 11, or establish a Point; Don\'t Pass wins on a 2, 3, or 12',
		'Place Field Options: Choose your lucky total (4, 5, 6, 8, 9, or 10) and win on your roll, avoiding a 7',
		'Hardways and Any Craps: Predict specific dice combinations or win with a roll of 2, 3, or 12'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'table',
}

const CASINO_CRAPS_2025: GapGameInfo = {
	displayName: 'Craps',
	gameType: 'gap',
	standardImageUrl: styles.casinoCraps2025Universal,
	featureImageUrl: styles.casinoCraps2025Universal,
	gameProviderId: 'vgw',
	gameId: 'craps2025',
	tagLine: 'STEP RIGHT UP!',
	infoModal: [
		'Experience the thrill of the casino floor anywhere, with the classic dice game brought online.',
		'Modern look, timeless excitement: A sleek, redesigned interface keeps the fast-paced action of traditional Craps alive and easy to play.',
		'Multiple ways to win, from Pass Line to Hardways and Horn options, enjoy a wide range of options styles and strategies to suit every player.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	filteredGameType: 'table',
}

const BUCKS_AND_DOE: GapGameInfo = {
	displayName: 'Bucks and Doe 10K Ways',
	gameType: 'gap',
	standardImageUrl: styles.bucksAndDoeStandard,
	featureImageUrl: styles.bucksAndDoeFeature,
	gameProviderId: 'gas',
	gameId: 'bucksanddoe10kways',
	tagLine: 'HUNT FOR BIG WINS',
	infoModal: [
		'Every spin offers 10,000 ways to win, with cascading reels for continuous action',
		'Thrilling Bonus Re-spins: Triggered by 3+ SCATTER symbols, featuring DEER, ELK, and MOOSE prizes up to 200x',
		'Wild Hunting Adventure: Stunning visuals in this captivating wilderness adventure'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const PROFESSORS_CLANKS_COMBINATOR: GapGameInfo = {
	displayName: 'Professor Clanks Combinator',
	gameType: 'gap',
	standardImageUrl: styles.professorClanksCombinatorStandard,
	featureImageUrl: styles.professorClanksCombinatorFeature,
	gameProviderId: 'gas',
	gameId: 'professorclankscombinator',
	tagLine: 'GEAR UP FOR STEAMPUNK WINS',
	infoModal: [
		'Non-winning symbols after each win, then merge multiple symbols into the highest value type and boost adjacent symbols for bigger wins',
		'Bonus Re-spins: Triggered by 5+ scatters, awarding up to 2,000x your spin amount, with symbols dropping and locking for more chances to win',
		'A steampunk slot with innovative mechanics and endless winning possibilities'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const MONEY_MARIACHI_INFINITY_REELS: GapGameInfo = {
	displayName: 'Money Mariachi Infinity Reels',
	gameType: 'gap',
	standardImageUrl: styles.moneyMariachiStandard,
	featureImageUrl: styles.moneyMariachiFeature,
	gameProviderId: 'gas',
	gameId: 'moneymariachiinfinityreels',
	tagLine: 'INFINITE WINS',
	infoModal: [
		'Each win adds a reel, increasing the multiplier by +1 and potentially awarding the 888x Infinity Bonus',
		'Level Up Re-spins: Triggered by 3+ Shrine scatters, with sticky symbols and increasing prizes as you fill and expand the grid',
		'Special Modifier Symbols: Unique Grower, Freezer, Booster, and Charmer symbols enhance your re-spins with additional multipliers and benefits'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const SHRINE_OF_ANUBIS_GOLD_HIT: GapGameInfo = {
	displayName: 'Shrine of Anubis Gold Hit',
	gameType: 'gap',
	standardImageUrl: styles.shrineOfAnubisGoldHitStandard,
	featureImageUrl: styles.shrineOfAnubisGoldHitFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_goldhit2_pop',
	tagLine: 'GOLD HITS AND ANCIENT RICHES',
	infoModal: [
		'Gold Hit Feature: Lock Prize Coins and Scarab symbols to trigger reel-specific prizes before the countdown ends, with chances for Mega, Major, Minor, or Mini rewards',
		'Collect symbols for instant prizes or fill reels in Free Games to activate a multiplier wheel',
		'Venture into the realm of Anubis with 4608 ways to win, where each spin promises excitement and potential riches'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const FIRE_BLAZE_QUATTRO_CELTIC_CHARM: GapGameInfo = {
	displayName: 'Fire Blaze Quattro: Celtic Charm',
	gameType: 'gap',
	standardImageUrl: styles.fireBlazeQuattroCelticCharmStandard,
	featureImageUrl: styles.fireBlazeQuattroCelticCharmFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_qccharm_pop',
	tagLine: 'FULL OF CELTIC CHARM',
	infoModal: [
		'Quattro Reel Experience: Celtic charm with four sets of reels, each offering 3 reels, 3 rows, and 27 ways to win',
		'Trigger Free Games with Scatter symbols, expanding gameplay to 6 reels and 46,656 ways to win',
		'Fire Blaze Hold & Re-spin: Chances to win Mini, Minor, Major, or the grand prizes by filling the screen'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const THOR_10K_WAYS: GapGameInfo = {
	displayName: 'Thor 10k Ways',
	gameType: 'gap',
	standardImageUrl: styles.thorStandard,
	featureImageUrl: styles.thorFeature,
	gameProviderId: 'reelplay',
	gameId: 'thor10kways',
	tagLine: 'HAMMER YOUR WAY TO VICTORY',
	infoModal: [
		'Epic Bonus Respins: Triggered by 6+ Hammer symbols, resetting with each new Hammer for big wins',
		'Colossal Prizes: Win up to 10,000×, plus Grand, Major, Minor, and Mini prizes',
		'Norse-Themed Adventure: Enjoy stunning visuals and captivating gameplay inspired by Norse mythology'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const THOR_INFINITY_REELS: GapGameInfo = {
	displayName: 'Thor Infinity Reels',
	gameType: 'gap',
	standardImageUrl: styles.thorInfinityReelsStandard,
	featureImageUrl: styles.thorInfinityReelsFeature,
	gameProviderId: 'reelplay',
	gameId: 'thorinfinityreels',
	tagLine: 'UNLEASH LIMITLESS POWER',
	infoModal: [
		'Infinite Reel Action: Watch as reels multiply infinitely, enhancing symbol combinations and awards with every spin',
		'Each added reel increases the Symbol Multiplier',
		'Bonus Re-spins: Triggered by 6+ Hammer symbols, these re-spins can expand reels and award massive wins, including the coveted Infinity Bonus'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const JOHN_WAYNE_10K_WAYS: GapGameInfo = {
	displayName: 'John Wayne 10K Ways',
	gameType: 'gap',
	standardImageUrl: styles.johnWayneStandard,
	featureImageUrl: styles.johnWayneFeature,
	gameProviderId: 'reelplay',
	gameId: 'johnwayne10kways',
	tagLine: 'SADDLE UP FOR AN EPIC ADVENTURE',
	infoModal: [
		'10,000 ways to win on every spin with cascading reels that extend winning chains',
		'John Wayne Re-spins: Triggered by 6+ SCATTER symbols, resetting with each new SCATTER for bigger prizes',
		'Jackpot Prizes: Win up to 2,000× with Grand, Major, Minor, and Mini jackpot prizes during re-spins'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const MACABRA_LINX: GapGameInfo = {
	displayName: 'Macabra LinX',
	gameType: 'gap',
	standardImageUrl: styles.macabraLinxStandard,
	featureImageUrl: styles.macabraLinxFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_mabralinx_pop',
	tagLine: 'FOLLOW THE X FOR RICH REWARDS',
	infoModal: [
		'Wild LinX Feature: Triggered by landing Circle, X, or GOLD X symbols on all five reels for multiplier prizes and jackpots',
		'Free Games: Choose between Mega Symbol Free Games with colossal reels or X Free Games with higher chances of Wild LinX',
		'Increased Wild LinX Chance: Activate this mode for a higher chance to trigger the Wild LinX Feature and access the Re-spin Feature'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const KENO_POP: GapGameInfo = {
	displayName: 'Keno Pop',
	gameType: 'gap',
	standardImageUrl: styles.kenoPopStandard,
	featureImageUrl: styles.kenoPopFeature,
	gameProviderId: '1X2',
	gameId: '2065',
	tagLine: 'A KENO CLASSIC',
	infoModal: [
		'Classic Keno Gameplay: Select 1 to 15 numbers and match them with 20 drawn balls to win up to 10,000× your play amount',
		'Modern Twist: Enjoy a simplified, fast-paced version of Keno with vibrant visuals and dynamic win tables',
		'Easy to Play: Choose your lucky numbers, watch the balloons pop, and see your winnings accumulate with each draw'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'instant-win',
}

const MEGA_MONEY_MACHINE: GapGameInfo = {
	displayName: 'Mega Money Machine',
	gameType: 'gap',
	standardImageUrl: styles.megaMoneyMachineStandard,
	featureImageUrl: styles.megaMoneyMachineFeature,
	gameProviderId: 'reelplay',
	gameId: 'megamoneymachine',
	tagLine: 'WIN WHAT YOU SEE!',
	infoModal: [
		'Combine numbers on the center win line to form your final prize, turning every spin into a potential jackpot',
		'Reels with 0 or 00 shift to the right, maximizing your chances to land higher numbers and boost your winnings',
		'Choose between 3-Reel Mode or 4-Reel Mode for an additional reel and bigger win potential'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	overlayClockPositionOnMobile: 'top-left'
}

const BIG_BUCKS_BISON_10K_WAYS: GapGameInfo = {
	displayName: 'Big Bucks Bison 10K Ways',
	gameType: 'gap',
	standardImageUrl: styles.bigBucksBisonStandard,
	featureImageUrl: styles.bigBucksBisonFeature,
	gameProviderId: 'reelplay',
	gameId: 'bigbucksbison10kways',
	tagLine: 'STAMPEDE FOR BIG WINS!',
	infoModal: [
		'Spin for endless excitement with 10,000 winning possibilities and cascading reels',
		'Trigger 6+ COIN symbols for re-spins and win up to 10,000x your play amount',
		'Near Miss Bonus, triggered when 5 COIN symbols land after a cascade'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	overlayClockPositionOnMobile: 'top-left'
}

const FRUIT_COMBINATOR: GapGameInfo = {
	displayName: 'Fruit Combinator',
	gameType: 'gap',
	standardImageUrl: styles.fruitCombinatorStandard,
	featureImageUrl: styles.fruitCombinatorFeature,
	gameProviderId: 'reelplay',
	gameId: 'fruitcombinator',
	tagLine: 'BURST OF FRUITY EXCITEMENT!',
	infoModal: [
		'Spin on a 6x3 grid with up to 707 adjacent ways to win, enhanced by cascading reels',
		'Trigger Explosions, Morphs, and Boosters for continuous wins, with symbols dropping and transforming for maximum rewards',
		'Land 3+ SCATTERs to unlock Free Games and win up to 2,000x your total play amount'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	overlayClockPositionOnMobile: 'top-left'
}

const WEST_COAST_CASH_INFINITY_REELS: GapGameInfo = {
	displayName: 'West Coast Cash Infinity Reels',
	gameType: 'gap',
	standardImageUrl: styles.westCoastCashInfinityReelsStandard,
	featureImageUrl: styles.westCoastCashInfinityReelsFeature,
	gameProviderId: 'reelplay',
	gameId: 'westcoastcashinfinityreels',
	tagLine: 'RIDE THE REELS, RULE THE STREETS!',
	infoModal: [
		'Start with 3 reels and keep adding more with each winning spin, offering limitless potential for expanding wins',
		'Score an 888x win when you expand to 12+ reels in a single spin',
		'Land 3+ CASH symbols to trigger re-spins, level up symbols, and unlock special bonuses symbols'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	overlayClockPositionOnMobile: 'top-left'
}

const BINGO_75: GapGameInfo = {
	displayName: 'Bingo 75',
	gameType: 'gap',
	standardImageUrl: styles.bingo75Standard,
	featureImageUrl: styles.bingo75Feature,
	gameProviderId: 'ggames',
	gameId: 'BINGO_75',
	tagLine: 'CLICK, DAB, WIN!',
	infoModal: [
		'Maximize your winning potential by managing multiple tickets at once, increasing your chances of hitting big',
		'Score up to 5,000× your play amount by completing the exhilarating Full House pattern on your bingo card',
		'Speed up the action with the Quick Play option, bringing faster draws and instant results to every game'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	filteredGameType: 'bingo',
}

const CALAVERA_BINGO: GapGameInfo = {
	displayName: 'Calavera Bingo',
	gameType: 'gap',
	standardImageUrl: styles.calaveraBingoStandard,
	featureImageUrl: styles.calaveraBingoFeature,
	gameProviderId: 'ggames',
	gameId: 'CALAVERA_BINGO',
	tagLine: 'SPIN, WIN, FIESTA!',
	infoModal: [
		'Play Up to 4 Tickets Simultaneously: Increase your chances of winning big by managing multiple tickets in this vibrant Day of the Dead celebration',
		'Hit the elusive plane pattern for a spin on the Bonus Wheel, with a chance to win up to 10,000× your play amount',
		'Use free balls and Joker Balls to boost your chances of completing patterns and hitting the ultimate Full House bingo for 1,500× rewards'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	filteredGameType: 'bingo',
}

const SEASONS_JOY: GapGameInfo = {
	displayName: 'Season\'s Joy',
	gameType: 'gap',
	standardImageUrl: styles.seasonsJoyUniversal,
	featureImageUrl: styles.seasonsJoyUniversal,
	gameProviderId: 'gfs',
	gameId: 'seasons-joy',
	tagLine: 'CHRISTMAS CHEER IN EVERY SPIN',
	infoModal: [
		'Game Layout: 5x3 reels with 9 winlines.',
		'Pick Bonus Feature: Land 3+ Scatters (Gift Boxes) to trigger the Pick Bonus and reveal prizes.',
		'Festive Theme: Enjoy Christmas-themed visuals and audio that bring holiday magic to the reels.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: true,
}

const ROCKY_HORROR_SHOW: GapGameInfo = {
	displayName: 'Rocky Horror Show',
	gameType: 'gap',
	standardImageUrl: styles.rockyHorrorShowStandard,
	featureImageUrl: styles.rockyHorrorShowFeature,
	gameProviderId: 'Fantasma Gaming',
	gameId: 'rocky-horror-show',
	tagLine: 'LET’S DO THE TIME WARP AGAIN!',
	infoModal: [
		'Hold and Win Re-spins: Land 6+ H&W symbols to trigger 3 re-spins with locked symbols; fill all 15 spots for a monstrous reward.',
		'Jackpots: Win Mini, Maxi, or Mega Jackpots during Hold and Win Re-spins, worth up to 1000x your spin amount.',
		'Mega Free Spins: Land 3+ Scatters for 5 Mega Free Spins with a 3x3 Mega Reel and a chance to unlock Hold and Win Re-spins.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
}

const RED_WIZARD: GapGameInfo = {
	displayName: 'Red Wizard',
	gameType: 'gap',
	standardImageUrl: styles.redWizardStandard,
	featureImageUrl: styles.redWizardFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_rwizard_pop',
	tagLine: 'MAGIC AND WINS WITH EVERY SPIN',
	infoModal: [
		'Free Games Feature: Land 3+ Scatters for 6 Free Games with Wild multipliers and the chance to retrigger with additional Scatters.',
		'Fire Blaze Re-Spin Feature: Land 7+ FLAMING BALL symbols to trigger 3 re-spins with held symbols and the potential for GRAND, MAJOR, MINOR, or MINI prizes.',
		'Unique Reel Set: Enjoy a 3-4-4-4-3 reel layout that adds variety and surprises to every spin.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const FESTIVAL_10K_WAYS: GapGameInfo = {
	displayName: 'Festival 10K Ways',
	gameType: 'gap',
	standardImageUrl: styles.festivalStandard,
	featureImageUrl: styles.festivalFeature,
	gameProviderId: 'reelplay',
	gameId: 'festival10kways',
	tagLine: 'PROSPERITY AWAITS!',
	infoModal: [
		'6 reels, 10,000 ways to win, with cascading symbols and a max win of 12,309x.',
		'Trigger Bonus Re-spins with 6+ SCATTERs and win up to 10,000x.',
		'WILD LION substitutes on the top reel, boosting cascading wins.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	overlayClockPositionOnMobile: 'top-left'
}

const GEMS_INFINITY_REELS: GapGameInfo = {
	displayName: 'Gems Infinity Reels',
	gameType: 'gap',
	standardImageUrl: styles.gemsInfinityReelsStandard,
	featureImageUrl: styles.gemsInfinityReelsFeature,
	gameProviderId: 'reelplay',
	gameId: 'gemsinfinityreels',
	tagLine: 'EXPAND REELS, EXPAND REWARDS!',
	infoModal: [
		'Expand reels endlessly with Infinity Reels and 4 unique reel sets.',
		'Wild Princesses substitute symbols and double wins in their reel sets.',
		'Unlock all reel sets and win up to 888x your play amount in Free Spins.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	overlayClockPositionOnMobile: 'top-left'
}

const STAR_TREK_THE_NEXT_GENERATION: GapGameInfo = {
	displayName: 'Star Trek The Next Generation',
	gameType: 'gap',
	standardImageUrl: styles.starTrekTheNextGenerationStandard,
	featureImageUrl: styles.starTrekTheNextGenerationFeature,
	gameProviderId: 'Atlantic Digital',
	gameId: 'star-trek',
	tagLine: 'MAKE IT SO!',
	infoModal: [
		'Every win cascades new symbols for consecutive rewards in a single spin.',
		'Choose from varied Free Spins options with multipliers, or a surprise mystery choice.',
		'Reach up to 10,000x your play amount with the three-level Warp Wheel for ultimate prizes!'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const FOUR_FANTASTIC_LOBSTERS: GapGameInfo = {
	displayName: '4 Fantastic Lobsters',
	gameType: 'gap',
	standardImageUrl: styles.fourFantasticLobstersStandard,
	featureImageUrl: styles.fourFantasticLobstersFeature,
	gameProviderId: 'Gaming Realms',
	gameId: 'slots-4fantasticlobsters',
	tagLine: 'REEL IN BIG CLAW-SOME WINS!',
	infoModal: [
		'Lobster symbols unlock progressive coin prizes from left to right, including four grand Lobster Prizes.',
		'Collect coin prizes in the re-spin bonus, with a Shark doubling wins when reels fill.',
		'Crabs can add new coin prizes, and the Giant Squid can create even bigger wins!'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const PIN_RUSH: GapGameInfo = {
	displayName: 'Pin Rush',
	gameType: 'gap',
	standardImageUrl: styles.pinRushStandard,
	featureImageUrl: styles.pinRushFeature,
	gameProviderId: '1X2',
	gameId: '22020',
	tagLine: 'DROP, BOUNCE, WIN!',
	infoModal: [
		'Adjust rows, volatility, and board size for a tailored play style.',
		'Balls descend, bouncing off pegs to land in multiplier buckets, with prizes up to 420x.',
		'Each round offers fresh excitement as balls bounce off pegs, building anticipation with every drop.'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'instant-win',
}

const MEGA_FIRE_BLAZE_DWARVES_AND_GOBLINS: GapGameInfo = {
	displayName: 'Mega Fire Blaze: Dwarves and Goblins',
	gameType: 'gap',
	standardImageUrl: styles.megaFireBlazeDwarvesAndGoblinsStandard,
	featureImageUrl: styles.megaFireBlazeDwarvesAndGoblinsFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_mfbdag_pop',
	tagLine: 'DIG FOR GOLD!',
	infoModal: [
		'Land SCATTER symbols to unlock Free Games, where Gold Nuggets reveal coin prizes or transform into major jackpots.',
		'Expand the reels with extra rows and uncover Treasure Chests holding up to 2,000x your play amount.',
		'Dwarves collect and double Gold Nuggets, while Goblins add extra prizes for bigger rewards.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const TOIN_OF_GOLD: GapGameInfo = {
	displayName: 'Toin of Gold',
	gameType: 'gap',
	standardImageUrl: styles.toinOfGoldStandard,
	featureImageUrl: styles.toinOfGoldFeature,
	gameProviderId: 'vgw',
	gameId: 'toin-of-gold',
	tagLine: 'MISCHIEF AND MAGIC',
	infoModal: [
		'Shakey Shakey Wilds add random wilds or scatters to the base game reels.',
		'Trigger Free Spins Galore—land 3, 4, or 5 scatters for 10, 15, or 20 free spins.',
		'Lock in sticky Wild Reels during Free Spins as Reel 2 holds three wilds for the entire feature.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const HIT_BAR_GOLD: GapGameInfo = {
	displayName: 'Hit Bar: Gold',
	gameType: 'gap',
	standardImageUrl: styles.hitBarGoldStandard,
	featureImageUrl: styles.hitBarGoldFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_hitbargl_pop',
	tagLine: 'CLIMB THE LADDER, WIN BIG!',
	infoModal: [
		'Lock in HIT BAR symbols for re-spins, filling the screen for a GRAND prize of 1,000x.',
		'Climb the prize ladder to spin Blue, Purple, or Red Wheels for multipliers, free games, or jackpot prizes.',
		'Collect HIT BAR symbols in free games to climb the ladder for increasing rewards and extra spins.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
}

const THE_GREAT_GENIE: GapGameInfo = {
	displayName: 'The Great Genie',
	gameType: 'gap',
	standardImageUrl: styles.theGreatGenieStandard,
	featureImageUrl: styles.theGreatGenieFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_gegenie_pop',
	tagLine: 'REEL WISHES',
	infoModal: [
		'On-Reels Features: Genie grants random features like WILDs, colossal symbols, and more.',
		'Bonus Wheel: Land 3+ BONUS symbols to spin and win one of six exciting bonus features.',
		'Palace of Gold: Fill a 5x5 grid with prizes for a chance to win up to 2000x your play amount.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
}

const PROSPERITY_RICHES: GapGameInfo = {
	displayName: 'Prosperity Riches',
	gameType: 'gap',
	standardImageUrl: styles.prosperityRichesStandard,
	featureImageUrl: styles.prosperityRichesFeature,
	gameProviderId: 'vgw',
	gameId: 'prosperity-riches',
	tagLine: 'PICK YOUR FORTUNE',
	infoModal: [
		'Shake Shake Features: Watch the Money Tree rain coins or feel the Dragon roar big wins with thrilling effects.',
		'Lucky Coin Bonus: Win up to 11,000x, including Jackpots, multipliers, and exciting collection rewards.',
		'Player Choice Free Spins: Choose your play style with tailored Free Spins options.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const REELIN_N_ROCKIN_GAP: GapGameInfo = {
	displayName: 'Reelin n\' Rockin',
	gameType: 'gap',
	standardImageUrl: styles.reelinNRockinStandard,
	featureImageUrl: styles.reelinNRockinFeature,
	gameProviderId: 'gfs',
	gameId: 'reelin-n-rockin',
	providerGameId: 'reelinnRockin',
	tagLine: 'FIRESHOT JACKPOT',
	hasJackpot: true,
	useGapJackpot: true,
	jackpotName: 'reelinnRockin',
	jackpotToDisplay: 'grand',
	infoModal: [
		'Shared Fireshot Jackpot™ with Stampede Fury',
		'1950’s Diner themed slot',
		'Six or more record symbols trigger Fireshot feature',
		'Fill all positions with records to win Grand Jackpot',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	overlayClockPositionOnMobile: 'top-left',
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: false,
}

const STAMPEDE_FURY_GAP: GapGameInfo = {
	displayName: 'Stampede Fury',
	gameType: 'gap',
	standardImageUrl: styles.stampedeFuryStandard,
	featureImageUrl: styles.stampedeFuryFeature,
	gameProviderId: 'gfs',
	gameId: 'stampede-fury',
	providerGameId: 'stampedeFury',
	tagLine: 'FIRESHOT JACKPOT',
	hasJackpot: true,
	useGapJackpot: true,
	jackpotName: 'stampedeFury',
	jackpotToDisplay: 'grand',
	infoModal: [
		'Shared Fireshot Jackpot™ with Reelin N Rockin',
		'Buffalo themed slot',
		'Six or more coins offer three different feature options',
		'Fill all positions with coins to win Grand Jackpot',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	overlayClockPositionOnMobile: 'top-left',
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: false,
}

const DOUBLE_DIGGER: GapGameInfo = {
	displayName: 'Double Digger',
	gameType: 'gap',
	standardImageUrl: styles.doubleDiggerStandard,
	featureImageUrl: styles.doubleDiggerFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_dwpfb_pop',
	tagLine: 'GO DOUBLE WILD',
	infoModal: [
		'Expanding Reel Set: Unlock up to 1,944 ways to win in Free Games or via the Spin More Ways feature in the base game.',
		'Multiplier Rewards: Collect symbols and diamond multipliers in Free Games, with wins boosted by up to 10x.',
		'Jackpot Prizes: Land Mini, Minor, Major, or Grand Jackpots, offering prizes up to 500x your play amount.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
}

const SLINGO_GOLDEN_ENVELOPE: GapGameInfo = {
	displayName: 'Slingo Golden Envelope',
	gameType: 'gap',
	standardImageUrl: styles.slingoGoldenEnvelopeStandard,
	featureImageUrl: styles.slingoGoldenEnvelopeFeature,
	gameProviderId: 'Gaming Realms',
	gameId: 'slingo-goldenenvelope',
	tagLine: 'GOLDEN REWARDS',
	infoModal: [
		'Red Envelope Tree Bonus: Collect and pick your way to rewards up to 216x your play amount.',
		'Jackpot Excitement: Static Jackpots from 150x to 5000x, including the familiar Mini, Minor, Major tiers.',
		'Super Wild Features: Unlock extra numbers and climb the Prize Ladder with up to 40 additional spins.'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const TEN_THOUSAND_BASS_LIGHTNING_BLITZ: GapGameInfo = {
	displayName: '10,000 Bass Lightning Blitz',
	gameType: 'gap',
	standardImageUrl: styles.tenThousandBassLightningBlitzStandard,
	featureImageUrl: styles.tenThousandBassLightningBlitzFeature,
	gameProviderId: 'reelplay',
	gameId: 'tenthousandbasslightningblitz',
	tagLine: 'REEL IN BIG REWARDS',
	infoModal: [
		'10K Ways Mechanic: Enjoy 10,000 ways to win on every spin, offering endless opportunities for big prizes.',
		'Explosive Cascades: WILD and BASS symbols explode, unlocking new ways to win after each prize collection.',
		'Lightning Blitz Bonus: Trigger guaranteed WILDs on every Free Spin, boosting bonus win potential with every round.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	overlayClockPositionOnMobile: 'top-left'
}

const JUICE_TRIO_BONUS: GapGameInfo = {
	displayName: 'JUICE Trio Bonus',
	gameType: 'gap',
	standardImageUrl: styles.juiceTrioBonusStandard,
	featureImageUrl: styles.juiceTrioBonusFeature,
	gameProviderId: 'ggames',
	gameId: 'JUICE',
	tagLine: 'JACKPOTS ON THE DANCEFLOOR',
	infoModal: [
		'Retro Disco Vibes: 3 Pot Collection feature and vibrant bonus variations.',
		'Jackpot Wins: Land static Jackpots with fixed rewards.',
		'Stacked Wilds: Boost your chances with stackable wild symbols and regular bonus triggers.'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GOLD_HIT_OREILLYS_CHARMS: GapGameInfo = {
	displayName: 'Gold Hit: O\'Reilly\'s Charms',
	gameType: 'gap',
	standardImageUrl: styles.goldHitOReillysCharmsStandard,
	featureImageUrl: styles.goldHitOReillysCharmsFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_orwifefb_pop',
	tagLine: 'POTS OF GOLD',
	infoModal: [
		'Gold Hit Feature: Lock Coin symbols, reset countdowns, and fill reels to claim big prizes, including jackpots up to 500x.',
		'Free Games with Multipliers: Locked Coins stay in place, and full reels trigger multipliers up to ×10 for massive wins.',
		'Double Chance Feature Mode: Boost your chances of triggering Free Games with an extra lucky edge.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
}

const RAGING_RICHES: GapGameInfo = {
	displayName: 'Raging Riches',
	gameType: 'gap',
	standardImageUrl: styles.ragingRichesStandard,
	featureImageUrl: styles.ragingRichesFeature,
	gameProviderId: 'slotmill',
	gameId: 'raging-riches',
	tagLine: 'FRENZY OF FORTUNE',
	infoModal: [
		'5,488 Ways to Win: Spin on a dynamic 4-5-5-5-4 grid with expanding reels for even more chances.',
		'Fortune Frenzy Bonus: Collect Coins for rewards up to 250x, with a 5,000x Grand Prize for filling all cells.',
		'Free Spins with Multipliers: Trigger Free Spins featuring WILD multipliers of x2 or x3 for boosted wins.'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GOLDEN_DATE: GapGameInfo = {
	displayName: 'Golden Date',
	gameType: 'gap',
	standardImageUrl: styles.goldenDateStandard,
	featureImageUrl: styles.goldenDateFeature,
	gameProviderId: 'vgw',
	gameId: 'golden-date',
	tagLine: 'A DATE WITH DESTINY',
	infoModal: [
		'Golden Hearts Feature: Land up to 9 Golden Hearts anywhere on the reels for massive wins up to 2,000x your play amount.',
		'Unlimited Free Spins: Trigger Free Spins with the heart-shaped key and enjoy multipliers, with unlimited retriggers.',
		'Timeless Romance Theme: Indulge in luxury with elegant symbols like diamond rings, champagne glasses, and classic 777s.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
}

const FLUFFY_FAVOURITES: GapGameInfo = {
	displayName: 'Fluffy Favorites',
	gameType: 'gap',
	standardImageUrl: styles.fluffyFavouritesStandard,
	featureImageUrl: styles.fluffyFavouritesFeature,
	gameProviderId: 'eyecon',
	gameId: 'pop_48788d2a_eye',
	tagLine: 'PLUSHIES AND PRIZES',
	infoModal: [
		'Free Games Feature: Trigger up to 25 Free Games with Elephant symbols, and retrigger them up to 15 times for extended play.',
		'Grab-A-Fluffy Bonus: Land Claw symbols to activate prize picks, with rewards worth up to 100x your play amount.',
		'Elephant Wilds: Substitutes double your prize, boosting your wins while substituting other symbols.'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const SPINGOTTS: GapGameInfo = {
	displayName: 'Spingotts',
	gameType: 'gap',
	standardImageUrl: styles.spingottsStandard,
	featureImageUrl: styles.spingottsFeature,
	gameProviderId: 'ggames',
	gameId: 'SPINGOTTS',
	tagLine: 'UNLOCK THE VAULTS, UNLEASE THE MAGIC',
	infoModal: [
		'Enter the grand mystical bank: 3 Vault Collection feature and vibrant bonus variations.',
		'Jackpot Wins: Land static Jackpots with fixed rewards.',
		'Stacked Wilds: Boost your chances with stackable wild symbols and regular bonus triggers.'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const MERLINS_10K_WAYS: GapGameInfo = {
	displayName: 'Merlin\'s 10K Ways',
	gameType: 'gap',
	standardImageUrl: styles.merlinsStandard,
	featureImageUrl: styles.merlinsFeature,
	gameProviderId: 'reelplay',
	gameId: 'merlins10kways',
	tagLine: 'LET MERLIN’S MAGIC GUIDE YOU',
	infoModal: [
		'10K Ways to Win: Enjoy up to 10,000 ways to win, with explosive cascading reels.',
		'Bonus Re-Spins: Land 6+ SCATTER symbols to trigger re-spins with prizes up to 10,000x your play amount.',
		'Mystical Prizes: Win Mini, Minor, Major, or Grand prizes up to 2,000x.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const BUFFALO_BLITZ_2: GapGameInfo = {
	displayName: 'Buffalo Blitz 2',
	gameType: 'gap',
	standardImageUrl: styles.buffaloBlitz2Standard,
	featureImageUrl: styles.buffaloBlitz2Feature,
	gameProviderId: 'playtech',
	gameId: 'gpas_bblitz2_pop',
	tagLine: 'BUFFALOS ARE BACK!',
	infoModal: [
		'Diamond Wilds multiply wins by up to 5×, adding excitement to every spin.',
		'Land 3+ Scatters to unlock up to 100 Free Games.',
		'Free Games play on the expanded Ways Boost™ reels, offering up to 14,400 ways to win and the chance to retrigger up to 1,000 Free Games can be re-triggered.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const PYRAMID_LINX: GapGameInfo = {
	displayName: 'Pyramid LinX',
	gameType: 'gap',
	standardImageUrl: styles.pyramidLinxStandard,
	featureImageUrl: styles.pyramidLinxFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_plink_pop',
	tagLine: 'BOOK WINS OR WILD LINX!',
	infoModal: [
		'Wild LinX Feature: Land Circle, X, and Gold X symbols to claim coin prizes up to 2000×, with X symbols potentially upgrading for bigger rewards.',
		'Two Free Games Modes: Choose Book Free Games for expanding symbols or X Free Games for higher chances of triggering Wild LinX.',
		'Jackpot Potential: Gold X symbols reveal Mini, Minor, Major, or Grand prizes, with the Grand prize awarding 2000× your total play amount.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const TWENTYFOURK_GOLD_TIGER: GapGameInfo = {
	displayName: '24K Gold Tiger',
	gameType: 'gap',
	standardImageUrl: styles.twentyfourkGoldTigerStandard,
	featureImageUrl: styles.twentyfourkGoldTigerFeature,
	gameProviderId: 'hotrise',
	gameId: 'tiger24kgold',
	tagLine: 'ROAR INTO RICHES',
	infoModal: [
		'24K Gold Symbol: Bonus symbols trigger stacks of 3, boosting win potential with cascading action.',
		'Free Spins with Sticky Stacks: Land 3+ Bonus symbols to trigger 10 Free Spins, with Top Row stacks staying in place.',
		'Wild Stack Upgrades: New Bonus symbols turn stacks sticky, and existing stacks transform into Wilds for even bigger wins.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const CARIBBEAN_POKER_GAP: GapGameInfo = {
	displayName: 'Caribbean Poker',
	gameType: 'gap',
	standardImageUrl: styles.caribbeanPokerGasStandard,
	featureImageUrl: styles.caribbeanPokerGasFeature,
	gameProviderId: 'gas',
	gameId: 'caribbean-stud',
	tagLine: 'TABLE GAME',
	filteredGameType: 'table',
	infoModal: [
		'Caribbean Poker puts you head-to-head with the house—no bluffing, no mind games, just pure strategy and excitement. Perfect for online play!'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	overlayClockPositionOnDesktop: 'bottom-right',
	overlayClockPositionOnMobile: 'bottom-right'
}

const GOOOD_HEAVENS: GapGameInfo = {
	displayName: 'Goood Heavens',
	gameType: 'gap',
	standardImageUrl: styles.gooodHeavensStandard,
	featureImageUrl: styles.gooodHeavensStandard,
	gameProviderId: 'playtech',
	gameId: 'gpas_gdhvns_pop',
	tagLine: 'YEAR OF THE Horse!',
	infoModal: [
		'Red Horse Feature: Pick Gold Horses to reveal matching prizes, guaranteeing MINI, MINOR, MAJOR, or GRAND rewards up to 2000×.',
		'Green Horse Free Games: Trigger up to 10 Free Games with expanded reels, increasing ways to win up to 3125.',
		'Blue Horse Prize Wheel: Spin for instant coin prizes up to 120× or activate the Red or Green Horses features.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
}

const PAY_PIG: GapGameInfo = {
	displayName: 'Pay Pig',
	gameType: 'gap',
	standardImageUrl: styles.payPigStandard,
	featureImageUrl: styles.payPigFeature,
	gameProviderId: 'reelplay',
	gameId: 'paypig',
	tagLine: 'WALLOW IN WEALTH!',
	infoModal: [
		'Locked Reels: Every spin synchronizes 2, 3, or 4 reels, filling them with identical symbols for bigger wins.',
		'Bonus Re-Spins: Land 6+ PIG symbols to trigger re-spins, with the chance to form massive Big Pigs.',
		'Big Pig Multipliers: Merging PIG symbols creates Big Pigs, doubling multiplier values for huge rewards.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const LUCKY_CAT_FORTUNES: GapGameInfo = {
	displayName: 'Lucky Cat Fortunes',
	gameType: 'gap',
	standardImageUrl: styles.luckyCatFortunesStandard,
	featureImageUrl: styles.luckyCatFortunesFeature,
	gameProviderId: 'twofish',
	gameId: 'lucky-cat',
	tagLine: 'MANEKI-NEKO BECKONS!',
	infoModal: [
		'Free Spins with Wild Reels: Trigger up to 25 Free Spins, with reels 4 and 5 turning wild for bigger wins.',
		'Jackpot Wins: Land wins with the highlighted frame symbols to claim Mini, Minor, Major, or Grand jackpots up to 5,000x.',
		'Koi Symbol Bonus: Randomly triggers Free Spins, bringing extra surprises as the Maneki-Neko grows more prosperous.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const ALOHAWAII_COLLECT_EM: GapGameInfo = {
	displayName: 'Alohawaii Collect’Em',
	gameType: 'gap',
	standardImageUrl: styles.alohawaiiCollectEmStandard,
	featureImageUrl: styles.alohawaiiCollectEmFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_alohaccus_pop',
	tagLine: 'WELCOME TO PARADISE!',
	infoModal: [
		'Collect’Em™ Feature: Land a Collect’Em™ symbol on reel 5 to gather Coin Prizes, Free Games, or Diamond Prizes up to 500×.',
		'Diamond Prizes: Unlock MINI, MINOR, MAJOR, or GRAND prizes, with the chance to win multiple times during the Prize Drop Feature.',
		'Prize Drop Free Games: Collected Coin Prizes drop through a peg board, with chances to multiply wins up to three times per drop'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
}

const PIGGIES_AND_THE_BANK_MEGA_FIRE_BLAZE: GapGameInfo = {
	displayName: 'Piggies and The Bank Mega Fire Blaze',
	gameType: 'gap',
	standardImageUrl: styles.piggiesAndTheBankMfbStandard,
	featureImageUrl: styles.piggiesAndTheBankMfbFeature,
	gameProviderId: 'playtech',
	gameId: 'gpas_engage_pop',
	tagLine: 'CRACK OPEN THE PIGGY BANK!',
	infoModal: [
		'Gold Wild Re-spins: Stacked SPECIAL WILD symbols shift left across the reels, turning Coins into Wilds and retriggering spins.',
		'Free Games: Land 3+ SCATTERS for 8 Free Games where SPECIAL WILDS expand, activating Gold Wild Re-spins.',
		'Mega Fire Blaze Feature: Collect 6+ Coin Symbols for respins with locked prizes, reel expansions, and jackpots up to 2,000×.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const NINE_FLAGS_PATRIOT_PARTY: GapGameInfo = {
	displayName: '9 Flags Patriot Party',
	gameType: 'gap',
	standardImageUrl: styles.nineFlagsPatriotPartyStandard,
	featureImageUrl: styles.nineFlagsPatriotPartyFeature,
	gameProviderId: 'vgw',
	gameId: 'patriot-party',
	tagLine: 'EXPLOSIVE SPINS, PATRIOTIC WINS!',
	infoModal: [
		'Collect Red, White, and Blue Fireworks in the base game to trigger explosive effects and massive bonus potential.',
		'Blast off into Rocket Free Spins— With Extra Scatters, Double Wins, or Expanded Reels, or combine them all in the ultimate Patriot Party Free Spins!',
		'Land up to 15 flags for a scorching 5,000x max win!'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	showMuteButtonOverlay: true,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const LUCKY_LAND_7S: GapGameInfo = {
	displayName: 'Lucky Land 7’s',
	gameType: 'gap',
	standardImageUrl: styles.luckyLandSevensStandard,
	featureImageUrl: styles.luckyLandSevensFeature,
	gameProviderId: 'lucky land',
	gameId: 'fancysevens',
	tagLine: 'PULL, SPIN, WIN!',
	infoModal: [
		'7 Wilds and Wild Bar symbols, keeping the action classic and rewarding.',
		'Fancy Re-Spin Feature gives you a second chance—land two matching 7s and a blank, and the blank reel spins again!',
		'Hit the jackpot with a max win of 1,000x your play amount for a true Vegas-style win!'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	showMuteButtonOverlay: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const CONNECT_4_BONANZA: GapGameInfo = {
	displayName: 'Connect 4 Bonanza',
	gameType: 'gap',
	standardImageUrl: styles.connect4BonanzaStandard,
	featureImageUrl: styles.connect4BonanzaFeature,
	gameProviderId: 'Hot Sauce Studios',
	gameId: 'connect-4',
	tagLine: 'STACK, MATCH, WIN!',
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	infoModal: [
		'Choose your token—go Yellow for frequent features or Red for bigger wins, and switch anytime without restarting the game!',
		'Fill reels with sticky tokens to trigger the Prize Collect Feature—win up to 100x per token or land a Jackpot worth up to 200x!',
		'Drop into the Connect 4 Bonus—match 4 tokens to boost all visible prizes by up to 6x on a thrilling 6x6x6x6x6 grid!',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: false,
}

const AZTEC_LIGHTNING_BLITZ: GapGameInfo = {
	displayName: 'Aztec Lightning Blitz',
	gameType: 'gap',
	standardImageUrl: styles.aztecLightningBlitzUniversal,
	featureImageUrl: styles.aztecLightningBlitzUniversal,
	gameProviderId: 'reelplay',
	gameId: 'azteclightningblitz',
	tagLine: 'REALM OF MYSTERY AND GOLD!',
	infoModal: [
		'WILD symbols collect all visible PRIZE values, then explode to make way for even more winning opportunities.',
		'Trigger the Lightning Blitz Free Spins with 4+ SCATTERS, guaranteeing WILDs on every spin!',
		'Land bonus PRIZES up to 2,000x your total play amount as you embark on an epic Aztec adventure!'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GOLD_TRIO_LEPRECHAUNS_LUCK: GapGameInfo = {
	displayName: 'Gold Trio: Leprechauns Luck',
	gameType: 'gap',
	standardImageUrl: styles.goldTrioLeprechaunsLuckUniversal,
	featureImageUrl: styles.goldTrioLeprechaunsLuckUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_gtriolla1_pop',
	tagLine: 'LUCK OF THE IRISH!',
	infoModal: [
		'Land Coloured Coins to trigger the Gold Trio Re-spins, where expanding reels, doubled prizes, and massive coin values can lead to big wins!',
		'Fill the entire grid with coins to claim the Grand Prize of 1,000x your total play amount!',
		'Watch out for the mischievous Leprechaun—he can randomly add Wilds, Coloured Coins, or even upgrade prize coins!'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const LIL_SPHINX: GapGameInfo = {
	displayName: 'Lil Sphinx',
	gameType: 'gap',
	standardImageUrl: styles.lilSphinxUniversal,
	featureImageUrl: styles.lilSphinxUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_jokerf_pop',
	tagLine: 'REWIND, RETRIGGER AND REWARDS!',
	infoModal: [
		'Lil Sphinx lands in the Cat Zone as a Wild and Collect symbol, gathering Prize Coins and boosting your wins.',
		'Trigger Free Games as Lil Sphinx fills the pots above—once inside Free Games, the Sphinx stays locked, collecting prizes for massive wins!',
		'Activate Double Chance Feature Mode for two Cat Zones, increasing your chances to land Lil Sphinx!'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const DEAL_OR_NO_DEAL: GapGameInfo = {
	displayName: 'Deal or No Deal',
	gameType: 'gap',
	standardImageUrl: styles.dealOrNoDealUniversal,
	featureImageUrl: styles.dealOrNoDealUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'deal-or-no-deal',
	tagLine: 'THE BANKER IS CALLING!',
	infoModal: [
		'Battle the banker to decide \'Deal\' or \'No Deal\' on surprise offers!',
		'Random mini-features which can be awarded on any base game or free spin',
		'Case Chase Feature respins can reveal instant wins, special gold case boosts and the ultimate reward - a progressive jackpot!'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
}

const GPAS_AZTECWFBUS_POP: GapGameInfo = {
	displayName: 'Azteca Collect\' Em',
	gameType: 'gap',
	standardImageUrl: styles.gpasAztecwfbusPopUniversal,
	featureImageUrl: styles.gpasAztecwfbusPopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_aztecwfbus_pop',
	tagLine: 'EXPLORE THE EMPIRE OF GOLD!',
	infoModal: [
		'Collect’Em Wins – Land symbols to instantly grab Coin Prizes, Free Games, or trigger the Bonus Wheel.',
		'Epic Bonus Features – Spin Bonus Wheels, unlock Wild or Aztec Re-spins, and rack up huge rewards.',
		'Big Prizes – Win up to 500x your play with Collect’Em Prizes, boosted by locked symbols.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const KINGARTHUR10KWAYS: GapGameInfo = {
	displayName: 'King Arthur 10K Ways',
	gameType: 'gap',
	standardImageUrl: styles.kingArthur10KWaysUniversal,
	featureImageUrl: styles.kingArthur10KWaysUniversal,
	gameProviderId: 'reelplay',
	gameId: 'kingarthur10kways',
	tagLine: 'CLAIM THE HOLY GRAIL!',
	infoModal: [
		'10,000 Ways to Win – Epic 6-reel setup with cascading wins and huge combo potential.',
		'Sword Scatter Free Spins – Trigger Free Spins with rising multipliers and instant Coin Prizes up to 100x.',
		'Unlimited Multipliers – Each win boosts your multiplier with no cap for massive legendary rewards.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const CANDYLAND: GapGameInfo = {
	displayName: 'Candy Land',
	gameType: 'gap',
	standardImageUrl: styles.candyLandUniversal,
	featureImageUrl: styles.candyLandUniversal,
	gameId: 'candy-land',
	tagLine: 'SWEETEN YOUR SPINS!',
	gameProviderId: 'Golden Feather Studios',
	infoModal: [
		'A super sweet game adventure, licensed in partnership with Hasbro',
		'5 random mini-features which can be awarded on any base game or free spin',
		'An interactive board game feature experience, with the chance to make it all the way to King Kandy’s castle for progressive jackpots!'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
}

const FIRE_BLAZE_GREEN_WIZARD: GapGameInfo = {
	displayName: 'Fire Blaze: Green Wizard',
	gameType: 'gap',
	standardImageUrl: styles.gpasGwizardPopUniversal,
	featureImageUrl: styles.gpasGwizardPopUniversal,
	gameId: 'gpas_gwizard_pop',
	tagLine: 'FEEL THE FIRE BLAZE!',
	gameProviderId: 'Playtech',
	infoModal: [
		'Free Games with Expanding Reels – Win 6+ Free Games with up to 576 ways and stackable 2x WILD multipliers on Golden Frame reels.',
		'Fire Blaze Hold & Re-spin – Lock Magic Balls, collect Golden Eggs, and hit jackpots up to 2,000x your total play.',
		'Golden Frame Wins – Golden Frames boost WILDS and reveal enhanced Magic Ball prizes for bigger wins.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
}

const BLITZ_OF_OLYMPUS_TRIO_MAX: GapGameInfo = {
	displayName: 'Blitz of Olympus Trio Max',
	gameType: 'gap',
	standardImageUrl: styles.blitzOfOlympusTrioMaxUniversal,
	featureImageUrl: styles.blitzOfOlympusTrioMaxUniversal,
	gameProviderId: 'ggames',
	gameId: 'VGW_BLITZ_OF_OLYMPUS_1',
	tagLine: 'STORM THE REELS!',
	infoModal: [
		'Triple Blitz Feature System – Unleash Red, Blue, and Green lightning bolts to trigger powerful features solo or in hybrid combinations for maximum impact.',
		'Twin Reel Grids & Re-Spins – Enter the Reel Blitz to play on two synchronized reel sets with re-spins and duplicate prize symbols for double the potential.',
		'Stackable Multipliers & Fixed Jackpots – Supercharge wins with stackable multipliers up to 5x and hit jackpot prizes up to 2,500x your total play amount.'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const BEEHIVE_BLITZ: GapGameInfo = {
	displayName: 'Beehive Blitz',
	gameType: 'gap',
	standardImageUrl: styles.beehiveBlitzUniversal,
	featureImageUrl: styles.beehiveBlitzUniversal,
	gameProviderId: 'twofish',
	gameId: 'beehive-blitz',
	tagLine: 'SWEET SPINS AND WILD WINS!',
	infoModal: [
		'Prize Collect & Jackpot Honeycombs – Gather Honeycomb prizes with Worker Bees and unlock jackpots up to 2,500x your total play.',
		'Free Spins & Wild Bumble Bonus – Choose from Honey Coin or Wild Bumble Free Spins, with multipliers up to 5x and the chance to retrigger up to 25 spins.',
		'Honey Hive Spins with Multipliers – Guaranteed Collect Spins with Worker and Queen Bee multipliers boosting all prizes by up to 3x.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true
}

const BFBL_GLOBALPOKERSLOTS: GapGameInfo = {
	displayName: 'Buffalo Blitz Live',
	gameType: 'gap',
	standardImageUrl: styles.bfblGlobalpokerslotsUniversal,
	featureImageUrl: styles.bfblGlobalpokerslotsUniversal,
	gameProviderId: 'playtech',
	gameId: 'bfbl_globalpokerslots',
	infoModal: [
		'Experience the iconic Buffalo Blitz™ gameplay with 4096 ways to win. Spin the reels and hunt for winning symbol combinations in this live-action slot.',
		'A professional host drives the action, commenting on gameplay, spinning the reels, and initiating bonus rounds, enhancing the atmosphere of communal excitement.',
		'Customisable Play Options: Choose the number of spins and play amounts before joining the game.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const BUFFALO_BLITZ_LIVE_SLOT: GapGameInfo = {
	displayName: 'Buffalo Blitz Live Slot',
	gameType: 'gap',
	standardImageUrl: styles.bfblGlobalpokerslotsUniversal,
	featureImageUrl: styles.bfblGlobalpokerslotsUniversal,
	gameProviderId: 'playtech',
	gameId: 'bfbl_liveslots',
	infoModal: [
		'Experience the iconic Buffalo Blitz™ gameplay with 4096 ways to win. Spin the reels and hunt for winning symbol combinations in this live-action slot.',
		'A professional host drives the action, commenting on gameplay, spinning the reels, and initiating bonus rounds, enhancing the atmosphere of communal excitement.',
		'Customisable Play Options: Choose the number of spins and play amounts before joining the game.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const SWLE_GLOBALPOKERSAW: GapGameInfo = {
	displayName: 'Spin A Win Wild',
	gameType: 'gap',
	standardImageUrl: styles.swleGlobalpokersawUniversal,
	featureImageUrl: styles.swleGlobalpokersawUniversal,
	gameProviderId: 'playtech',
	gameId: 'swle_globalpokersaw',
	tagLine: 'Spin A Win Wild',
	infoModal: [
		'The game is played with a manually spun 54-sector wheel. Your goal? Predict the winning sector!',
		'Jump in at any time and place your chips before the next spin.',
		'Place your chips, watch the wheel turn, and chase thrilling wins in this must-play live casino game!',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const BAL_GLOBALPOKERBAC: GapGameInfo = {
	displayName: 'Live Baccarat',
	gameType: 'gap',
	standardImageUrl: styles.balGlobalpokerbacUniversal,
	featureImageUrl: styles.balGlobalpokerbacUniversal,
	gameProviderId: 'playtech',
	gameId: 'bal_globalpokerbac',
	infoModal: [
		'Predict a specific Tie outcome between Player and Banker.',
		'Unlimited players can occupy a single seat, but you will only see your own play amounts.',
		'Played with eight decks of 52 cards each.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const ABWL_WONDERLAND: GapGameInfo = {
	displayName: 'Adventures Beyond Wonderland',
	gameType: 'gap',
	standardImageUrl: styles.abwlWonderlandUniversal,
	featureImageUrl: styles.abwlWonderlandUniversal,
	gameProviderId: 'playtech',
	gameId: 'abwl_wonderland',
	infoModal: [
		'Place your chips, spin the wheel, and journey through.Wonderland in this unforgettable live gaming adventure!',
		'The manually spin wheel features 54 sectors.',
		'Special events: Mystery sectors for bonus surprises.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const ROL_GLOBALPOKERROL2: GapGameInfo = {
	displayName: 'European Roulette',
	gameType: 'gap',
	standardImageUrl: styles.rolGlobalpokerrol2Universal,
	featureImageUrl: styles.rolGlobalpokerrol2Universal,
	gameProviderId: 'playtech',
	gameId: 'rol_globalpokerrol2',
	infoModal: [
		'Play on a physical table-top single-zero Roulette wheel featuring 37 sectors, numbered 0 to 36.',
		'Real-Time Gameplay: Enjoy an authentic casino atmosphere with live video feeds from professional hosts.',
		'Comprehensive Game Insights: Access detailed statistics, including red/black percentages and even/odd ratios, view table trends with a pie chart display, and review full game history for previous spin results.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const ABJL_GLOBALPOKERBJ2: GapGameInfo = {
	displayName: 'All Play Blackjack',
	gameType: 'gap',
	standardImageUrl: styles.abjlGlobalpokerbj2Universal,
	featureImageUrl: styles.abjlGlobalpokerbj2Universal,
	gameProviderId: 'playtech',
	gameId: 'abjl_globalpokerbj2',
	infoModal: [
		'No limit on the number of participants, creating a highly engaging experience for all.',
		'Engage with live hosts for a truly immersive casino experience.',
		'Welcome to All Play Blackjack, where every hand offers the chance for thrilling wins and strategic decisions.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const LEGACY_OF_THE_TIGER_MEGA_FIRE_BLAZE: GapGameInfo = {
	displayName: 'Legacy of the Tiger Mega Fire Blaze',
	gameType: 'gap',
	standardImageUrl: styles.legacyOfTheTigerUniversal,
	featureImageUrl: styles.legacyOfTheTigerUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_lottiger_pop',
	tagLine: 'HUNT FOR JACKPOTS!',
	infoModal: [
		'Trigger 8 Free Games with Wilds and Moons on reel 3 for beastly win potential!',
		'Land 6+ Moons to ignite the Mega Fire Blaze™ Re-spin Feature with coin prizes, reel expansions, and multipliers up to 5x!',
		'Collect Jackpot Stars for your shot at the GRAND, MAJOR, MINOR, or MINI jackpots—win them multiple times in a single feature!'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false
}

const MEGA_WINVASION: GapGameInfo = {
	displayName: 'Mega Winvasion',
	gameType: 'gap',
	standardImageUrl: styles.megaWinvasionUniversal,
	featureImageUrl: styles.megaWinvasionUniversal,
	gameProviderId: 'Famtasma Gaming',
	gameId: 'mega-winvasion',
	tagLine: 'BLAST OFF FOR BIG WINS!',
	infoModal: [
		'Expanding Reels & Cloning Wins – Reels grow up to 5x7 with 100 lines, while cloned symbols boost every spin.',
		'Alien Wilds with Multipliers – Random wilds land with 2x, 3x, or 5x multipliers for out-of-this-world wins.',
		'Free Spins & Jackpot Bonus – Trigger interactive Free Spins or shoot planets in the bonus game to win jackpots and instant prizes.'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false
}

const SFL_SAKURASLOTS: GapGameInfo = {
	displayName: 'Sakura Fortune Live',
	gameType: 'gap',
	standardImageUrl: styles.sflSakuraslotsUniversal,
	featureImageUrl: styles.sflSakuraslotsUniversal,
	gameProviderId: 'playtech',
	gameId: 'sfl_sakuraslots',
	infoModal: [
		'Two full stacks of Princess wild symbols will trigger the respin feature. The total number of respins relates to the number of wilds on the reels when triggered. Additional wilds grant more respins and the feature ends when nomore wilds land.',
		'Three or more consecutive scatter symbols from left to right on a single spin will trigger the feature. During free spins, any Princess wild symbol that lands on the reels will expand to cover the full reel and will remain that way for the duration of the free spin. It will also award an additional free spin.',
		'Any time two or more Princess wild symbols land there is a chance they nudge into a full stack.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const PRSTL_BUSTEDORBAILED: GapGameInfo = {
	displayName: 'Busted or Bailed',
	gameType: 'gap',
	standardImageUrl: styles.prstiBustedorbailedUniversal,
	featureImageUrl: styles.prstiBustedorbailedUniversal,
	gameProviderId: 'playtech',
	gameId: 'prstl_bustedorbailed',
	infoModal: [
		'Follow intense, lifelike pursuits between police and getaway drivers, streamed live from a cutting-edge studio.',
		'Switch between Helicopter, Dash Cam, and Highway Cam views for a broadcast-quality experience straight from the headlines.',
		'Chase scenes feature detailed car models inspired by real 1990s classics, rendered with precision for visual realism.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const CHEL_GLOBALPOKERCASINOHOLDEM: GapGameInfo = {
	displayName: 'Live Casino Hold’em',
	gameType: 'gap',
	standardImageUrl: styles.chelGlobalpokercasinoholdemUniversal,
	featureImageUrl: styles.chelGlobalpokercasinoholdemUniversal,
	gameProviderId: 'playtech',
	gameId: 'chel_gpholdem',
	infoModal: [
		'Play and see the flop, then decide: Call to go all-in or Fold to step back.',
		'Boost your chances with the optional plays.',
		'Play close with the timer, the host and players get two cards plus the flop.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const ROL_QUANTUMROULETTE: GapGameInfo = {
	displayName: 'Quantum Roulette',
	gameType: 'gap',
	standardImageUrl: styles.rolQuantumrouletteUniversal,
	featureImageUrl: styles.rolQuantumrouletteUniversal,
	gameProviderId: 'playtech',
	gameId: 'rol_quantumroulette',
	infoModal: [
		'Quantum Multipliers: The core difference is the addition of multipliers, randomly applied to between one and five numbers on the layout before each spin.',
		'Multiplier Range: These multipliers range from 50x to 500x and apply only to straight-up play placed on those specific numbers.',
		'Only straight-up plays are eligible for the multiplier awards.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const FBBL_LUCKYBALL: GapGameInfo = {
	displayName: 'Mega Fire Blaze Lucky Ball',
	gameType: 'gap',
	standardImageUrl: styles.fbblLuckyballUniversal,
	featureImageUrl: styles.fbblLuckyballUniversal,
	gameProviderId: 'playtech',
	gameId: 'fbbl_luckyball',
	infoModal: [
		'Players choose between 11 different cards – eight regular and three bonus variations (Major, Grand, and Mega).',
		'Once the game starts, 11 numbers are randomly selected as Lucky Balls. Twenty balls are drawn from a physical machine.',
		'Forming a line (horizontal, vertical, or diagonal) of four matching numbers results in a reward. The more Lucky Balls in a winning line, the bigger the reward. ',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const STAMPEDEFURY2: GapGameInfo = {
	displayName: 'Stampede Fury 2',
	gameType: 'gap',
	standardImageUrl: styles.stampedeFury2Universal,
	featureImageUrl: styles.stampedeFury2Universal,
	gameId: 'stampede-fury-2',
	gameProviderId: 'Golden Feather Studios',
	tagLine: 'THE STAMPEDE RETURNS!',
	infoModal: [
		'The Stampede Returns: A thrilling sequel to the fan-favourite Stampede Fury, now bigger, bolder, and more rewarding.',
		'Explosive Bonus Features: Trigger the Fireshot™ and Fireshot Diamond modes for blazing prizes and progressive jackpots.',
		'Wild Free Spins Action: Spin two wheels to determine your free spins count and the number of buffalo symbols added to the reels for even bigger win potential.'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnMobile: true,
	moveMuteButtonLeftOnDesktop: true
}

const MUMMYMAYHEM2: GapGameInfo = {
	displayName: 'Mummy Mayhem 2: Wild Nefertiti',
	gameType: 'gap',
	standardImageUrl: styles.mummyMayhem2Universal,
	featureImageUrl: styles.mummyMayhem2Universal,
	gameId: 'mummymayhem2',
	gameProviderId: 'Hot Sauce Studio',
	tagLine: 'MUMMY MAYHEM RETURNS!',
	infoModal: [
		'Nefertiti’s Blessing activates every 10 spins, transforming Eye of Horus-marked positions into Wilds, with chances to upgrade them into powerful 2x or 3x Multiplier Wilds.',
		'Up to 50 Free Spins in the bonus round, where Wild multipliers flood the reels for massive win potential.',
		'5 reels and 40 win lines filled with Egyptian gods, sacred symbols, and Nefertiti, the highest-awarding symbol in the game.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	showMuteButtonOverlay: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true
}

const BACON_BLING: GapGameInfo = {
	displayName: 'Bacon Bling',
	gameType: 'gap',
	standardImageUrl: styles.baconBlingUniversal,
	featureImageUrl: styles.baconBlingUniversal,
	gameId: 'bacon-bling',
	gameProviderId: 'ggames',
	tagLine: 'BLING, BACON AND BIG WINS!',
	infoModal: [
		'Diamond Chase Jackpot – Land up to 9 Diamonds anywhere on the reels for rewards up to a colossal 2,000x your total play amount.',
		'Vault-Powered Free Spins – Crack open the bank vault for 10–30 Free Spins with 2x–3x multipliers and unlimited retriggers.',
		'20 Ways to Win – Spin across 5 reels and 3 rows with 20 dynamic winlines delivering non-stop win potential.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true
}

const GOBLIN_GRAND: GapGameInfo = {
	displayName: 'Goblin Grand',
	gameType: 'gap',
	standardImageUrl: styles.goblinGrandUniversal,
	featureImageUrl: styles.goblinGrandUniversal,
	gameId: 'goblin-grand',
	gameProviderId: 'Golden Feather Studios',
	tagLine: 'GO GOBLIN, FOR GOLD COINS!',
	infoModal: [
		'Win one of four jackpots: Mini, Minor, Major, or Grand, with the Major and Grand offering exciting progressive prizes that can grow to huge amounts.',
		'Hold & Spin Jackpot Feature: Triggered by 6+ coin symbols, this feature locks coins, resets spins with each new coin, and the cheeky Goblin can multiply prizes up to 7x. Filling the screen awards the Grand Jackpot!',
		'Free Spins with Random Enhancements: Free Spins are packed with retriggers and more frequent Random Reel Features, including added wilds and up to 10x multipliers for explosive win potential.'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	showMuteButtonOverlay: true,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true
}

const GPAS_FFIGHTER_POP: GapGameInfo = {
	displayName: 'Fire Blaze Fire Fighter',
	gameType: 'gap',
	standardImageUrl: styles.gpasFfighterPopUniversal,
	featureImageUrl: styles.gpasFfighterPopUniversal,
	gameId: 'gpas_ffighter_pop',
	gameProviderId: 'Playtech',
	tagLine: 'IGNITE THE REELS, RING THE BELLS!',
	infoModal: [
		'Fire Bells hold the key—land 8+ to trigger the Fire Blaze Jackpots for massive prizes!',
		'Land 3+ Scatters to trigger Free Spins—flaming symbols turn into Wilds or Fire Bells for scorching wins!',
		'Hit the Fire Blaze Feature and fill the screen to win the GRAND Jackpot of 2,000x your total play amount!'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const FREAKY_13: GapGameInfo = {
	displayName: 'Freaky 13',
	gameType: 'gap',
	standardImageUrl: styles.freaky13Universal,
	featureImageUrl: styles.freaky13Universal,
	gameId: 'freaky-13',
	gameProviderId: 'Golden Feather Studios',
	tagLine: 'GHOULISHLY GOOD PRIZES!',
	infoModal: [
		'Halloween Special – A spooky slot packed with thrills and chills.',
		'Spooky Wild Scatters – Free spins feature where Scattered Pumpkins transform into Wild Scatters, boosting wins and retriggering spins.',
		'Lucky 13 Free Spins – Trigger 13 free spins with 3+ Scatters, with the chance to keep stacking more spins for frighteningly big rewards.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	showMuteButtonOverlay: true,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true
}

const GHOST_FACE_LIVES: GapGameInfo = {
	displayName: 'Ghost Face Lives',
	gameType: 'gap',
	standardImageUrl: styles.ghostFaceLivesUniversal,
	featureImageUrl: styles.ghostFaceLivesUniversal,
	gameId: 'ghost-face-lives',
	gameProviderId: 'Golden Feather Studios',
	tagLine: 'KILLER WINS!',
	infoModal: [
		'Surprise Reel Features – Ghost Face can strike at any moment, awarding wilds, multipliers, or bonus-triggering scatters.',
		'Free Spins with Pick Bonus – Trigger Free Spins and reveal wilds and extra spins before the night begins.',
		'Jackpot Wheel Encounter – Win up to a Grand Progressive Jackpot in a chilling face-off with Ghost Face himself.'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	showMuteButtonOverlay: true,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true
}

const IMPERIAL_KOI: GapGameInfo = {
	displayName: 'Imperial Koi',
	gameType: 'gap',
	standardImageUrl: styles.imperialKoiUniversal,
	featureImageUrl: styles.imperialKoiUniversal,
	gameId: 'imperial-koi',
	gameProviderId: 'Golden Feather Studios',
	tagLine: 'CARPE DIEM!',
	infoModal: [
		'Fireshot Diamond Feature – Land 6+ Coins or Diamonds for jackpot wins and boosted prizes, with a full screen awarding the Grand Jackpot.',
		'Free Spins with Wild Choices – Trigger up to 25 Free Spins and pick your mix of Wilds and win multipliers—or go Mystery for one of 36 wild outcomes.',
		'4 Jackpot Levels – Win fixed or progressive jackpots, with the Grand shared across Fireshot titles for even bigger potential.'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true
}

const NC_BAL_GLOBALPOKERBAC: GapGameInfo = {
	displayName: 'Live Baccarat No Commission',
	gameType: 'gap',
	standardImageUrl: styles.ncBalGlobalpokerbacUniversal,
	featureImageUrl: styles.ncBalGlobalpokerbacUniversal,
	gameProviderId: 'playtech',
	gameId: 'nc_bal_globalpokerbac',
	infoModal: [
		'Predict a specific Tie outcome between Player and Banker.',
		'In No Commission version, game’s RTP and redeem for the Banker position is different from the Baccarat game.',
		'Unlimited players can occupy a single seat, but you will only see your own play amounts.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const BJL_GLOBALPOKERBJ1 : GapGameInfo = {
	displayName: '7-Seater Blackjack 1',
	gameType: 'gap',
	standardImageUrl: styles.bjlGlobalpokerbj1Universal,
	featureImageUrl: styles.bjlGlobalpokerbj1Universal,
	gameProviderId: 'playtech',
	gameId: 'bjl_globalpokerbj1',
	infoModal: [
		'Played with eight decks of cards.',
		'Get closer to 21 than the host without exceeding it.',
		'Blackjack awards 3:2, while a "push" returns your original play amount if you tie with the host.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const BJL_GLOBALPOKERBJ2 : GapGameInfo = {
	displayName: '7-Seater Blackjack 2',
	gameType: 'gap',
	standardImageUrl: styles.bjlGlobalpokerbj2Universal,
	featureImageUrl: styles.bjlGlobalpokerbj2Universal,
	gameProviderId: 'playtech',
	gameId: 'bjl_globalpokerbj2',
	infoModal: [
		'Played with eight decks of cards.',
		'Get closer to 21 than the host without exceeding it.',
		'Blackjack awards 3:2, while a "push" returns your original play amount if you tie with the host.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const BJL_GLOBALPOKERBJ3 : GapGameInfo = {
	displayName: '7-Seater Blackjack 3',
	gameType: 'gap',
	standardImageUrl: styles.bjlGlobalpokerbj3Universal,
	featureImageUrl: styles.bjlGlobalpokerbj3Universal,
	gameProviderId: 'playtech',
	gameId: 'bjl_globalpokerbj3',
	infoModal: [
		'Played with eight decks of cards.',
		'Get closer to 21 than the host without exceeding it.',
		'Blackjack awards 3:2, while a "push" returns your original play amount if you tie with the host.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const BJL_GLOBALPOKERBJ4 : GapGameInfo = {
	displayName: '7-Seater Blackjack 4',
	gameType: 'gap',
	standardImageUrl: styles.bjlGlobalpokerbj4Universal,
	featureImageUrl: styles.bjlGlobalpokerbj4Universal,
	gameProviderId: 'playtech',
	gameId: 'bjl_globalpokerbj4',
	infoModal: [
		'Played with eight decks of cards.',
		'Get closer to 21 than the host without exceeding it.',
		'Blackjack awards 3:2, while a "push" returns your original play amount if you tie with the host.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const BJL_GLOBALPOKERBJ5 : GapGameInfo = {
	displayName: '7-Seater Blackjack 5',
	gameType: 'gap',
	standardImageUrl: styles.bjlGlobalpokerbj5Universal,
	featureImageUrl: styles.bjlGlobalpokerbj5Universal,
	gameProviderId: 'playtech',
	gameId: 'bjl_globalpokerbj5',
	infoModal: [
		'Played with eight decks of cards.',
		'Get closer to 21 than the host without exceeding it.',
		'Blackjack awards 3:2, while a "push" returns your original play amount if you tie with the host.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const QUANTAM_BLACKJACK: GapGameInfo = {
	displayName: 'Quantum Blackjack',
	gameType: 'gap',
	standardImageUrl: styles.quantumBlackjackUniversal,
	featureImageUrl: styles.quantumBlackjackUniversal,
	gameProviderId: 'playtech',
	gameId: 'qabjl_quantumbj',
	tagLine:'Quantum Blackjack',
	infoModal: [
		'Scalable version of Blackjack enhanced with multipliers.',
		'Random cards receive Quantum Multipliers before each deal.',
		'Only winning hands can be boosted by Quantum Multipliers.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const X1000_QUANTUM_ROULETTE: GapGameInfo = {
	displayName: 'x1000 Quantum Roulette',
	gameType: 'gap',
	standardImageUrl: styles.x1000QuantumRouletteUniversal,
	featureImageUrl: styles.x1000QuantumRouletteUniversal,
	gameProviderId: 'playtech',
	gameId: 'qrodzl_quantumita',
	tagLine: 'x1000 Quantum Roulette',
	infoModal: [
		'Auto American-Roulette version of Quantum Roulette.',
		'Potential multipliers up to 1000x.',
		'Only Straight Up play can be boosted by Quantum Multipliers.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	showMuteButtonOverlay: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino',
}

const GPAS_SSAMMCTUS_POP: GapGameInfo = {
	displayName: "Silent Samurai Mega Collect'Em",
	gameType: 'gap',
	standardImageUrl: styles.gpasSsammctusPopUniversal,
	featureImageUrl: styles.gpasSsammctusPopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_ssammctus_pop',
	tagLine: 'STRIKE IN SILENCE!',
	infoModal: [
		'Mega Collect’Em:  Lock samurai symbols to gather prizes, free spins, and jackpots.',
		'Free Games Path: Unlock extra rows, sticky Collect’Em, and blazing coin features.',
		'Jackpot Strikes: Diamond Coins unleash MINI, MINOR, MAJOR, or the GRAND 500× reward.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GOLDEN_ACE: GapGameInfo = {
	displayName: 'Golden Ace Scratch',
	gameType: 'gap',
	standardImageUrl: styles.goldenAceUniversal,
	featureImageUrl: styles.goldenAceUniversal,
	gameProviderId: 'ggames',
	gameId: 'GOLDEN_ACE',
	tagLine: 'FIND A ROYAL WINNING HAND!',
	infoModal: [
		'Match three to win prizes',
		'Ace of spades wins every single prize on the card',
		'20 Field Scratch with tap and reveal'
	],
	filteredGameType: 'scratch-cards',
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
}

const KITTY_PUZZLE: GapGameInfo = {
	displayName: 'Kitty Puzzle Scratch',
	gameType: 'gap',
	standardImageUrl: styles.kittyPuzzleUniversal,
	featureImageUrl: styles.kittyPuzzleUniversal,
	gameProviderId: 'ggames',
	gameId: 'KITTY_PUZZLE',
	tagLine: 'COMPLETE THE PUZZLE, CLAIM THE PRIZE!',
	infoModal: [
		'Match images to win',
		'Build the kitty puzzle',
		'Win up to 25,000x'
	],
	filteredGameType: 'scratch-cards',
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
}

const SPINLOTTO_SCRATCH: GapGameInfo = {
	displayName: 'SpinStar Scratch',
	gameType: 'gap',
	standardImageUrl: styles.spinlottoScratchUniversal,
	featureImageUrl: styles.spinlottoScratchUniversal,
	gameProviderId: 'ggames',
	gameId: 'SPINLOTTO_SCRATCH',
	tagLine: 'MATCH YOUR NUMBERS TO WIN!',
	infoModal: [
		'Match numbers for multipliers',
		'Scratch and win instant prizes',
		'6/49 scratch card wins'
	],
	filteredGameType: 'scratch-cards',
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
}

const DIAMOND_DIGGER: GapGameInfo = {
	displayName: 'Diamond Digger',
	gameType: 'gap',
	standardImageUrl: styles.diamondDiggerUniversal,
	featureImageUrl: styles.diamondDiggerUniversal,
	gameProviderId: 'ggames',
	gameId: 'DIAMOND_DIGGER',
	tagLine: 'PICK YOUR WAY TO RICHES!',
	infoModal: [
		'Pick squares to find diamonds',
		'Avoid the bombs to win',
		'End the game early to collect'
	],
	filteredGameType: 'instant-win',
	overlayClockDesktop: false,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const EPIC_GEMS: GapGameInfo = {
	displayName: 'Epic Gems',
	gameType: 'gap',
	standardImageUrl: styles.epicGemsUniversal,
	featureImageUrl: styles.epicGemsUniversal,
	gameProviderId: 'ggames',
	gameId: 'EPIC_GEMS',
	tagLine: 'DIG FOR EPIC WINS!',
	infoModal: [
		'Pick gems, earn prizes',
		'Collect gems, avoid mines',
		'End your turn early'
	],
	filteredGameType: 'instant-win',
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
}

const SPINLOTTO: GapGameInfo = {
	displayName: 'SpinStar',
	gameType: 'gap',
	standardImageUrl: styles.spinlottoUniversal,
	featureImageUrl: styles.spinlottoUniversal,
	gameProviderId: 'ggames',
	gameId: 'SPINLOTTO',
	tagLine: 'MATCH YOUR LUCKY LOTTO NUMBERS!',
	infoModal: [
		'Match your lucky numbers',
		'Star boosters add multipliers',
		'Special Star extra booster'
	],
	filteredGameType: 'instant-win',
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
}

const THORS_EGG_HUNT: GapGameInfo = {
	displayName: 'Thors Egg Hunt',
	gameType: 'gap',
	standardImageUrl: styles.thorsEggHuntUniversal,
	featureImageUrl: styles.thorsEggHuntUniversal,
	gameProviderId: 'ggames',
	gameId: 'THORS_EGG_HUNT',
	tagLine: 'FIND THE EGGS, WIN BIG!',
	infoModal: [
		'Cluster awards cascade wins',
		'Increase multipliers on cascades',
		'Defeat bosses for big wins'
	],
	filteredGameType: 'instant-win',
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
}

const ONE_HUNDRED_CASH: GapGameInfo = {
	displayName: '100K Coins',
	gameType: 'gap',
	standardImageUrl: styles.gameId100CashUniversal,
	featureImageUrl: styles.gameId100CashUniversal,
	gameProviderId: 'ggames',
	gameId: '100K_CASH',
	tagLine: 'SCRATCH FOR A GRAND PRIZE!',
	infoModal: [
		'Match three prize values',
		'Win up to 100,000 SC',
		'Classic scratch game'
	],
	filteredGameType: 'scratch-cards',
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
}

const VEGAS_SOLITAIRE: GapGameInfo = {
	displayName: 'Vegas Solitaire',
	gameType: 'gap',
	standardImageUrl: styles.vegasSolitaireUniversal,
	featureImageUrl: styles.vegasSolitaireUniversal,
	gameProviderId: 'ggames',
	gameId: 'VEGAS_SOLITAIRE',
	tagLine: 'PLAY YOUR CARDS, WIN BIG!',
	infoModal: [
		'Classic solitaire card game',
		'Win on red or black plays',
		'Get prizes for no moves'
	],
	filteredGameType: 'table',
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
}

const DANCING_GOLD: GapGameInfo = {
	displayName: 'Dancing Gold',
	gameType: 'gap',
	standardImageUrl: styles.dancingGoldUniversal,
	featureImageUrl: styles.dancingGoldUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'dancing-gold',
	tagLine: 'DANCE YOUR WAY TO JACKPOTS!',
	infoModal: [
		'Fireshot Jackpot hold and spin',
		'Progressive jackpots up for grabs',
		'Free spins with multipliers'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnMobile: true
}

const THE_STALLION: GapGameInfo = {
	displayName: 'Stallion Grand',
	gameType: 'gap',
	standardImageUrl: styles.theStallionUniversal,
	featureImageUrl: styles.theStallionUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'the-stallion',
	tagLine: 'RIDE FOR A GRAND JACKPOT!',
	infoModal: [
		'Fireshot Jackpot hold and spin',
		'Player choice for free spins',
		'Progressive jackpots on offer'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: true,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true
}

const REALLY_REELY_RICH: GapGameInfo = {
	displayName: 'Really Reely Rich',
	gameType: 'gap',
	standardImageUrl: styles.reallyReelyRichUniversal,
	featureImageUrl: styles.reallyReelyRichUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'really-reely-rich',
	tagLine: 'SOMETHING YOU WILL REELY LIKE!',
	infoModal: [
		'Fireshot jackpot hold and spin',
		'Free spins with 2x multipliers',
		'Progressive jackpots available now'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: false
}

const ROARING_STRIKE: GapGameInfo = {
	displayName: 'Roaring Strike',
	gameType: 'gap',
	standardImageUrl: styles.roaringStrikeUniversal,
	featureImageUrl: styles.roaringStrikeUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'roaring-strike',
	tagLine: 'GRAB YOUR LION\'S SHARE OF WINS!',
	infoModal: [
		'Expand reels and ways',
		'Wild fury triggers respins',
		'Progressive jackpots available now'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true
}

const VIVA_FROST_VEGAS: GapGameInfo = {
	displayName: 'Viva Frost Vegas',
	gameType: 'gap',
	standardImageUrl: styles.vivaFrostVegasUniversal,
	featureImageUrl: styles.vivaFrostVegasUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'viva-frost-vegas',
	tagLine: 'CHILL OUT AND WIN BIG!',
	infoModal: [
		'Random wilds with multipliers',
		'Bonus wheel for jackpots',
		'Progressive jackpot up for grabs'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnMobile: true
}

const FROST_VEGAS: GapGameInfo = {
	displayName: 'Frost Vegas',
	gameType: 'gap',
	standardImageUrl: styles.frostVegasUniversal,
	featureImageUrl: styles.frostVegasUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'frost-vegas',
	replacesGameId: 'viva-frost-vegas',
	tagLine: 'CHILL OUT AND WIN BIG!',
	infoModal: [
		'Random wilds with multipliers',
		'Bonus wheel for jackpots',
		'Progressive jackpot up for grabs'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnMobile: true
}

const BLACK_TIDE_FORTUNES: GapGameInfo = {
	displayName: 'Black Tide Fortunes',
	gameType: 'gap',
	standardImageUrl: styles.blackTideFortunesUniversal,
	featureImageUrl: styles.blackTideFortunesUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'black-tide-fortunes',
	tagLine: 'SET SAIL FOR EPIC WINS!',
	infoModal: [
		'Fireshot hold and spin bonus',
		'Symbol upgrades to gold wilds',
		'Progressive jackpots up for grabs'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: true
}

const THE_GOLDEN_CHEESE: GapGameInfo = {
	displayName: 'The Golden Cheese',
	gameType: 'gap',
	standardImageUrl: styles.theGoldenCheeseUniversal,
	featureImageUrl: styles.theGoldenCheeseUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'the-golden-cheese',
	tagLine: 'IT\'S ALL GOUDA!',
	infoModal: [
		'Hold and spin with mega symbols',
		'Player choice free spin bonus',
		'Progressive jackpots available now'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true
}

const DRUM_FESTIVAL: GapGameInfo = {
	displayName: 'Drum Festival',
	gameType: 'gap',
	standardImageUrl: styles.drumFestivalUniversal,
	featureImageUrl: styles.drumFestivalUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'drum-festival',
	tagLine: 'DRUM UP BIG WINS!',
	infoModal: [
		'Hit drums for instant prizes',
		'Win a progressive jackpot',
		'Free spins with wild multipliers'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true
}

const TROPHY_CATCH: GapGameInfo = {
	displayName: 'Trophy Catch',
	gameType: 'gap',
	standardImageUrl: styles.trophyCatchUniversal,
	featureImageUrl: styles.trophyCatchUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'trophy-catch',
	tagLine: 'REEL IN THE WINS!',
	infoModal: [
		'Expanding reels with more ways',
		'Floating wilds on reels 1-2',
		'Progressive jackpot up for grabs'
	],
	hasJackpot: true,
	jackpotToDisplay: 'major',
	useGapJackpot: true,
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: true,
}

const STAR_CATCH_JACKPOTS: GapGameInfo = {
	displayName: 'Star Catch Jackpots',
	gameType: 'gap',
	standardImageUrl: styles.starCatchJackpotsUniversal,
	featureImageUrl: styles.starCatchJackpotsUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'star-catch-jackpots',
	tagLine: 'SPIN LIKE A STAR!',
	infoModal: [
		'Instant hit jackpot prizes',
		'Free spins wheel bonus',
		'Progressive jackpot up for grabs'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnMobile: true,
	moveMuteButtonLeftOnDesktop: true
}

const QUEST_3_LAMPS: GapGameInfo = {
	displayName: 'Quest of the 3 Lamps',
	gameType: 'gap',
	standardImageUrl: styles.quest3LampsUniversal,
	featureImageUrl: styles.quest3LampsUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'quest-of-the-3-lamps',
	tagLine: 'YOUR WISH AWAITS!',
	infoModal: [
		'Trigger the Genie Feature with just 1 Lamp! – Any 1, 2 or 3 Lamps can summon magical rewards, with 3 Lamps guaranteeing entry to the feature.',
		'Unique Genie Bonuses – Green, Red and Purple Lamps unleash Fortune, Multiply or Collect rewards for even bigger wins.',
		'Jackpots to Chase – Fill all 15 reel positions for the Grand Jackpot, linked across popular games.'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true
}

const FU_QIAN_QIAN: GapGameInfo = {
	displayName: 'Fu Qian Qian',
	gameType: 'gap',
	standardImageUrl: styles.fuQianQianUniversal,
	featureImageUrl: styles.fuQianQianUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'fu-qian-qian',
	tagLine: 'A FANTASTIC FORTUNE AWAITS!',
	infoModal: [
		'Four Jackpots  – Win Mini, Minor, Major and Grand!',
		'Fireshot Inferno Upgrade & Collect – Special coins upgrade prizes or collect them all in one spin!',
		'Lucky Prize Free Spins – WILDs award coin prizes or jackpots directly during bonus spins.'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true
}

const FASHION_TV_MEGA_PARTY: GapGameInfo = {
	displayName: 'Fashion TV Mega Party',
	gameType: 'gap',
	standardImageUrl: styles.fashionTvMegaPartyUniversal,
	featureImageUrl: styles.fashionTvMegaPartyUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'mjpswl_ftvmegaparty',
	tagLine: 'Fashion TV Mega Party',
	infoModal: [
		'Player can play on any or all the play positions: Number  1, 2, 5, 10, Lucky DJ, Laser Show, Dance Floor or Mega Win.',
		'Occasionally, the Mega Party game event is announced, and the boosters are applied on play positions.',
		'Four different bonus round.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const LIVE_ROULETTE: GapGameInfo = {
	displayName: 'Live Roulette',
	gameType: 'gap',
	standardImageUrl: styles.liveRouletteUniversal,
	featureImageUrl: styles.liveRouletteUniversal,
	gameProviderId: 'playtech',
	gameId: 'rol_swtrol',
	tagLine: 'Live Roulette',
	infoModal: [
		'Play on a physical table-top single-zero Roulette wheel featuring 37 sectors, numbered 0 to 36.',
		'Real-Time Gameplay: Enjoy an authentic casino atmosphere with live video feeds from professional hosts.',
		'Comprehensive Game Insights: Access detailed statistics, including red/black percentages and even/odd ratios, view table trends with a pie chart display, and review full game history for previous spin results.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const AMERICAN_ROULETTE: GapGameInfo = {
	displayName: 'American Roulette',
	gameType: 'gap',
	standardImageUrl: styles.americanRouletteUniversal,
	featureImageUrl: styles.americanRouletteUniversal,
	gameProviderId: 'playtech',
	gameId: 'rodzl_globalpoker2',
	tagLine: 'American Roulette',
	infoModal: [
		'Play on a physical table-top double-zero Roulette wheel featuring 38 sectors, numbered from 1 to 36, plus slots for Zero (0) and Double Zero (00).',
		'Real-Time Gameplay: Enjoy an authentic casino atmosphere with live video feeds from professional hosts.',
		'The sectors are coloured red and black (alternately), except for Zero and Double Zero, which are greenand located on the opposite sides of the wheel.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const MONSTER_ORBS_FRANKEN_LINK: GapGameInfo = {
	displayName: 'MonsterOrbs: FrankenLink',
	gameType: 'gap',
	standardImageUrl: styles.monsterOrbsFrankenLinkUniversal,
	featureImageUrl: styles.monsterOrbsFrankenLinkUniversal,
	gameProviderId: 'Hot Sauce Studios',
	gameId: 'frankenlink',
	tagLine: 'THROW THE SWITCH!',
	infoModal: [
		'Monster Orbs Hold & Spin: Unlock rows, reset spins, and chase jackpots up to the Grand Progressive.',
		'Boost Mode Power-Ups : Replay, Unlock, and Electrify Orbs supercharge the feature when Boost is ON.',
		'Monster Free Spins: +70 extra Wilds and retriggers bring electrifying wins to life.',
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const SANTAS_TREE_OF_TREETS: GapGameInfo = {
	displayName: "Santa's Tree of Treats",
	gameType: 'gap',
	standardImageUrl: styles.santasTreeOfTreetsUniversal,
	featureImageUrl: styles.santasTreeOfTreetsUniversal,
	gameProviderId: 'Saddle Up Gaming',
	gameId: 'santas-tree-of-treats',
	tagLine: 'UNWRAP THE MAGIC!',
	infoModal: [
		'Santa’s Tree Collection: Grow the Christmas Tree with baubles and trigger jackpots or Hold & Win bonuses.',
		'Bauble Hold & Win: Fill 15 spaces for the 2,500× Grand, with Snow Globe and Santa’s Sack boosters.',
		'Free Spins Choice: Pick your volatility or go Mystery for bauble-packed holiday wins.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const FROGS_FEAST_FORTUNES: GapGameInfo = {
	displayName: "Frog's Feast Fortunes",
	gameType: 'gap',
	standardImageUrl: styles.frogsFeastFortuneUniversal,
	featureImageUrl: styles.frogsFeastFortuneUniversal,
	gameProviderId: 'Saddle Up Gaming',
	gameId: 'frogs-feast-fortune',
	tagLine: 'HOP. SPIN. WIN!',
	infoModal: [
		'Frog Collect Frenzy: Five unique frogs bring thrilling collect mechanics, from multipliers and re-spins to jackpot upgrades.',
		'Jackpot Packed Pond: Catch Fly symbols worth up to 2,500x with Mini, Minor, Major, and Grand Jackpots.',
		'Free Spins Feast: Fill the prize pot during Free Spins and watch the Green Frog swoop in for a final all-in collection!',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const SPARTACUS_10K_WAYS: GapGameInfo = {
	displayName: 'Spartacus 10K Ways',
	gameType: 'gap',
	standardImageUrl: styles.spartacusWaysUniversal,
	featureImageUrl: styles.spartacusWaysUniversal,
	gameProviderId: 'reelplay',
	gameId: 'spartacus10kways',
	tagLine: 'ENTER THE ARENA!',
	infoModal: [
		'10,000 Ways to Win: Epic reel setup with cascading victories that keep the battle going.',
		'Battle Spins: Face gladiators in rounds of combat, striking for prizes and extra life points.',
		'Victory Prize: Defeat the Red Gladiator to claim Mini, Minor, Major, or the Grand 2,000× bonus.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const ARCTIC_TITAN: GapGameInfo = {
	displayName: "Arctic Titan",
	gameType: 'gap',
	standardImageUrl: styles.arcticTitanUniversal,
	featureImageUrl: styles.arcticTitanUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'arctic-titan',
	tagLine: 'RED HOT ROARS AWAIT!',
	infoModal: [
		'1024 Ways to Win: Wild polar bears nudge into place for frosty wins.',
		'Free Spins Multipliers: Growing Wild multipliers boost every win throughout the feature.',
		'Fireshot Heatwave: Lock icy coins for prizes, reel jackpots, and the Grand Jackpot, linked across popular games.',
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const GEM_HUNTRESS_2: GapGameInfo = {
	displayName: "Gem Huntress 2",
	gameType: 'gap',
	standardImageUrl: styles.gemHuntress2Universal,
	featureImageUrl: styles.gemHuntress2Universal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'gem-huntress-2',
	tagLine: 'FORTUNE FAVORS THE FEARLESS!',
	infoModal: [
		'Unlock Epic Treasures: Land 3 or more Scatters to trigger Free Spins, where coins progressively open treasure chests packed with extra spins, wilds, multipliers, and huge rewards.',
		'Hunt for Jackpots: Hit 6 or more Coins to launch the Hold & Spin feature, watch as the Huntress collects prizes and jackpots, including the massive shared Grand Jackpot.',
		'50 Ways to Win: Enjoy fast paced action across 50 win lines on a 5x4 layout, blending classic slot excitement with rewarding modern bonus features.',
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const JELLY_JILLIONS: GapGameInfo = {
	displayName: 'Jelly Jillions',
	gameType: 'gap',
	standardImageUrl: styles.jellyJillionsUniversal,
	featureImageUrl: styles.jellyJillionsUniversal,
	gameProviderId: 'reelplay',
	gameId: 'jellyjillions',
	tagLine: 'CASCADES OF CANDY!',
	infoModal: [
		'Cascading Jellies: Match 5 or more symbols for chain reactions and sweet rewards.',
		'Bonus Re-Spins: Lock scatters, hold and spins, and build prize totals with every drop.',
		'Jackpot Treats: Mini, Minor, Major, or the Grand 2,000× bonus can be unwrapped.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const TEN_THOUSAND_WOLVES_10K_WAYS : GapGameInfo = {
	displayName: '10,000 Wolves 10K Ways',
	gameType: 'gap',
	standardImageUrl: styles.tenThousandWolvesUniversal,
	featureImageUrl: styles.tenThousandWolvesUniversal,
	gameProviderId: 'reelplay',
	gameId: 'tenthousandwolves10kways',
	tagLine: 'JOIN THE WOLF PACK!',
	infoModal: [
		'10,000 Ways to Win: Every spin offers up to 10,000 chances, with cascading wins creating endless wild combinations.',
		'Bonus Re-spins Feature: Land 6+ Scatters to trigger re-spins where every new symbol resets the count and boosts your rewards.',
		'Diamond Jackpots: Hunt down prizes up to 2,000x your play amount with four dazzling jackpot tiers.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GOLD_IS_ALL_MINE: GapGameInfo = {
	displayName: 'Gold is all Mine 10K',
	gameType: 'gap',
	standardImageUrl: styles.goldIsAllMineUniversal,
	featureImageUrl: styles.goldIsAllMineUniversal,
	gameProviderId: 'reelplay',
	gameId: 'gold-is-all-mine',
	tagLine: 'GOLD RUSH WITH EVERY SPIN!',
	infoModal: [
		'10,000 Ways to Win: Every spin offers up to 10,000 chances to uncover golden rewards and cascading wins.',
		'Explosive Free Spins: Land 4+ DYNAMITE symbols to trigger up to 20 Free Spins, with WILDs adding extra spins and boosting your Treasure multiplier.',
		'Treasure Collect Feature: WILDs collect all visible prizes, including Mini, Minor, Major, and Grand rewards worth up to 1,000x your total play amount.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GPAS_LEMERALDS_POP: GapGameInfo = {
	displayName: 'Lucky Emeralds',
	gameType: 'gap',
	standardImageUrl: styles.gpasLemeraldsPopUniversal,
	featureImageUrl: styles.gpasLemeraldsPopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_lemeralds_pop',
	tagLine: 'YOUR LUCKY DAY IS HERE!',
	infoModal: [
		'Wild reels with respins',
		'Simple and elegant gameplay',
		'A classic Irish-themed slot'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const GPAS_BOKING_POP: GapGameInfo = {
	displayName: 'Book of Kings',
	gameType: 'gap',
	standardImageUrl: styles.gpasBokingPopUniversal,
	featureImageUrl: styles.gpasBokingPopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_boking_pop',
	tagLine: 'UNCOVER ANCIENT EXPANDING SYMBOLS!',
	infoModal: [
		'Classic \'Book of\' mechanic',
		'Expanding symbols for big wins',
		'Re-trigger for extra spins'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GPAS_EAPE_POP: GapGameInfo = {
	displayName: 'Epic Ape',
	gameType: 'gap',
	standardImageUrl: styles.gpasEapePopUniversal,
	featureImageUrl: styles.gpasEapePopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_eape_pop',
	tagLine: 'WILD MULTIPLIERS FOR EPIC WINS!',
	infoModal: [
		'4,096 ways to win',
		'Wild multipliers up to 5x',
		'Easy free spins re-triggers'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const GPAS_AWILD2_POP: GapGameInfo = {
	displayName: 'Anaconda Wild II',
	gameType: 'gap',
	standardImageUrl: styles.gpasAwild2PopUniversal,
	featureImageUrl: styles.gpasAwild2PopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_awild2_pop',
	tagLine: 'FOLLOW THE SNAKE\'S WILD TRAIL!',
	infoModal: [
		'Wild respins with a snake trail',
		'Large wilds with multipliers',
		'Wilds can double for wins'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const GPAS_HFORTUNE_POP: GapGameInfo = {
	displayName: 'Halloween Fortune',
	gameType: 'gap',
	standardImageUrl: styles.gpasHfortunePopUniversal,
	featureImageUrl: styles.gpasHfortunePopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_hfortune_pop',
	tagLine: 'PICK YOUR WAY TO MULTIPLIERS!',
	infoModal: [
		'Pick your free spins prize',
		'Choose your win multiplier',
		'Up to 10x multiplier wins'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GPAS_PPPEARLS_POP: GapGameInfo = {
	displayName: 'Pearls Pearls Pearls Fire Blaze Classics',
	gameType: 'gap',
	standardImageUrl: styles.gpasPppearlsPopUniversal,
	featureImageUrl: styles.gpasPppearlsPopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_pppearls_pop',
	tagLine: 'DIVE FOR PEARLS AND PRIZES!',
	infoModal: [
		'Hold and Spin jackpot game',
		'Wild multipliers up to 16x',
		'Classic Fire Blaze bonus'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GPAS_WPISTO_POP: GapGameInfo = {
	displayName: 'Wild Pistolero Mega Fire Blaze',
	gameType: 'gap',
	standardImageUrl: styles.gpasWpistoPopUniversal,
	featureImageUrl: styles.gpasWpistoPopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_wpisto_pop',
	tagLine: 'AIM FOR MEGA FIRE JACKPOTS!',
	infoModal: [
		'Unlockable rows in bonus',
		'Hold and spin enhancers',
		'A mega Fire Blaze jackpot'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GPAS_WPUNCH_POP: GapGameInfo = {
	displayName: 'Wushu Punch',
	gameType: 'gap',
	standardImageUrl: styles.gpasWpunchPopUniversal,
	featureImageUrl: styles.gpasWpunchPopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_wpunch_pop',
	tagLine: 'STRIKE A PRIZE LINK COMBO!',
	infoModal: [
		'Prize links on the reels',
		'Free spins with high symbols',
		'Win static jackpots prizes'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GPAS_AFACTORY_POP: GapGameInfo = {
	displayName: 'Amazing Factory Fire Blaze Golden',
	gameType: 'gap',
	standardImageUrl: styles.gpasAfactoryPopUniversal,
	featureImageUrl: styles.gpasAfactoryPopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_afactory_pop',
	tagLine: 'GOLDEN RICHES REPEAT THEIR WINS!',
	infoModal: [
		'Repeating prizes in hold and spin',
		'Bells are wilds and scatters',
		'A Fire Blaze Golden experience'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GPAS_SQUEEN_POP: GapGameInfo = {
	displayName: 'Sky Queen Fire Blaze Classics',
	gameType: 'gap',
	standardImageUrl: styles.gpasSqueenPopUniversal,
	featureImageUrl: styles.gpasSqueenPopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_squeen_pop',
	tagLine: 'REIGN OVER THE SKIES!',
	infoModal: [
		'Classic hold and spin feature',
		'Stacked symbols in free spins',
		'Win the Grand Jackpot prize'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const GPAS_AZBOLI_POP: GapGameInfo = {
	displayName: 'Azteca Bonus Lines',
	gameType: 'gap',
	standardImageUrl: styles.gpasAzboliPopUniversal,
	featureImageUrl: styles.gpasAzboliPopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_azboli_pop',
	tagLine: 'WIN ON EVERY BONUS LINE!',
	infoModal: [
		'Prize multipliers on win lines',
		'Free spins with static jackpots',
		'A unique Aztec-themed game'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const GPAS_GOLDHIT3_POP: GapGameInfo = {
	displayName: 'Dragon Bonanza Gold Hit',
	gameType: 'gap',
	standardImageUrl: styles.gpasGoldhit3PopUniversal,
	featureImageUrl: styles.gpasGoldhit3PopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_goldhit3_pop',
	tagLine: 'GOLD HIT COLUMNS WIN PRIZES!',
	infoModal: [
		'Persistence mechanic with coins',
		'Multiplier bonus wheel',
		'A gold hit collect feature'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GPAS_QCTOBLO_POP: GapGameInfo = {
	displayName: 'Fire Blaze Toltec Blocks',
	gameType: 'gap',
	standardImageUrl: styles.gpasQctobloPopUniversal,
	featureImageUrl: styles.gpasQctobloPopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_qctoblo_pop',
	tagLine: 'EXPAND THE GRID, WIN BIG!',
	infoModal: [
		'Expandable grid hold and spin',
		'Unlockable reel free spins',
		'Win a Fire Blaze jackpot'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const GPAS_SSTRIKE_POP: GapGameInfo = {
	displayName: 'Stallion Strike Power Zones',
	gameType: 'gap',
	standardImageUrl: styles.gpasSstrikePopUniversal,
	featureImageUrl: styles.gpasSstrikePopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_sstrike_pop',
	tagLine: 'POWER ZONES EXPAND FOR WINS!',
	infoModal: [
		'Create persistent power zones',
		'Power zones expand with wins',
		'Win a mega power spin'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GPAS_CXTREME_POP: GapGameInfo = {
	displayName: 'Chilli Xtreme Ways Boost',
	gameType: 'gap',
	standardImageUrl: styles.gpasCxtremePopUniversal,
	featureImageUrl: styles.gpasCxtremePopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_cxtreme_pop',
	tagLine: 'BOOST YOUR WAYS TO WIN!',
	infoModal: [
		'Expanding ways up to 262,144',
		'Mega symbols and wilds',
		'Reels do not reset in free spins'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const GPAS_WOFIRE1_POP: GapGameInfo = {
	displayName: 'Wheels of Flame',
	gameType: 'gap',
	standardImageUrl: styles.gpasWofire1PopUniversal,
	featureImageUrl: styles.gpasWofire1PopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_wofire1_pop',
	tagLine: 'SPIN THE WHEEL, WIN PRIZES!',
	infoModal: [
		'Persistent symbols on reels',
		'Spin the bonus wheel',
		'Win extra wilds and prizes'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const TENTHOUSANDLIONS10KWAYS: GapGameInfo = {
	displayName: '10,000 Lions 10k Ways',
	gameType: 'gap',
	standardImageUrl: styles.tenThousandLions10KWaysUniversal,
	featureImageUrl: styles.tenThousandLions10KWaysUniversal,
	gameProviderId: 'reelplay',
	gameId: 'tenthousandlions10kways',
	tagLine: 'LIONS ROAR, FORTUNES SOAR!',
	infoModal: [
		'Cascading wins and hold and spin',
		'Hold and win re-trigger',
		'Win static jackpots prizes'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const QUEEN_OF_THE_PYRAMIDS_MEGA_COLLECT_EM: GapGameInfo = {
	displayName: 'Queen of the Pyramids: Mega Collect\'Em',
	gameType: 'gap',
	standardImageUrl: styles.gpasQueenpusPopUniversal,
	featureImageUrl: styles.gpasQueenpusPopUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_queenpus_pop',
	tagLine: 'RISE TO THE TREASURE!',
	infoModal: [
		'Mega Collect\'Em™: Lock coins, gather prizes, and climb the pyramid with every spin.',
		'Free Games Pyramid: Unlock up to 5 extra rows packed with coins, keys, and jackpots.',
		'Jackpot Riches: Diamond Coins unleash MINI, MINOR, MAJOR, or the GRAND prize.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
}

const JAWSOME_JACKPOTS: GapGameInfo = {
	displayName: 'Jawsome Jackpots',
	gameType: 'gap',
	standardImageUrl: styles.jawsomeJackpotsUniversal,
	featureImageUrl: styles.jawsomeJackpotsUniversal,
	gameProviderId: 'vgw',
	gameId: 'jawsome-jackpots',
	tagLine: 'JACKPOTS WITH SERIOUS BITE!',
	infoModal: [
		'Shark-Powered Wins: The Shark Wild sparks the Wheel of Fortune for Free Spins, multipliers, or extra Wilds.',
		'Free Spin Ocean Adventure: Trigger Regular, Big, or Super Free Spins to fill frames with fish, unleash the Shark’s bite, and reveal massive prizes across classic and expanded reels.',
		'Jaw Frame Frenzy: Land Scatters to create and upgrade Jaw Frames from Bone to Gold, each hiding fish prizes, multipliers, or even Mini, Minor, Major, and Grand Jackpots during free spins.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const QBAL_QUANTUMBAC: GapGameInfo = {
	displayName: 'Quantum Baccarat',
	gameType: 'gap',
	standardImageUrl: styles.quantumBaccaratUniversal,
	featureImageUrl: styles.quantumBaccaratUniversal,
	gameProviderId: 'playtech',
	gameId: 'qbal_quantumbac',
	tagLine: 'Quantum Baccarat',
	infoModal: [
		'Live Baccarat version enhanced with multipliers.',
		'Random cards receive Quantum Multipliers before each deal.',
		'Only winning hands can be boosted by Quantum Multipliers.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const BC_SLOTS: GapGameInfo = {
	displayName: 'Brian Christopher\'s Adventure',
	gameType: 'gap',
	standardImageUrl: styles.bcSlotsUniversal,
	featureImageUrl: styles.bcSlotsUniversal,
	gameProviderId: 'Famtasma Gaming',
	gameId: 'bc-slots',
	tagLine: 'SHAKEY, SHAKEY!',
	infoModal: [
		'Shaky Shaky: Brian will appear tossing frames that can transform wilds into Sticky, Multiplier, or Expanding for surprise wins and big reel action.',
		'Epic Free Spin: Travel through Greece, China, and Egypt with re-triggers, Marco’s bonus multipliers, and the Scratch-It Bonus Game for a shot at Progressive Jackpot.',
		'Jackpot Key Thrills: Collect keys in Vegas to spin the Jackpot Wheel and chase a huge progressive prize while keeping the excitement rolling.',
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: false,
}

const INSTANT_KENO: GapGameInfo = {
	displayName: "Instant Keno",
	gameType: 'gap',
	standardImageUrl: styles.instantKenoStandard,
	featureImageUrl: styles.instantKenoFeature,
	gameProviderId: 'ggames',
	gameId: 'INSTANT_KENO',
	tagLine: 'HIT YOUR NUMBERS IN AN INSTANT!',
	infoModal: [
		'Instant Draw Thrills: Pick up to ten numbers from a seventy ball grid and watch twenty balls drop each round, creating nonstop anticipation with every reveal.',
		'Big Multipliers Every Round: Score massive rewards with multipliers climbing as high as 10,000x, turning even a single hit into a breakout win.',
		'Second Chance Boost: Miss every number you picked and you still get ten percent of your play amount back, keeping the action flowing even on a losing round.',
	],
	filteredGameType: 'instant-win',
	overlayClockDesktop: false,
	overlayClockMobile: false,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
}

const ZEN_TREE_TREASURES: GapGameInfo = {
	displayName: 'Zen Tree Treasures',
	gameType: 'gap',
	standardImageUrl: styles.zenTreeUniversal,
	featureImageUrl: styles.zenTreeUniversal,
	gameProviderId: 'ggames',
	gameId: 'zen-tree-treasures',
	tagLine: 'GROW YOUR FORTUNE!',
	infoModal: [
		'Random Tree Surprises: Watch the Zen Tree shake at any moment, triggering extra Wilds, envelope prizes, or additional Scatters that can lead to the Pick Bonus.',
		'Pick Bonus Magic: Select from 8 spots on the lucky Zen Tree to reveal coin prizes, extra picks, Free Spins, or Mini, Minor, Major, and Grand Jackpots.',
		'Free Spin Harmony: Unlock 10 Free Spins by revealing Free Spin symbols, with boosted random tree features and the chance to retrigger for even more spins and bigger wins.',
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const LEGEND_OF_MEDUSA: GapGameInfo = {
	displayName: 'Legend of Medusa',
	gameType: 'gap',
	standardImageUrl: styles.legendOfMedusaUniversal,
	featureImageUrl: styles.legendOfMedusaUniversal,
	gameId: 'legend-of-medusa',
	gameProviderId: 'Hot Sauce Studio',
	tagLine: 'GAZE INTO RICHES!',
	infoModal: [
		'Medusa’s Wheel transforms spins with instant wins, wilds, multipliers, Free Spins and jackpots.',
		'Free Spins with guaranteed Wheel triggers from Wilds and re triggers up to 5000X.',
		'Jackpot Wheel Bonus spins for fixed jackpots up to 4000X or instant prizes.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const PIGS_N_POTS: GapGameInfo = {
	displayName: "Pigs N' Pots",
	gameType: 'gap',
	standardImageUrl: styles.pigsNPotsUniversal,
	featureImageUrl: styles.pigsNPotsUniversal,
	gameId: '4tppigsnpots_94',
	gameProviderId: 'relax',
	tagLine: 'SQUEAL WITH DELIGHT!',
	infoModal: [
		'Piggy Wild Re spins with roaming stacked Wilds that lock in place, move across the reels, and boost every win with multipliers up to 50x',
		'Piggy Prize Spins triggered by Safe scatters, giving you a shot at four jackpots ranging from 50x all the way up to a massive 10,000x',
		'Combo Pots powered Free Spins where six upgradeable pots unlock extra spins, bigger multipliers, more Wild stacks, VIP Reels, Xtra Reels, and bonus access to Piggy Prize Spins',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: false,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: false,
}

const MUSTANG_ACE: GapGameInfo = {
	displayName: 'Mustang Ace',
	gameType: 'gap',
	standardImageUrl: styles.mustangAceUniversal,
	featureImageUrl: styles.mustangAceUniversal,
	gameId: 'MUSTANG',
	gameProviderId: 'ggames',
	tagLine: 'TAKE TO THE SKIES!',
	infoModal: [
		'Crash game where you play Coins on a rising multiplier and redeem at the right moment before the game ends',
		'Fast paced rounds with a Mustang flight animation auto redeem options up to x5000 and quick countdowns between games',
		'Strategy focused gameplay with game history and statistics to help you refine timing and maximise potential winnings',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const SACRED_CHILIS: GapGameInfo = {
	displayName: 'The Sacred Chilis',
	gameType: 'gap',
	standardImageUrl: styles.sacredChilisUniversal,
	featureImageUrl: styles.sacredChilisUniversal,
	gameProviderId: 'gfs',
	gameId: 'the-sacred-chilis',
	tagLine: 'THE HEAT IS ON!',
	infoModal: [
		'243 ways to win with spicy Wild Multipliers.',
		'Trigger the Hold and Spin feature with coin prizes and special Chili bonuses.',
		'Win Mini and Minor jackpots or chase the Major and Grand progressives.'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: true,
}

const KABUKI_10k: GapGameInfo = {
	displayName: 'Kabuki 10K Ways',
	gameType: 'gap',
	standardImageUrl: styles.kabukiUniversal,
	featureImageUrl: styles.kabukiUniversal,
	gameProviderId: 'reelplay',
	gameId: 'kabuki10kways',
	tagLine: 'TAKE THE STAGE!',
	infoModal: [
		'10,000 ways to win with a 6 reel layout and cascading awards.',
		'Free Spins with unlimited win multiplier and spin resets.',
		'Oversized Scatters award instant Coin Prizes up to 100x your play amount.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
}

const FIRE_BLAZE_ETERNAL_LADY: GapGameInfo = {
	displayName: 'Fire Blaze Eternal Lady',
	gameType: 'gap',
	standardImageUrl: styles.eternalLadyUniversal,
	featureImageUrl: styles.eternalLadyUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_elady_pop',
	tagLine: 'LIGHT UP THE NIGHT!',
	infoModal: [
		'Pick a Mooncake to trigger Fire Blaze re-spins or up to 12 Free Games packed with extra stacked Wilds',
		'Lock Moon symbols in the Fire Blaze Feature and chase prizes up to 2000x',
		'Re-trigger Free Games while keeping all added Wilds active for massive win potential'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
}

const GRAVITY_WHEEL: GapGameInfo = {
	displayName: 'Gravity Wheel',
	gameType: 'gap',
	standardImageUrl: styles.gravityWheelUniversal,
	featureImageUrl: styles.gravityWheelUniversal,
	gameProviderId: 'iconic21',
	gameId: 'launch_wheel_gravity',
	tagLine: 'Gravity Wheel',
	infoModal: [
		'8 Prize Segments per Spin',
		'Instant Multiplier Reveal',
		'Up to x1000 Prize Boost',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const GRAND_BONUS_BACCARAT: GapGameInfo = {
	displayName: 'Grand Bonus Baccarat',
	gameType: 'gap',
	standardImageUrl: styles.grandBonusBaccaratUniversal,
	featureImageUrl: styles.grandBonusBaccaratUniversal,
	gameProviderId: 'iconic21',
	gameId: 'launch_rom_main_gbb_1',
	tagLine: 'Grand Bonus Baccarat',
	infoModal: [
		'Unlock Bonuses with Streaks',
		'Play on Player or Banker',
		'Get Closest to 9 to Win',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const GRAND_BONUS_BLACKJACK: GapGameInfo = {
	displayName: 'Grand Bonus Blackjack',
	gameType: 'gap',
	standardImageUrl: styles.grandBonusBlackjackUniversal,
	featureImageUrl: styles.grandBonusBlackjackUniversal,
	gameProviderId: 'iconic21',
	gameId: 'launch_rom_gbbj_1',
	tagLine: 'Grand Bonus Blackjack',
	infoModal: [
		'Unlock Progressive Bonuses',
		'Win 5 Hands in a Row',
		'Random Bonus Multipliers',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const LIVE_ROULETTE_I21: GapGameInfo = {
	displayName: 'Live Roulette',
	gameType: 'gap',
	standardImageUrl: styles.liveRouletteI21Universal,
	featureImageUrl: styles.liveRouletteI21Universal,
	gameProviderId: 'iconic21',
	gameId: 'launch_main_rol_01',
	tagLine: 'Live Roulette',
	infoModal: [
		'Play on a physical table-top single-zero Roulette wheel featuring 37 sectors, numbered 0 to 36.',
		'Real-Time Gameplay: Enjoy an authentic casino atmosphere with live video feeds from professional hosts.',
		'Comprehensive Game Insights: Access detailed statistics, including red/black percentages and even/odd ratios, view table trends with a pie chart display.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const SPIN_A_WIN: GapGameInfo = {
	displayName: 'Spin A Win',
	gameType: 'gap',
	standardImageUrl: styles.spinAWinUniversal,
	featureImageUrl: styles.spinAWinUniversal,
	gameProviderId: 'playtech',
	gameId: 'swl_spinawin',
	tagLine: 'Spin A Win',
	infoModal: [
		'The game is played with a manually spun 54-sector wheel. Your goal? Predict the winning sector!',
		'Jump in at any time and place your chips before the next spin.',
		'Place your chips, watch the wheel turn, and chase thrilling wins in this must-play live casino game!',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'bottom-right',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const THIRD_TIMES_A_CHARM: GapGameInfo = {
	displayName: 'Third Time\'s a Charm',
	gameType: 'gap',
	standardImageUrl: styles.thirdTimesACharmUniversal,
	featureImageUrl: styles.thirdTimesACharmUniversal,
	gameProviderId: 'vgw',
	gameId: 'third-times-a-charm',
	tagLine: 'CHASE THE CHARM!',
	infoModal: [
		'Three evolving jackpot pots with stacked multipliers and collectors',
		'Hold and Spin with triple reel sets and escalating features',
		'Huge win potential up to 12,442x'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnDesktop: 'bottom-left',
	overlayClockPositionOnMobile: 'bottom-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const TWISTER_MANIA: GapGameInfo = {
	displayName: 'Twister Mania',
	gameType: 'gap',
	standardImageUrl: styles.twisterManiaUniversal,
	featureImageUrl: styles.twisterManiaUniversal,
	gameProviderId: 'vgw',
	gameId: 'twister-mania',
	tagLine: 'TWIST THE REELS!',
	infoModal: [
		'Iconic Fun Reimagined; colourful 4x6 slot with 50 win lines inspired by the classic Twister game, packed with energy, nostalgia and big win potential.',
		'Explosive Bonus Features; Twister Free Spins, Fortune Wheel boosts, Mystery Box symbols and a full arsenal of Wild features that keep every spin unpredictable and exciting.',
		'Non Stop Action; From the Twister Time feature to wild filled Free Spins, every round is designed to deliver constant action and full of winning opportunities.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const CRASH_LIVE: GapGameInfo = {
	displayName: 'Crash Live',
	gameType: 'gap',
	standardImageUrl: styles.crashLiveUniversal,
	featureImageUrl: styles.crashLiveUniversal,
	gameProviderId: 'iconic21',
	gameId: 'launch_rom_sport_crash_1',
	tagLine: 'Crash Live',
	infoModal: ['Live Host', 'Real-time Leaderboards', 'Auto play & Auto Redeem Options'],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const FIRE_BLAZE_GOLDEN_BUCCANEERS_BELLS: GapGameInfo = {
	displayName: 'Fire Blaze Golden Buccaneers Bells',
	gameType: 'gap',
	standardImageUrl: styles.fireBlazeGoldenBuccaneersBellsUniversal,
	featureImageUrl: styles.fireBlazeGoldenBuccaneersBellsUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_fbgbb95_pop',
	tagLine: 'SET SAIL FOR BLAZING RICHES!',
	infoModal: [
		'Explosive Fire Blaze Re-spins; Trigger the Golden Re-spin Feature to lock in coin prizes, reset re-spins with new Bells and build toward the ultimate Grand win with every spin.',
		'Treasure Packed Reels with Big Win Potential; Stacked Wilds, gleaming Bells and 40 action filled lines combine to deliver constant excitement and serious reward potential on every voyage.',
		'Win Free Games and keep the adventure alive with extra retriggers that stack your chances of uncovering even more treasure.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: false,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const CHUBBY_CHICKS_JACKPOTS: GapGameInfo = {
	displayName: 'Chubby Chicks Jackpots',
	gameType: 'gap',
	standardImageUrl: styles.chubbyChicksJackpotsUniversal,
	featureImageUrl: styles.chubbyChicksJackpotsUniversal,
	gameProviderId: 'twofish',
	gameId: 'chubby-chicks-jackpots',
	tagLine: 'FARM FUN & FEATHERED FORTUNES!',
	infoModal: [
		'Collection; Watch the adorable chicks grow as it collects coins, triggering exciting bonus games and chances to win big jackpots.',
		'Dual Bonus Features; Unlock the Jackpot Pick Bonus or the high value Coin Hold & Win Bonus for massive win potential, including a Grand 2,500x jackpot.',
		'Customizable Free Spins; Choose an option to tailor your winning strategy, with retriggers and extra coins boosting your chances.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true
}

const GOLD_OVERLOAD: GapGameInfo = {
	displayName: 'Gold Overload',
	gameType: 'gap',
	standardImageUrl: styles.goldOverloadUniversal,
	featureImageUrl: styles.goldOverloadUniversal,
	gameProviderId: 'gfs',
	gameId: 'gold-overload',
	tagLine: 'LEAD THE GOLD RUSH!',
	infoModal: [
		'243 ways to win with explosive TNT bonus spins on any base game spin',
		'Free spins with upgrading Ore frames that unlock jackpots and bonus prizes',
		'Shared Grand progressive jackpot for massive win potential'
	],
	hasJackpot: true,
	jackpotToDisplay: 'grand',
	useGapJackpot: true,
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
}

const GRAVITY_ROULETTE: GapGameInfo = {
	displayName: 'Gravity Roulette',
	gameType: 'gap',
	standardImageUrl: styles.gravityRouletteUniversal,
	featureImageUrl: styles.gravityRouletteUniversal,
	gameProviderId: 'iconic21',
	gameId: 'launch_mrol_gravity',
	tagLine: 'Gravity Roulette',
	infoModal: ['Automatic Single 0 Roulette', 'Multipliers up to x1000', 'Up to 5 Random Multipliers'],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const SIC_BO_DELUXE: GapGameInfo = {
	displayName: 'Sic Bo Deluxe',
	gameType: 'gap',
	standardImageUrl: styles.sicBoDeluxeUniversal,
	featureImageUrl: styles.sicBoDeluxeUniversal,
	gameProviderId: 'playtech',
	gameId: 'sbdl_deluxesicbo',
	tagLine: 'Sic Bo Deluxe',
	infoModal: ['Fast-paced 3-Dice Combo', 'High Multipliers', 'Up to 6 Random Multipliers'],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'bottom-right',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino',
}

const ASTRO_DOGFIGHT: GapGameInfo = {
	displayName: 'Astro Dogfight 10K Ways',
	gameType: 'gap',
	standardImageUrl: styles.astroDogfightUniversal,
	featureImageUrl: styles.astroDogfightUniversal,
	gameProviderId: 'reelplay',
	gameId: 'astro-dogfight-10kways',
	tagLine: 'FIGHT FOR COSMIC GLORY!',
	infoModal: [
		'6 reel, 10,000 ways setup with cascading reels that continue winning sequences',
		'Battle Spins feature with life points and escalating enemy fights',
		'Guaranteed bonus prize up to 2,000x after defeating all opponents',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'bottom-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const KING_CROC_FURY: GapGameInfo = {
	displayName: 'King Croc Fury',
	gameType: 'gap',
	standardImageUrl: styles.kingCrocFuryUniversal,
	featureImageUrl: styles.kingCrocFuryUniversal,
	gameProviderId: 'gfs',
	gameId: 'king-croc-fury',
	tagLine: 'UNLEASH THE BEAST!',
	infoModal: [
		'4096 ways to win with optional Bonus Mode and Croc Attack boosts',
		'Free spins with bonus wheels and extra croc symbols on the reels',
		'Fireshot Diamond feature with Mini, Minor, Major and standalone Grand jackpots'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
}

const GRAVITY_BLACKJACK: GapGameInfo = {
	displayName: 'Gravity Blackjack',
	gameType: 'gap',
	standardImageUrl: styles.gravityBlackjackUniversal,
	featureImageUrl: styles.gravityBlackjackUniversal,
	gameProviderId: 'iconic21',
	gameId: 'launch_main_ssbj_01',
	tagLine: 'Gravity Blackjack',
	infoModal: [
		'Dynamic Multipliers',
		'Unlimited amount of players',
		'Side-Play options available'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	filteredGameType: 'social-live-casino'
}

const LOAD_EM_UP: GapGameInfo = {
	displayName: 'Load \'Em Up',
	gameType: 'gap',
	standardImageUrl: styles.loadEmUpUniversal,
	featureImageUrl: styles.loadEmUpUniversal,
	gameProviderId: 'Hot Sauce Studios',
	gameId: 'load-em-up',
	tagLine: 'LOAD UP ON AMAZING WINS!',
	infoModal: [
		'3 ways to win the Load \'em Up Bonus Feature!',
		'Unlock the Golden Gates to award the Pure Gold Full Steam Ahead Feature and HUGE wins!',
		'4 Jackpots: MINI - 20X / MINOR - 50X / MAJOR - 250X / GRAND - 2500X the play value!'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const PRIZE_PINATA: GapGameInfo = {
	displayName: 'Prize Piñata',
	gameType: 'gap',
	standardImageUrl: styles.prizePinataUniversal,
	featureImageUrl: styles.prizePinataUniversal,
	gameProviderId: 'Saddle Up Gaming',
	gameId: 'prize-pinata',
	tagLine: 'IT’S FIESTA TIME!',
	infoModal: [
		'Grow, pop, and win big with piñatas that build as you spin and explode for rewards up to 16,000x',
		'Unlock three bonus boosts including multipliers, double reels, and a collector feature in Hold and Spin',
		'Persistent piñata pots keep growing between sessions and can award jackpots up to 2,000x',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const DRAGON_TIGER: GapGameInfo = {
	displayName: 'Dragon Tiger',
	gameType: 'gap',
	standardImageUrl: styles.dragonTigerUniversal,
	featureImageUrl: styles.dragonTigerUniversal,
	gameProviderId: 'iconic21',
	gameId: 'launch_dt_2',
	tagLine: 'Dragon Tiger',
	infoModal: [
		'Predict outcome between Dragon, Tiger or Tie',
		'Unlimited players can occupy a single seat',
		'Tie option plays',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	filteredGameType: 'social-live-casino',
}

const BASS_10K_WAYS: GapGameInfo = {
	displayName: '10,000 Bass 10K Ways',
	gameType: 'gap',
	standardImageUrl: styles.bassUniversal,
	featureImageUrl: styles.bassUniversal,
	gameProviderId: 'reelplay',
	gameId: 'ten-thousand-bass-10k-ways',
	tagLine: 'HOOK THE BIG ONE!',
	infoModal: [
		'Up to 10,000 ways to win every spin',
		'WILDs collect all visible BASS prizes',
		'Re-trigger Free Spins with rising multiplier',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'bottom-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const THE_RACAROON: GapGameInfo = {
	displayName: 'The Racaroon',
	gameType: 'gap',
	standardImageUrl: styles.racaroonUniversal,
	featureImageUrl: styles.racaroonUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_racrnsa1_pop',
	tagLine: 'SWEET WINS ARE UP FOR GRABS',
	infoModal: [
		'Hot Zone Wild collects all visible Coin Prizes while substituting for wins',
		'Win multipliers up to 10x plus rewind chances',
		'Racaroon Re-spins and Golden Macaroon bonus features offer up to 5000x prize potential'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: false,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const WONDERLAND_LUCKYBALL: GapGameInfo = {
	displayName: 'Wonderland Lucky Ball',
	gameType: 'gap',
	standardImageUrl: styles.wonderlandLuckyballUniversal,
	featureImageUrl: styles.wonderlandLuckyballUniversal,
	gameProviderId: 'playtech',
	gameId: 'abwlbl_abwlbl',
	tagLine: 'Wonderland Lucky Ball',
	infoModal: ['Combination of live ball drawing and bonus games', '10 possible winning lines', 'Each Lucky Ball number on a line enhances the prize'],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'bottom-right',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino',
}

const AUTO_ROULETTE: GapGameInfo = {
	displayName: 'Auto Roulette',
	gameType: 'gap',
	standardImageUrl: styles.autoRouletteUniversal,
	featureImageUrl: styles.autoRouletteUniversal,
	gameProviderId: 'iconic21',
	gameId: 'launch_auto_rol_01',
	tagLine: 'Auto Roulette',
	infoModal: ['Auto - European Roulette', 'Wheel featuring 37 sectors, numbered 0 to 36', 'Comprehensive Game Insights: Access detailed statistics'],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'bottom-right',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino',
}

const BIG_ZERO_ROULETTE: GapGameInfo = {
	displayName: 'Big Zero Roulette',
	gameType: 'gap',
	standardImageUrl: styles.bigZeroRouletteUniversal,
	featureImageUrl: styles.bigZeroRouletteUniversal,
	gameProviderId: 'saddle-up-gaming',
	gameId: 'big-zero-roulette',
	tagLine: 'THE POWER OF ZERO!',
	infoModal: [
		'Streamlined 42 pocket wheel including 6 BIG ZERO sectors for double bonus opportunities and thrilling gameplay.',
		'BIG ZERO Feature offers massive multipliers up to 100× your play and bonus wheel surprises for even bigger wins.',
		'Fast, high impact roulette action with 36× rewards on straight number hits.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	filteredGameType: 'table',
}

const CHEEKY_FRUITS_TRIO_BONUS: GapGameInfo = {
	displayName: 'Cheeky Fruits Trio Bonus',
	gameType: 'gap',
	standardImageUrl: styles.cheekyFruitsTrioBonusUniversal,
	featureImageUrl: styles.cheekyFruitsTrioBonusUniversal,
	gameProviderId: 'ggames',
	gameId: 'TBG_CHEEKY_FRUITS',
	tagLine: 'TRIPLE FORTUNES AWAIT!',
	infoModal: [
		'7 explosive bonus features including Wild Stacks, Multipliers, Jackpots, and double and TRIO combinations.',
		'Expanded 6 high reels with up to 100 win lines, full reel Wilds, and re triggerable Free Spins.',
		'Win up to 5000x with jackpot prizes, boosted by 3x multipliers and stacked Wild action.'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
}

const EAGLE_EMPIRE: GapGameInfo = {
	displayName: '9 Flags Eagle Empire',
	gameType: 'gap',
	standardImageUrl: styles.eagleEmpireUniversal,
	featureImageUrl: styles.eagleEmpireUniversal,
	gameProviderId: 'vgw',
	gameId: 'eagle-empire',
	tagLine: 'GET READY TO TAKE FLIGHT!',
	infoModal: [
		'3 Pot Nest mechanic where red, white, and blue diamond collections unlock different bonus paths',
		'Triple bonus trigger system including diamond matches, nest growth, and eagle collect feature activating up to all three pots at once',
		'Expanding Eagle Empire bonus with grid growth up to 5x8, extra spins, jackpots, and optional Ultra Mode for rapid autoplay and instant bonus results'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const THE_KICKOFF: GapGameInfo = {
	displayName: 'The Kickoff',
	gameType: 'gap',
	standardImageUrl: styles.theKickoffUniversal,
	featureImageUrl: styles.theKickoffUniversal,
	gameProviderId: 'iconic21',
	gameId: 'launch_rom_sport_kickoff_1',
	tagLine: 'The Kickoff',
	infoModal: [
		'Football-themed Table',
		'Predict which colored dice will win',
		'3 Different outcomes'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	filteredGameType: 'social-live-casino'
}

const PIZZA_BOSS: GapGameInfo = {
	displayName: 'Pizza Boss',
	gameType: 'gap',
	standardImageUrl: styles.pizzaBossUniversal,
	featureImageUrl: styles.pizzaBossUniversal,
	gameProviderId: 'gfs',
	gameId: 'pizza-boss',
	tagLine: 'GRAB A SLICE OF THE ACTION!',
	infoModal: [
		'Instant Pizza Prizes triggered by Wild Gigi, including coin wins and progressive jackpots',
		'Feature Wheel with Free Spins, extra symbols, and upgraded rewards',
		'Shared Progressive jackpots, with Major and Grand prizes available',
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	overlayClockPositionOnDesktop: 'bottom-right',
	overlayClockPositionOnMobile: 'bottom-right',
}

const GOLD_TRIO_SOCCER: GapGameInfo = {
	displayName: 'Gold Trio Soccer',
	gameType: 'gap',
	standardImageUrl: styles.goldTrioSoccerUniversal,
	featureImageUrl: styles.goldTrioSoccerUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_gtfbb1_pop',
	tagLine: 'SCORE BIG WITH EVERY RE-SPIN!',
	infoModal: [
		'Fast paced re-spin feature where locked coins build the grid toward a 15 position win and a 1000x Grand Prize',
		'Coloured coins with unique exciting features that multiply values, transform rewards, and trigger fixed jackpots',
		'Constant action re-spins where every new coin can reset the feature and increase win potential throughout the game'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: false,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const PSYCHO_CANDIES: GapGameInfo = {
	displayName: 'Psycho Candies',
	gameType: 'gap',
	standardImageUrl: styles.psychoCandiesUniversal,
	featureImageUrl: styles.psychoCandiesUniversal,
	gameProviderId: 'ggames',
	gameId: 'PSYCHO_CANDY_SLOTS',
	tagLine: 'STICKY SWEET BONUSES!',
	infoModal: [
		'Match 4 cascades with increasing win multipliers',
		'Explosive candy bomb symbols clear large sections of the grid',
		'5 boss levels with bonus wheel and extra game features'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
}

const TOP_CARD: GapGameInfo = {
	displayName: 'Top Card',
	gameType: 'gap',
	standardImageUrl: styles.topCardUniversal,
	featureImageUrl: styles.topCardUniversal,
	gameProviderId: 'iconic21',
	gameId: 'launch_rom_sport_tc_1',
	tagLine: 'Top Card',
	infoModal: [
		'Guess the higher-value card',
		'Play on Champion or Contender',
		'Draw result is 11:1 '
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	filteredGameType: 'social-live-casino'
}

const BERSERKER_BUCKS: GapGameInfo = {
	displayName: 'Berserker Bucks 20K',
	gameType: 'gap',
	standardImageUrl: styles.berserkerBucksUniversal,
	featureImageUrl: styles.berserkerBucksUniversal,
	gameProviderId: 'Hot Sauce Studios',
	gameId: 'berserker-bucks',
	tagLine: '20,000 WAYS TO GLORY!',
	infoModal: [
		'20,736 Ways to Win!',
		'Any Wilds in view are Locked in place until they are part of a winning symbol combination!',
		'Collect as many Coins as possible for Huge Wins!'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnDesktop: 'bottom-left',
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: false,
}

const ROYAL_ROULETTE: GapGameInfo = {
	displayName: 'Royal Roulette',
	gameType: 'gap',
	standardImageUrl: styles.royalRouletteUniversal,
	featureImageUrl: styles.royalRouletteUniversal,
	gameProviderId: 'iconic21',
	gameId: 'launch_rom_gs_rol_1',
	tagLine: 'Royal Roulette',
	infoModal: [
		'European Roulette',
		'Wheel featuring 37 sectors, numbered 0 to 36.',
		'Comprehensive Game Insights: Access detailed statistics'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	filteredGameType: 'social-live-casino'
}

const SUSHI_SPARKLE: GapGameInfo = {
	displayName: 'Sushi Sparkle',
	gameType: 'gap',
	standardImageUrl: styles.sushiSparkleUniversal,
	featureImageUrl: styles.sushiSparkleUniversal,
	gameProviderId: 'gfs',
	gameId: 'sushi-sparkle',
	tagLine: 'MEOWVELOUS!',
	infoModal: [
		'8+ symbol scatter wins on a 6x5 grid with cascading wins and rising multipliers up to x5 for huge combo potential',
		'Coin and Lucky Cat symbols trigger instant prizes, jackpot chances, prize boosts, extra Coins, and symbol clears during winning cascades',
		'Free Spins feature with retriggers and a Stored Coin/Cat meter that keeps building and reawarding collected prizes throughout the bonus round'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnDesktop: 'bottom-left',
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
}

const SIC_BO: GapGameInfo = {
	displayName: 'Sic Bo',
	gameType: 'gap',
	standardImageUrl: styles.sicBoUniversal,
	featureImageUrl: styles.sicBoUniversal,
	gameProviderId: 'iconic21',
	gameId: 'launch_asia_sb_1',
	tagLine: 'Sic Bo',
	infoModal: [
		'Play on three dice outcomes',
		'Over 20 side plays available',
		'Automatic shaker rolls dice'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	filteredGameType: 'social-live-casino'
}

const NINE_FLAGS_PLINKO: GapGameInfo = {                                                                                                                                                                  
  displayName: '9 Flags Plinko',                                                                                                                                                                          
  gameType: 'gap',                                                                                                                                                                                        
  standardImageUrl: styles.nineFlagsPlinkoUniversal,                                                                                                                                                    
  featureImageUrl: styles.nineFlagsPlinkoUniversal,                                                                                                                                                       
  gameProviderId: 'Saddle Up Gaming',                                                                                                                                                                     
  gameId: 'nine-flags-plinko',                                                                                                                                                                            
  tagLine: 'CLASSIC PLINKO ACTION!',                                                                                                                                                                      
  infoModal: [                                                                                                                                                                                            
    'Classic Plinko gameplay with fast drop-and-bounce action',                                                                                                                                           
    'Multiple reward tiers with higher multipliers on harder modes',                                                                                                                                      
    'Adjustable play amounts and selectable levels to suit your style'                                                                                                                                    
  ],                                                                                                                                                                                                      
  overlayClockDesktop: true,                                                                                                                                                                              
  overlayClockMobile: true,                                                                                                                                                                               
  hasInsufficientCoinDialogAvailableInGame: true,                                                                                                                                                         
  onlyUpdateBalanceOnGameRoundCompleted: false,                                                                                                                                                           
  moveCloseButtonLeftOnDesktop: true,                                                                                                                                                                     
  moveCloseButtonLeftOnMobile: true,                                                                                                                                                                      
  showMuteButtonOverlay: false,                                                                                                                                                                            
  moveMuteButtonLeftOnDesktop: true,                                                                                                                                                                      
  moveMuteButtonLeftOnMobile: true,
	filteredGameType: 'instant-win',
}   

const MOW_MONEY: GapGameInfo = {                                                                                                                                                                  
  displayName: 'Mow Money',                                                                                                                                                                          
  gameType: 'gap',                                                                                                                                                                                        
  standardImageUrl: styles.mowMoneyUniversal,                                                                                                                                                    
  featureImageUrl: styles.mowMoneyUniversal,                                                                                                                                                       
  gameProviderId: 'reelplay',                                                                                                                                                                     
  gameId: 'mow-money',                                                                                                                                                                            
  tagLine: 'RAKE IN THE REWARDS!',                                                                                                                                                                      
  infoModal: [                                                                                                                                                                                            
    'Chain reaction wins keep spins active, with symbols clearing and cascading while the mower upgrades symbols into WILDS for bigger wins',                                                                                                                                           
    'Bonus Re-spins lock in SCATTERS that reset spins and stack hidden prizes',                                                                                                                                      
    'LAWN MOWER MAN and the 10K BONUS, with reel-clearing collections and a chance to land a full screen for a 10,000x win'                                                                                                                                    
  ],                                                                                                                                                                                                      
  overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'bottom-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
}

const ROULETTE_LITE: GapGameInfo = {
	displayName: 'Roulette Lite',
	gameType: 'gap',
	standardImageUrl: styles.launchMainRolLite1Universal,
	featureImageUrl: styles.launchMainRolLite1Universal,
	gameProviderId: 'iconic21',
	gameId: 'launch_main_rol_lite_1',
	tagLine: 'Roulette Lite',
	infoModal: [
		'European Roulette',
		'Wheel featuring 37 sectors, numbered 0 to 36.',
		'Comprehensive Game Insights: Access detailed statistics',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	filteredGameType: 'social-live-casino'
}

const DIGGER_DIGGER_GOLDEN_WINNER: GapGameInfo = {
	displayName: 'Digger Digger Golden Winner',
	gameType: 'gap',
	standardImageUrl: styles.diggerUniversal,
	featureImageUrl: styles.diggerUniversal,
	gameProviderId: 'Saddle Up Gaming',
	gameId: 'digger',
	tagLine: 'GET READY TO STRIKE GOLD!',
	infoModal: [
		'Mine themed slot with expanding reel rows and increasing rewards as you dig deeper into the bonus feature',
		'Dynamite Wilds and random triggers that boost wins, substitute symbols, and can instantly unlock bonus opportunities',
		'Hold and spin style bonus with nugget collection, progressive reel expansion, and a 10,000x Grand Prize at the deepest level',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
}

const GRAVITY_SIC_BO: GapGameInfo = {                                                                                                                                                                  
  displayName: 'Gravity Sic Bo',                                                                                                                                                                          
  gameType: 'gap',                                                                                                                                                                                        
  standardImageUrl: styles.gravitySicBoUniversal,                                                                                                                                                    
  featureImageUrl: styles.gravitySicBoUniversal,                                                                                                                                                       
  gameProviderId: 'iconic21',                                                                                                                                                                     
  gameId: 'launch_gravity_sb',                                                                                                                                                                            
  tagLine: 'Gravity Sic Bo',                                                                                                                                                                      
  infoModal: [                                                                                                                                                                                            
    'Dice game with multipliers',                                                                                                                                           
    'Win up to x1000 prize',                                                                                                                                      
    'Play on dice combinations'                                                                                                                                    
  ],                                                                                                                                                                                                      
  overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	filteredGameType: 'social-live-casino'                                                                                                                                                   
}

const THREE_WONDERS_PHOENIX: GapGameInfo = {
	displayName: '3 Wonders Phoenix',
	gameType: 'gap',
	standardImageUrl: styles.threeWondersPhoenixUniversal,
	featureImageUrl: styles.threeWondersPhoenixUniversal,
	gameProviderId: 'reelplay',
	gameId: 'three-wonders-phoenix',
	tagLine: 'FORTUNES RISES FROM THE FLAMES!',
	infoModal: [
		'Phoenix themed slot with Free Spins feature that unlocks multiple bonus rewards through Pots of Gold',
		'Expanding, contagious, and multiplying Wild mechanics that significantly increase win potential across the reels',
		'Hold and Re spin feature with coin collection and reset mechanic that builds towards wins up to 25x total play amount',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
}

const GRAVITY_AUTO_ROULETTE: GapGameInfo = {                                                                                                                                                                  
  displayName: 'Gravity Auto Roulette',                                                                                                                                                                          
  gameType: 'gap',                                                                                                                                                                                        
  standardImageUrl: styles.gravityAutoRouletteUniversal,                                                                                                                                                    
  featureImageUrl: styles.gravityAutoRouletteUniversal,                                                                                                                                                       
  gameProviderId: 'iconic21',                                                                                                                                                                     
  gameId: 'launch_rom_auto_mrol_1',                                                                                                                                                                            
  tagLine: 'Gravity Auto Roulette',                                                                                                                                                                      
  infoModal: [                                                                                                                                                                                            
    'Auto-European Roulette',                                                                                                                                           
    'Multipliers up to x1000',                                                                                                                                      
    'Up to 5 random multipliers'                                                                                                                                    
  ],                                                                                                                                                                                                      
  overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	filteredGameType: 'social-live-casino'                                                                                                                                                   
}

const PAY_PIG_10K_WAYS: GapGameInfo = {
	displayName: 'Pay Pig 10K Ways',
	gameType: 'gap',
	standardImageUrl: styles.payPigTenKWaysUniversal,
	featureImageUrl: styles.payPigTenKWaysUniversal,
	gameProviderId: 'reelplay',
	gameId: 'pay-pig-10k-ways',
	tagLine: 'GO WHOLE HOG FOR GOLD!',
	infoModal: [
		'10,000 ways to win on every spin',
		'Cascading wins for consecutive rewards',
		'Bonus Re-spins with jackpots up to 2,000x',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnMobile: 'bottom-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const VIDEO_POKER: GapGameInfo = {
	displayName: 'Video Poker',
	gameType: 'gap',
	standardImageUrl: styles.videoPokerUniversal,
	featureImageUrl: styles.videoPokerUniversal,
	gameProviderId: 'vgw',
	gameId: 'video-poker',
	tagLine: '6 CLASSIC POKER GAMES IN 1!',
	infoModal: [
		'6 classic Video Poker modes in one game',
		'Hold and draw gameplay puts every decision in your hands',
		'Fast single round action with instant wins',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: false,
	overlayClockPositionOnMobile: 'top-left',
	overlayClockPositionOnDesktop: 'top-left',
	filteredGameType: 'table',
}

const TEEN_PATTI: GapGameInfo = {
	displayName: 'Teen Patti',
	gameType: 'gap',
	standardImageUrl: styles.teenPattiUniversal,
	featureImageUrl: styles.teenPattiUniversal,
	gameProviderId: 'iconic21',
	gameId: 'launch_in_botp_1',
	tagLine: 'Teen Patti',
	infoModal: ['Three-card poker variant', 'Push result return plays', 'Engaging side plays included'],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	filteredGameType: 'social-live-casino',
}

const MAGMA_MOOLAH: GapGameInfo = {
	displayName: 'Magma Moolah',
	gameType: 'gap',
	standardImageUrl: styles.magmaMoolahUniversal,
	featureImageUrl: styles.magmaMoolahUniversal,
	gameProviderId: 'vgw',
	gameId: 'magma-moolah',
	tagLine: 'FEED THE VOLCANO!',
	infoModal: [
		'Growing Volcano Pot that can erupt into guaranteed jackpot wins',
		'Wild Rex Free Spins with stacked wild multipliers up to 5x',
		'Expanding Hold and Spin bonus up to a massive 5x8 reel grid with enhanced fireball prizes',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const BUBBLE_CRAPS: GapGameInfo = {
	displayName: 'Bubble Craps',
	gameType: 'gap',
	standardImageUrl: styles.bubbleCrapsUniversal,
	featureImageUrl: styles.bubbleCrapsUniversal,
	gameProviderId: 'iconic21',
	gameId: 'launch_craps_1',
	tagLine: 'Bubble Craps',
	infoModal: ['Auto-Traditional Craps', 'Includes Don\'t Pass and Don\'t Come plays', 'Top Numbers and Winning Streaks live trackers'],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	filteredGameType: 'social-live-casino',
}

const NINE_FLAGS_ROUTE_TO_GLORY: GapGameInfo = {
	displayName: '9 Flags Route To Glory',
	gameType: 'gap',
	standardImageUrl: styles.nineFlagsRouteToGloryUniversal,
	featureImageUrl: styles.nineFlagsRouteToGloryUniversal,
	gameProviderId: 'vgw',
	gameId: 'nine-flags-route-to-glory',
	tagLine: 'HOW FAR WILL YOU GO!',
	infoModal: [
		'Choose Your Route; Guide Uncle Sam across 9 flags and see how far your luck can take you on the road to Vegas.',
		'Climb for Bigger Rewards; Each successful step moves you closer to larger rewards and greater glory.',
		'Know When to Stop; Decide whether to keep climbing or lock in your progress before a risky tile sends you back to the start.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	filteredGameType: 'instant-win',
}

const HYPER_RESPINS: GapGameInfo = {
	displayName: 'Hyper Respins',
	gameType: 'gap',
	standardImageUrl: styles.hyperRespinsUniversal,
	featureImageUrl: styles.hyperRespinsUniversal,
	gameProviderId: 'reelplay',
	gameId: 'hyper-respins',
	tagLine: 'INTERSTELLAR WINS AWAIT!',
	infoModal: [
		'Trigger Hyper Symbols including Bombs, Zaps, Megazaps, and Hyperbombs to create explosive chain reactions across the grid.',
		'Land 5 or more Scatters to unlock Bonus Respins, where additional Scatters reset the counter and stay locked in place.',
		'Win up to 100x your total play amount on individual Scatter prizes, with Hyper Symbols boosting the potential even further.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
}

const PEARL_BOUNTY: GapGameInfo = {
	displayName: 'Pearl Bounty',
	gameType: 'gap',
	standardImageUrl: styles.pearlBountyUniversal,
	featureImageUrl: styles.pearlBountyUniversal,
	gameProviderId: 'vgw',
	gameId: 'pearl-bounty',
	tagLine: 'DIVE IN NOW!',
	infoModal: [
		'243 Winning Ways with Pearl Scatters triggering Hold and Spin bonuses',
		'Three bonuses: Fortune pays prizes, Multiply doubles, Collect gathers wins',
		'Progressive jackpots including MAJOR and GRAND via full board fill or Fortune Pearl',
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
	overlayClockPositionOnDesktop: 'bottom-right',
	overlayClockPositionOnMobile: 'bottom-right',
}

const BUBBLE_CRAPLESS_CRAPS: GapGameInfo = {
	displayName: 'Crapless Bubble Craps',
	gameType: 'gap',
	standardImageUrl: styles.craplessBubbleCrapsUniversal,
	featureImageUrl: styles.craplessBubbleCrapsUniversal,
	gameProviderId: 'iconic21',
	gameId: 'launch_crapless_craps_1',
	tagLine: 'Crapless Bubble Craps',
	infoModal: [
		'Auto-Crapless Craps',
		'Expanded Point numbers from 2 to 12',
		'Low (30:1), Grand (150:1), and High (30:1) streak plays',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	filteredGameType: 'social-live-casino',
}

const TWENTY_STARS_ABLAZE: GapGameInfo = {
	displayName: '20 Stars Ablaze',
	gameType: 'gap',
	standardImageUrl: styles.twentyStarsAblazeUniversal,
	featureImageUrl: styles.twentyStarsAblazeUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_homb1_pop',
	tagLine: 'IGNITE THE REELS!',
	infoModal: [
		'Trigger Hold & Respin on reel 3, locking symbols and resetting respins as new wins land, with Mystery symbols revealing hidden prizes or collectors',
		'Golden Pot Collector gathers all locked coin values during Hold & Re-spin and applies up to 20x multiplier for explosive wins',
		'Fill the grid with Coins and Mystery symbols to unlock the Grand Prize, awarding up to 1,000x plus all accumulated wins'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: false,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const KENO: GapGameInfo = {
	displayName: 'Keno',
	gameType: 'gap',
	standardImageUrl: styles.kenoUniversal,
	featureImageUrl: styles.kenoUniversal,
	gameProviderId: 'Saddle Up Gaming',
	gameId: 'keno',
	tagLine: 'MATCH FOR MORE!',
	infoModal: [
		'Choose 2 to 10 Spots – Tailor every round by selecting your own numbers and preferred level of chance',
		'Clear and Transparent Win Table – Every possible win is displayed upfront, so you always know what you’re playing for',
		'Fast, Single Round Gameplay – Make your picks, watch the draw unfold, and receive instant results in seconds'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
	filteredGameType: 'instant-win',
}

const CASTLE_CASH_10K_WAYS: GapGameInfo = {
	displayName: 'Castle Cash 10K Ways',
	gameType: 'gap',
	standardImageUrl: styles.castleCashWaysUniversal,
	featureImageUrl: styles.castleCashWaysUniversal,
	gameProviderId: 'reelplay',
	gameId: 'castle-cash-10k-ways',
	tagLine: 'FIGHT FOR GLORY, SPIN FOR FORTUNE!',
	infoModal: [
		'Up to 10,000 Ways to Win with explosive cascades that create extra chances to land winning combinations.',
		'Trigger the Bonus Re-spins Feature with 6 or more Scatters and lock symbols in place as you hunt for bigger rewards.',
		'Battle dragons, goblins, and enchanted creatures to uncover prizes, multipliers, and treasure filled bonus action.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
}

const STACKING_KONG: GapGameInfo = {
	displayName: 'Stacking Kong',
	gameType: 'gap',
	standardImageUrl: styles.stackingKongUniversal,
	featureImageUrl: styles.stackingKongUniversal,
	gameProviderId: 'rogue',
	gameId: 'rogue-stackingkong',
	tagLine: 'GET READY TO GO BANANAS!',
	infoModal: [
		'Innovative blockchain powered tower mechanic',
		'Progressive climb system where each level increases rewards up to 1,000x',
		'Persistent gameplay that carries tower progress between rounds'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	filteredGameType: 'instant-win',
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
}

const FLIGHT_OF_DRAGONS_PHOENIX: GapGameInfo = {
	displayName: 'Flight of Dragons: Phoenix',
	gameType: 'gap',
	standardImageUrl: styles.flightOfDragonsPhoenixUniversal,
	featureImageUrl: styles.flightOfDragonsPhoenixUniversal,
	gameProviderId: 'Hot Sauce Studios',
	gameId: 'flight-of-dragons-phoenix',
	tagLine: 'RISE FROM THE FLAMES!',
	infoModal: [
		'4096 ways to win with expanding Wilds and Coin Re-spins',
		'Trigger multiple bonus modes including guaranteed Jackpot Feature wins up to the Grand Jackpot',
		'Free Spins packed with up to 200 Wilds and increasing Coin values for massive win potential'
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnDesktop: 'bottom-left',
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: false,
}

const FAMILY_FEUD: GapGameInfo = {
	displayName: 'Family Feud',
	gameType: 'gap',
	standardImageUrl: styles.familyFeudUniversal,
	featureImageUrl: styles.familyFeudUniversal,
	gameProviderId: 'Rogue',
	gameId: 'rogue-familyfeud',
	tagLine: "LET'S PLAY FAMILY FEUD!",
	infoModal: [
		'Collect Coin Prizes with dual Collector symbols for double rewards and wins up to 5,000x',
		'Choose between multiplier packed Free Spins or the Collection Bonus feature',
		'Answer classic Family Feud style questions to reveal guaranteed jackpot prizes'
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: false,
}

const PROSPERITY_RICHES_LUCKY_SHAKE: GapGameInfo = {
	displayName: 'Prosperity Riches Lucky Shake',
	gameType: 'gap',
	standardImageUrl: styles.prosperityRichesLuckyShakeUniversal,
	featureImageUrl: styles.prosperityRichesLuckyShakeUniversal,
	gameProviderId: 'Saddle Up Gaming',
	gameId: 'prosperity-riches-lucky-shake',
	tagLine: 'SHAKE FOR LUCK!',
	infoModal: [
		'Shake the prosperity tree and uncover exciting rewards hidden within red envelopes',
		'Experience spectacular win moments brought to life with rich animations and effects',
		'Play in seconds with quick rounds and convenient Auto Play functionality'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnDesktop: 'bottom-right',
	overlayClockPositionOnMobile: 'bottom-right',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
	filteredGameType: 'instant-win',
}

const TOIN_OF_GOLD_SCRATCHED: GapGameInfo = {
	displayName: 'Toin of Gold Scratched',
	gameType: 'gap',
	standardImageUrl: styles.toinOfGoldScratchedUniversal,
	featureImageUrl: styles.toinOfGoldScratchedUniversal,
	gameProviderId: 'vgw',
	gameId: 'toin-of-gold-scratched',
	tagLine: 'SCRATCH, MATCH AND STRIKE GOLD!',
	infoModal: [
		'Match 3 identical prize values to win instant rewards.',
		'Win up to 10,000x your selected play amount.',
		'Use Reveal All for fast paced, instant results.',
	],
	filteredGameType: 'scratch-cards',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	overlayClockPositionOnDesktop: 'top-left',
	overlayClockPositionOnMobile: 'top-left',
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: false,
}

const BAO_BAO_PIGGY: GapGameInfo = {
	displayName: 'Bao Bao Piggy',
	gameType: 'gap',
	standardImageUrl: styles.baoBaoPiggyUniversal,
	featureImageUrl: styles.baoBaoPiggyUniversal,
	gameProviderId: 'Saddle Up Gaming',
	gameId: 'bao-bao-piggy',
	tagLine: 'PROSPERITY AWAITS IN EVERY POT!',
	infoModal: [
		'Three Pigs, Three Ways to Win: Collect coloured coins to unlock Lucky Pick, Fortune Wheel and Royal Free Spins, each offering a unique route to rewards.',
		'Massive 2,000x Jackpot: Chase four jackpot tiers, with the Grand Jackpot worth up to 2,000x your total play amount.',
		'Expanding Ways & Random Features: Build from 243 Ways in the base game to up to 3,125 Ways in Royal Free Spins, with the Golden Pig Empress adding surprise coins and scatters.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const STAMPEDE_FURY_3_SUPERCHARGED: GapGameInfo = {
	displayName: 'Stampede Fury 3 Supercharged',
	gameType: 'gap',
	standardImageUrl: styles.stampedeFury3Universal,
	featureImageUrl: styles.stampedeFury3Universal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'stampede-fury-3',
	tagLine: 'FEEL THE FURY!',
	infoModal: [
		'Charge through 10,000 ways to win with cascading reels and dynamic Supercharge features.',
		'Spin interactive feature wheels to trigger Free Spins with upgraded reels.',
		'Trigger the Fireshot Diamond feature for locked prizes and Progressive Jackpots up to GRAND.',
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const CARNIVAL_POWER: GapGameInfo = {
	displayName: 'Carnival Power',
	gameType: 'gap',
	standardImageUrl: styles.carnivalPowerUniversal,
	featureImageUrl: styles.carnivalPowerUniversal,
	gameProviderId: 'Saddle Up Gaming',
	gameId: 'carnival-power',
	tagLine: 'IT PACKS A PUNCH!',
	infoModal: [
		'Punch the boxing meter to test your strength and light up instant wins.',
		'Hit the BONUS threshold to trigger the high-stakes Clown Dunk Wheel.',
		'Spin up to 3 times to accumulate win multipliers or play it all on another spin.',
	],
	filteredGameType: 'instant-win',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: false,
}

const HARVEST_HAPPINESS: GapGameInfo = {
	displayName: 'Harvest Happiness',
	gameType: 'gap',
	standardImageUrl: styles.harvestHappinessUniversal,
	featureImageUrl: styles.harvestHappinessUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'harvest-happiness',
	tagLine: 'HARVEST THE FUN!',
	infoModal: [
		'Sticky Wild Free Spins: Triggering Scatters transform into Sticky Wilds and stay locked throughout the feature.',
		'More Wilds, More Spins: Additional Wilds can lock in place and award an extra Free Spin.',
		'Seasonal Fun: Cheerful fall-themed gameplay with 10 win lines and a low minimum play.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

// NOTE: jackpot config (GRAND) pending product confirmation before enabling in pok-admin
const BRIDE_OF_FRANKENLINK: GapGameInfo = {
	displayName: 'MonsterOrbs Bride of Frankenlink',
	gameType: 'gap',
	standardImageUrl: styles.brideOfFrankenlinkUniversal,
	featureImageUrl: styles.brideOfFrankenlinkUniversal,
	gameProviderId: 'Hot Sauce Studios',
	gameId: 'bride-of-frankenlink',
	tagLine: 'FRIGHTENINGLY GOOD!',
	infoModal: [
		"Trigger the Bride's Love feature to spread random Wilds across the reels.",
		'Unlock locked rows in the MonsterOrbs feature with Hold-N-Spin action.',
		'Turn on Boost Mode for increased feature triggers and up to 10x Orb multipliers.',
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const BEAR_BUZZ: GapGameInfo = {
	displayName: 'Bear Buzz',
	gameType: 'gap',
	standardImageUrl: styles.bearBuzzUniversal,
	featureImageUrl: styles.bearBuzzUniversal,
	gameProviderId: 'playtech',
	gameId: 'gpas_bbuzza1_pop',
	tagLine: 'JOIN THE BUZZ AND COLLECT SWEET REWARDS!',
	infoModal: [
		'Land the Wild Bear in the Hot Zone to lock and collect Coin Prizes with up to 10x multipliers.',
		'Trigger Bear Buzz Re-spins to reset your spins and chase the massive 5,000x Grand Prize.',
		'Uncover the Golden Hive to match jar symbols and win up to 500x Special Prizes.'
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: false,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const CRAZY_TIME: GapGameInfo = {
	displayName: 'Crazy Time',
	gameType: 'gap',
	standardImageUrl: styles.evoCrazyTimeUniversal,
	featureImageUrl: styles.evoCrazyTimeUniversal,
	gameProviderId: 'evolution',
	gameId: 'CrazyTime0000002',
	tagLine: 'Crazy Time',
	infoModal: [
		'Four unique bonus games (Cash Hunt, Pachinko, Coin Flip, and Crazy Time)',
		'Top Slot multiplier generation up to 50x before each main spin',
		'Massive, interactive 54-segment money wheel live show',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: false,
	filteredGameType: 'social-live-casino',
}

const CRAPS: GapGameInfo = {
	displayName: 'Craps',
	gameType: 'gap',
	standardImageUrl: styles.evoCrapsUniversal,
	featureImageUrl: styles.evoCrapsUniversal,
	gameProviderId: 'evolution',
	gameId: 'Craps00000000001',
	tagLine: 'Craps',
	infoModal: [
		'Authentic underground 1920s speakeasy studio setting',
		'Specially engineered mechanical arm for truly random dice throws',
		'Intuitive "My Numbers" tracker panel for simplified play monitoring',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: false,
	filteredGameType: 'social-live-casino',
}

const MONOPOLY_BIG_BALLER: GapGameInfo = {
	displayName: 'Monopoly Big Baller',
	gameType: 'gap',
	standardImageUrl: styles.evoMonopolyBigBallerUniversal,
	featureImageUrl: styles.evoMonopolyBigBallerUniversal,
	gameProviderId: 'evolution',
	gameId: 'MonBigBaller0001',
	tagLine: 'Monopoly Big Baller',
	infoModal: [
		'Action-packed, live bingo-style drawing with 20 balls',
		'Chance and Free Space cards featuring line multipliers up to 199x',
		'Immersive 3D Monopoly board bonus game triggered by 3 Rolls and 5 Rolls cards',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: false,
	filteredGameType: 'social-live-casino',
}

const RED_DOOR_ROULETTE: GapGameInfo = {
	displayName: 'Red Door Roulette',
	gameType: 'gap',
	standardImageUrl: styles.evoRedDoorRouletteUniversal,
	featureImageUrl: styles.evoRedDoorRouletteUniversal,
	gameProviderId: 'evolution',
	gameId: 'RedDoorRoulette1',
	tagLine: 'Red Door Roulette',
	infoModal: [
		'Traditional European Roulette with the iconic Crazy Time bonus',
		'Initial slots round assigns keys to up to 15 numbers every spin',
		'Land on a key to open the Red Door and enter in the Crazy Time wheel',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: false,
	filteredGameType: 'social-live-casino',
}

const FUNKY_TIME: GapGameInfo = {
	displayName: 'Funky Time',
	gameType: 'gap',
	standardImageUrl: styles.evoFunkyTimeUniversal,
	featureImageUrl: styles.evoFunkyTimeUniversal,
	gameProviderId: 'evolution',
	gameId: 'FunkyTime0000001',
	tagLine: 'Funky Time',
	infoModal: [
		'Dynamic 64-segment LED Digital Wheel technology with random multipliers',
		'24 distinct letter segments',
		"Four 1970s disco-themed bonus rounds: Bar, Stayin' Alive, Disco, and VIP Disco",
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: false,
	filteredGameType: 'social-live-casino',
}

const ICE_FISHING: GapGameInfo = {
	displayName: 'Ice Fishing',
	gameType: 'gap',
	standardImageUrl: styles.evoIceFishingUniversal,
	featureImageUrl: styles.evoIceFishingUniversal,
	gameProviderId: 'evolution',
	gameId: 'IceFishing000001',
	tagLine: 'Ice Fishing',
	infoModal: [
		'Arcade-style instant multiplier instant win mechanic',
		'Catch progression meter for unlocking bonus tier prizes',
		'Wheel RNG Game Show',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: false,
	filteredGameType: 'social-live-casino',
}

const GOLDEN_WEALTH_BACCARAT: GapGameInfo = {
	displayName: 'Golden Wealth Baccarat',
	gameType: 'gap',
	standardImageUrl: styles.evoGoldenWealthBaccaratUniversal,
	featureImageUrl: styles.evoGoldenWealthBaccaratUniversal,
	gameProviderId: 'evolution',
	gameId: 'gwbaccarat000001',
	tagLine: 'Golden Wealth Baccarat',
	infoModal: [
		'Five virtual Golden Cards drawn from a magical pot every round',
		'Random multipliers of 2x, 3x, 5x, or 8x assigned to selected cards',
		'Accumulative card multipliers for potential massive prizes on Tie plays',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: false,
	filteredGameType: 'social-live-casino',
}

const LIGHTNING_ROULETTE: GapGameInfo = {
	displayName: 'Lightning Roulette',
	gameType: 'gap',
	standardImageUrl: styles.evoLightningRouletteUniversal,
	featureImageUrl: styles.evoLightningRouletteUniversal,
	gameProviderId: 'evolution',
	gameId: 'LightningTable01',
	tagLine: 'Lightning Roulette',
	infoModal: [
		'Classic European Roulette rules with a live host',
		'Between 1 and 5 Lucky Numbers struck by lightning every round',
		'RNG-powered prize multipliers ranging from 50x to 500x on straight-up plays',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: false,
	filteredGameType: 'social-live-casino',
}

const CRAZY_COIN_FLIP: GapGameInfo = {
	displayName: 'Crazy Coin Flip',
	gameType: 'gap',
	standardImageUrl: styles.evoCrazyCoinFlipUniversal,
	featureImageUrl: styles.evoCrazyCoinFlipUniversal,
	gameProviderId: 'evolution',
	gameId: 'CrazyCoinFlip001',
	tagLine: 'Crazy Coin Flip',
	infoModal: [
		'Unique hybrid game featuring three phases: Qualification, Top Up, and Live Coin Flip',
		'Spin the RNG slot to collect three Scatters and accumulate initial multipliers',
		'Join to the iconic Coin Flip live studio',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: false,
	filteredGameType: 'social-live-casino',
}

const MEGA_BALL: GapGameInfo = {
	displayName: 'Mega Ball',
	gameType: 'gap',
	standardImageUrl: styles.evoMegaBallUniversal,
	featureImageUrl: styles.evoMegaBallUniversal,
	gameProviderId: 'evolution',
	gameId: 'MegaBall00000001',
	tagLine: 'Mega Ball',
	infoModal: [
		'Play with up to 200 bingo-style cards on a 5x5 grid per round',
		'Ball-drawing machine rapidly selects 20 numbered balls out of 51',
		'A final Mega Ball generates a random multiplier from 5x to 100x to boost winning lines',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: false,
	moveMuteButtonLeftOnMobile: false,
	filteredGameType: 'social-live-casino',
}

const SPICY_SUPREME: GapGameInfo = {
	displayName: 'Spicy Supreme',
	gameType: 'gap',
	standardImageUrl: styles.spicySupremeUniversal,
	featureImageUrl: styles.spicySupremeUniversal,
	gameProviderId: 'Saddle Up Gaming',
	gameId: 'spicy-supreme',
	tagLine: '¡AY, CARAMBA!',
	infoModal: [
		'Collect firey peppers to trigger 3 unique Hold & Spin bonus modes.',
		'Spin the Super Wheel for instant prizes and Progressive Jackpots up to GRAND.',
		'Enable Boost Mode to double your chances of unlocking top features and jackpots.',
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const HAPPILY_EVER_AFTER: GapGameInfo = {
	displayName: 'Happily Ever After - Once Upon a Multiplier',
	gameType: 'gap',
	standardImageUrl: styles.happilyEverAfterUniversal,
	featureImageUrl: styles.happilyEverAfterUniversal,
	gameProviderId: 'Rogue',
	gameId: 'rogue-happilyeverafter-deluxe',
	tagLine: 'A FAIRY TALE OF MAGIC WINS!',
	infoModal: [
		'Five Fairytale Bonus Adventures; Follow the Happy Ending Trail to unlock one of five unique bonus games, each inspired by a beloved fairytale character.',
		'Magical Multipliers Up to x25; Discover multipliers throughout the game, with Bonus Frenzy increasing opportunities and boosting potential multipliers up to x25.',
		'Happy Ending Trail; Positive and negative symbol values move you along the trail, creating anticipation as you journey towards magical books and exciting bonus rewards.',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: false,
}

const AIRSPEED_JACKPOTS: GapGameInfo = {
	displayName: '23xi Racing Airspeed Jackpots',
	gameType: 'gap',
	standardImageUrl: styles.airspeedJackpotsUniversal,
	featureImageUrl: styles.airspeedJackpotsUniversal,
	gameProviderId: 'ggames',
	gameId: 'AIRSPEED_JACKPOTS',
	tagLine: 'RACE TO THE TOP!',
	infoModal: [
		'Race-Fuelled Fun; A fast-paced, easy-to-follow slot with a 23XI Racing theme that puts you right in the action.',
		'Two Ways to Push Your Luck; Hit Airspeed Spins for 8 boosted free spins, or race into Drift & Win for a shot at the 5,000x top prize.',
		'Chase the Podium; Collect Scatters, climb through the race positions and fill all 15 spots to take the ultimate victory.',
	],
	overlayClockDesktop: false,
	overlayClockMobile: false,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: false,
}

const SCARLET_INFERNO: GapGameInfo = {
	displayName: 'Scarlet Inferno',
	gameType: 'gap',
	standardImageUrl: styles.scarletInfernoUniversal,
	featureImageUrl: styles.scarletInfernoUniversal,
	gameProviderId: 'Saddle Up Gaming',
	gameId: 'scarlet-inferno',
	tagLine: 'EMBRACE THE FLAMES!',
	infoModal: [
		'Up to 10,000x Win; Chase the Grand Jackpot worth an incredible 10,000x your play amount.',
		'Inferno Hold & Spin; Lock Fireballs, reset the re-spins with every new Fireball, and fill all 15 positions to instantly claim the Grand Jackpot.',
		'Flaming Free Spins; 3+ Scatters award 6 Free Spins, with oversized 3x3 symbols on Reels 2–4 for bigger win potential.',
	],
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const THE_WONDERS_OF_CAISHEN: GapGameInfo = {
	displayName: 'The Wonders of Caishen',
	gameType: 'gap',
	standardImageUrl: styles.theWondersOfCaishenUniversal,
	featureImageUrl: styles.theWondersOfCaishenUniversal,
	gameProviderId: 'Golden Feather Studios',
	gameId: 'the-wonders-of-caishen',
	tagLine: 'MAY FORTUNE SHINE UPON YOU!',
	infoModal: [
		'243 Ways to Win with a Pick Bonus triggered by 3 Scatters, awarding Free Spins, an Instant Coin prize, or Hold & Spin.',
		'Two Progressive Jackpots: Major and Grand, with the Grand shared across The Golden Cheese jackpot pool.',
		'Hold & Spin Feature: Collect prize coins, jackpots and boosting Caishen coins across 3 respins, with all positions filled awarding the Grand Jackpot.',
	],
	hasJackpot: true,
	useGapJackpot: true,
	jackpotToDisplay: 'grand',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: false,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: true,
	moveCloseButtonLeftOnMobile: true,
	showMuteButtonOverlay: true,
	moveMuteButtonLeftOnDesktop: true,
	moveMuteButtonLeftOnMobile: true,
}

const GOLD_RUNNER: GapGameInfo = {
	displayName: 'Gold Runner',
	gameType: 'gap',
	standardImageUrl: styles.goldRunnerUniversal,
	featureImageUrl: styles.goldRunnerUniversal,
	gameProviderId: 'Rogue',
	gameId: 'rogue-goldrunner-95',
	tagLine: 'TAKE THE TRAIL TO TREASURE!',
	infoModal: [
		'A unique Treasure Trail every time;  Follow your own ever-changing path through a fresh grid of prizes, collecting gems, coins and diamonds while dodging the dangers ahead.',
		'Power up your adventure; Collect gems to unlock increasingly valuable power-ups, giving you Extra Lives, boosted Coins and the ability to collect prizes beyond your chosen path.',
		'Chase bigger rewards; Trigger the Bonus Pot with a Diamond and unlock exciting bonus games, including the Treasure Room, where you can uncover the potential for a Guaranteed Jackpot.',
	],
	filteredGameType: 'instant-win',
	overlayClockDesktop: true,
	overlayClockMobile: true,
	hasInsufficientCoinDialogAvailableInGame: true,
	onlyUpdateBalanceOnGameRoundCompleted: false,
	moveCloseButtonLeftOnDesktop: false,
	moveCloseButtonLeftOnMobile: false,
	showMuteButtonOverlay: false,
}

export const CASINO_GAME_INFO: {
	[key: string]: CasinoGameInfo;
} = {
	SUPER_DAZZLING_7S,
	HYPERNOVA,
	WESTERN_GOLD,
	LUCKY_SHOW,
	CRUSADERS_GOLD,
	TRIPLE_DOUBLE_GOLDEN_STARS,
	BIG_GOREELA,
	SANTAS_RICHES,
	LIGHTNING_NUDGE,
	BLACKJACK_PREMIUM,
	BLACKJACK_PREMIUM_GAP,
	BLACKJACK_CLASSIC,
	BLACKJACK_CLASSIC_GAP,
	DUSKMOON_FAIRE_JACKPOT_EDITION,
	HALLOWS_WILDS,
	SUPER_HOT_SEVENS,
	TRIPLE_DOUBLE_GOLDEN_EAGLES,
	DRAGONS_RIVER,
	CARIBBEAN_POKER,
	CARIBBEAN_POKER_GAP,
	DIAMOND_PANTHER,
	CASINO_HOLDEM,
	TRIPLE_DOUBLE_FEVER,
	WILD_ROADS,
	LAST_EMPRESS,
	ATLANTIS_10K,
	RING_MASTER,
	WOLF_GOLD,
	BIG_BASS_BONANZA,
	GRIZZLY_REELS,
	CHILLI_HEAT,
	JOHN_HUNTER,
	GATES_OF_OLYMPUS,
	SWEET_BONANZA,
	SLINGO_XXXTREME,
	THE_DOG_HOUSE,
	MADAME_DESTINY,
	SUGAR_RUSH,
	GREAT_RHINO,
	CHEEKY_FRUITS_DELUXE,
	BIG_BASS_SPLASH,
	MILLION_BOOK,
	FIRE_STRIKE_2,
	STARBURST,
	QUEENIE,
	FORTUNE_SCRATCH,
	THE_LINK_SCRATCH,
	PHARAOHS_TREASURE,
	DIAMONDS_SCRATCH,
	TOUCH_DOWN,
	FIVE_LIONS_GOLD,
	AMERICASH,
	THREE_DANCING_MONKEYS,
	CLOVER_GOLD,
	RED_HOT_SLINGO,
	CASINO_SOLITAIRE,
	FOUR_FANTASTIC_FISH,
	ELITE_OF_EVIL,
	SEVEN_UP,
	FRUIT_PUNCH_UP,
	DIAMOND_DEAL,
	LUCKY_NUMBERS,
	TWIN_SPIN_MEGAWAYS,
	BLUE_WIZARD,
	KHONSU_GOD_OF_MOON,
	TWO_FIFTY_K_DELUXE,
	BUFFALO_BLITZ,
	QUEST_WEST,
	TSAI_SHENS_GIFT,
	BIG_CIRCUS,
	TUNDRA_WOLF,
	WILD_LINX,
	DRAGON_TRIO_BONUS,
	SHARK_FRENZY,
	THREE_SAMURAI,
	THUNDER_WHEEL,
	FRUIT_SMASH,
	SANDS_OF_ETERNITY,
	STAR_SPELL,
	SPACE_MINERS,
	CLUSTER_TUMBLE,
	MONEY_TRAIN,
	TNT_TUMBLE,
	TEMPLAR_TUMBLE,
	IRON_BANK,
	NINE_FLAGS,
	NINEK_YETI,
	OINK_OINK_OINK,
	HERCULES_10K,
	SLINGO_LIGHTNING,
	VOLATILE_VIKINGS,
	MONEY_TRAIN_2,
	MONEY_TRAIN_3,
	THE_GREAT_PIGSBY,
	SNAKE_ARENA,
	BETTER_WILDS,
	LETS_GET_READY_TO_RUMBLE,
	MOON_OF_THOTH,
	ZOMBIE_CIRCUS,
	BANANA_TOWN,
	TITAN_STRIKE,
	SANTAS_STACK,
	FOUR_FANTASTIC_FISH_GOLD,
	SULTAN_SPINS,
	TSAI_SHEN_10K,
	ADVENTURE_TRAIL,
	LIL_DEMON_GOLD_HIT,
	THREE_WIZARDS,
	GOLD_TRIO,
	CHEERS,
	GODDESS_OF_THE_SEA,
	JP_BACON_AND_CO_GOLD_HIT_AND_LINK,
	SLINGO_SUPER_SPIN,
	CASINO_WIZARD_CRAPS,
	CASINO_CRAPS_2025,
	BUCKS_AND_DOE,
	PROFESSORS_CLANKS_COMBINATOR,
	MONEY_MARIACHI_INFINITY_REELS,
	SHRINE_OF_ANUBIS_GOLD_HIT,
	FIRE_BLAZE_QUATTRO_CELTIC_CHARM,
	THOR_10K_WAYS,
	THOR_INFINITY_REELS,
	JOHN_WAYNE_10K_WAYS,
	MACABRA_LINX,
	KENO_POP,
	MEGA_MONEY_MACHINE,
	BIG_BUCKS_BISON_10K_WAYS,
	FRUIT_COMBINATOR,
	WEST_COAST_CASH_INFINITY_REELS,
	BINGO_75,
	CALAVERA_BINGO,
	SEASONS_JOY,
	ROCKY_HORROR_SHOW,
	RED_WIZARD,
	FESTIVAL_10K_WAYS,
	GEMS_INFINITY_REELS,
	STAR_TREK_THE_NEXT_GENERATION,
	FOUR_FANTASTIC_LOBSTERS,
	PIN_RUSH,
	MEGA_FIRE_BLAZE_DWARVES_AND_GOBLINS,
	TOIN_OF_GOLD,
	HIT_BAR_GOLD,
	THE_GREAT_GENIE,
	PROSPERITY_RICHES,
	REELIN_N_ROCKIN_GAP,
	STAMPEDE_FURY_GAP,
	DOUBLE_DIGGER,
	SLINGO_GOLDEN_ENVELOPE,
	TEN_THOUSAND_BASS_LIGHTNING_BLITZ,
	JUICE_TRIO_BONUS,
	GOLD_HIT_OREILLYS_CHARMS,
	RAGING_RICHES,
	GOLDEN_DATE,
	FLUFFY_FAVOURITES,
	SPINGOTTS,
	MERLINS_10K_WAYS,
	BUFFALO_BLITZ_2,
	PYRAMID_LINX,
	TWENTYFOURK_GOLD_TIGER,
	GOOOD_HEAVENS,
	PAY_PIG,
	LUCKY_CAT_FORTUNES,
	ALOHAWAII_COLLECT_EM,
	PIGGIES_AND_THE_BANK_MEGA_FIRE_BLAZE,
	NINE_FLAGS_PATRIOT_PARTY,
	LUCKY_LAND_7S,
	CONNECT_4_BONANZA,
	AZTEC_LIGHTNING_BLITZ,
	GOLD_TRIO_LEPRECHAUNS_LUCK,
	LIL_SPHINX,
	DEAL_OR_NO_DEAL,
	GPAS_AZTECWFBUS_POP,
	KINGARTHUR10KWAYS,
	CANDYLAND,
	FIRE_BLAZE_GREEN_WIZARD,
	BLITZ_OF_OLYMPUS_TRIO_MAX,
	BEEHIVE_BLITZ,
	BFBL_GLOBALPOKERSLOTS,
	BUFFALO_BLITZ_LIVE_SLOT,
	SWLE_GLOBALPOKERSAW,
	BAL_GLOBALPOKERBAC,
	ABWL_WONDERLAND,
	ROL_GLOBALPOKERROL2,
	ABJL_GLOBALPOKERBJ2,
	LEGACY_OF_THE_TIGER_MEGA_FIRE_BLAZE,
	MEGA_WINVASION,
	SFL_SAKURASLOTS,
	PRSTL_BUSTEDORBAILED,
	CHEL_GLOBALPOKERCASINOHOLDEM,
	ROL_QUANTUMROULETTE,
	FBBL_LUCKYBALL,
	STAMPEDEFURY2,
	MUMMYMAYHEM2,
	GOBLIN_GRAND,
	BACON_BLING,
	GPAS_FFIGHTER_POP,
	FREAKY_13,
	GHOST_FACE_LIVES,
	IMPERIAL_KOI,
	NC_BAL_GLOBALPOKERBAC,
	BJL_GLOBALPOKERBJ1,
	BJL_GLOBALPOKERBJ2,
	BJL_GLOBALPOKERBJ3,
	BJL_GLOBALPOKERBJ4,
	BJL_GLOBALPOKERBJ5,
	GOLDEN_ACE,
	KITTY_PUZZLE,
	SPINLOTTO_SCRATCH,
	DIAMOND_DIGGER,
	EPIC_GEMS,
	SPINLOTTO,
	THORS_EGG_HUNT,
	ONE_HUNDRED_CASH,
	VEGAS_SOLITAIRE,
	DANCING_GOLD,
	THE_STALLION,
	REALLY_REELY_RICH,
	ROARING_STRIKE,
	VIVA_FROST_VEGAS,
	FROST_VEGAS,
	BLACK_TIDE_FORTUNES,
	THE_GOLDEN_CHEESE,
	DRUM_FESTIVAL,
	TROPHY_CATCH,
	STAR_CATCH_JACKPOTS,
	QUEST_3_LAMPS,
	FU_QIAN_QIAN,
	FASHION_TV_MEGA_PARTY,
	LIVE_ROULETTE,
	AMERICAN_ROULETTE,
	MONSTER_ORBS_FRANKEN_LINK,
	SANTAS_TREE_OF_TREETS,
	FROGS_FEAST_FORTUNES,
	SPARTACUS_10K_WAYS,
	ARCTIC_TITAN,
	GEM_HUNTRESS_2,
	QUANTAM_BLACKJACK,
	X1000_QUANTUM_ROULETTE,
	GPAS_SSAMMCTUS_POP,
	JELLY_JILLIONS,
	TEN_THOUSAND_WOLVES_10K_WAYS,
	GOLD_IS_ALL_MINE,
	GPAS_LEMERALDS_POP,
	GPAS_BOKING_POP,
	GPAS_EAPE_POP,
	GPAS_AWILD2_POP,
	GPAS_HFORTUNE_POP,
	GPAS_PPPEARLS_POP,
	GPAS_WPISTO_POP,
	GPAS_WPUNCH_POP,
	GPAS_AFACTORY_POP,
	GPAS_SQUEEN_POP,
	GPAS_AZBOLI_POP,
	GPAS_GOLDHIT3_POP,
	GPAS_QCTOBLO_POP,
	GPAS_SSTRIKE_POP,
	GPAS_CXTREME_POP,
	GPAS_WOFIRE1_POP,
	TENTHOUSANDLIONS10KWAYS,
	QUEEN_OF_THE_PYRAMIDS_MEGA_COLLECT_EM,
	JAWSOME_JACKPOTS,
	QBAL_QUANTUMBAC,
	BC_SLOTS,
	INSTANT_KENO,
	ZEN_TREE_TREASURES,
	LEGEND_OF_MEDUSA,
	PIGS_N_POTS,
	MUSTANG_ACE,
	SACRED_CHILIS,
	KABUKI_10k,
	FIRE_BLAZE_ETERNAL_LADY,
	GRAVITY_WHEEL,
	GRAND_BONUS_BACCARAT,
	GRAND_BONUS_BLACKJACK,
	LIVE_ROULETTE_I21,
	SPIN_A_WIN,
	THIRD_TIMES_A_CHARM,
	TWISTER_MANIA,
	CRASH_LIVE,
	FIRE_BLAZE_GOLDEN_BUCCANEERS_BELLS,
	CHUBBY_CHICKS_JACKPOTS,
	GOLD_OVERLOAD,
	GRAVITY_ROULETTE,
	SIC_BO_DELUXE,
	ASTRO_DOGFIGHT,
	KING_CROC_FURY,
	GRAVITY_BLACKJACK,
	LOAD_EM_UP,
	PRIZE_PINATA,
	DRAGON_TIGER,
	BASS_10K_WAYS,
	THE_RACAROON,
	WONDERLAND_LUCKYBALL,
	AUTO_ROULETTE,
	BIG_ZERO_ROULETTE,
	CHEEKY_FRUITS_TRIO_BONUS,
	THE_KICKOFF,
	EAGLE_EMPIRE,
	PIZZA_BOSS,
	GOLD_TRIO_SOCCER,
	PSYCHO_CANDIES,
	TOP_CARD,
	BERSERKER_BUCKS,
	ROYAL_ROULETTE,
	SUSHI_SPARKLE,
	SIC_BO,
	NINE_FLAGS_PLINKO,
	MOW_MONEY,
	GRAVITY_SIC_BO,
	ROULETTE_LITE,
	DIGGER_DIGGER_GOLDEN_WINNER,
	THREE_WONDERS_PHOENIX,
	GRAVITY_AUTO_ROULETTE,
	PAY_PIG_10K_WAYS,
	VIDEO_POKER,
	TEEN_PATTI,
	MAGMA_MOOLAH,
	BUBBLE_CRAPS,
	HYPER_RESPINS,
	NINE_FLAGS_ROUTE_TO_GLORY,
	PEARL_BOUNTY,
	BUBBLE_CRAPLESS_CRAPS,
	TWENTY_STARS_ABLAZE,
	KENO,
	CASTLE_CASH_10K_WAYS,
	STACKING_KONG,
	FLIGHT_OF_DRAGONS_PHOENIX,
	FAMILY_FEUD,
	PROSPERITY_RICHES_LUCKY_SHAKE,
	TOIN_OF_GOLD_SCRATCHED,
	BAO_BAO_PIGGY,
	STAMPEDE_FURY_3_SUPERCHARGED,
	CARNIVAL_POWER,
	HARVEST_HAPPINESS,
	BRIDE_OF_FRANKENLINK,
	BEAR_BUZZ,
	CRAZY_TIME,
	CRAPS,
	MONOPOLY_BIG_BALLER,
	RED_DOOR_ROULETTE,
	FUNKY_TIME,
	ICE_FISHING,
	GOLDEN_WEALTH_BACCARAT,
	LIGHTNING_ROULETTE,
	CRAZY_COIN_FLIP,
	MEGA_BALL,
	SPICY_SUPREME,
	SCARLET_INFERNO,
	AIRSPEED_JACKPOTS,
	HAPPILY_EVER_AFTER,
	THE_WONDERS_OF_CAISHEN,
	GOLD_RUNNER,
}

export function getStaticCasinoGameInfoById(gameId: string, provider: string = null): CasinoGameInfo {
	const games = CASINO_GAME_INFO
	const gameInfo = Object.values(games).filter(c => c.gameId === gameId || c.providerGameId === gameId)
	if (gameInfo.length > 1 && provider !== null) {
		return gameInfo.find(c => c.gameType === provider.toLowerCase())
	}
	return gameInfo[0]
}

export function getAvailableReplacementGameInfo(gameId: string, availableGameIds: string[]): CasinoGameInfo | undefined {
	return Object.values(CASINO_GAME_INFO)
		.find(game => game.replacesGameId === gameId && availableGameIds.includes(game.gameId))
}
